import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React$1 from 'react';
import React__default, { createContext, useContext, useState, useCallback, useRef, Component, forwardRef, useMemo, useEffect, Children } from 'react';
import styled, { useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';

const asRem = (pxValue) => {
    const baseFontSize = 16;
    const remValue = pxValue / baseFontSize;
    return `${remValue}rem`;
};

const createUniqKey = () => {
    const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

const AccordionStyle = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
`;
const AccordionItemStyle = styled.div `
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  border-radius: ${asRem(6)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.one)};
`;
const AccordionHeaderStyle = styled.div `
  display: inline-flex;
  flex-direction: row;
  cursor: pointer;

  align-items: center;
  width: 100%;
  padding: ${({ theme }) => asRem(theme.spacing.two)};
  padding-right: ${({ theme }) => asRem(theme.spacing.default)};
  border-radius: ${asRem(6)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)};
    padding-right: ${({ theme }) => asRem(theme.spacing.one)};
  }

  .icon {
    margin-top: ${asRem(-2)};
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
  }

  p,
  h5,
  h4,
  h3 {
    fontsize: ${asRem(16)};
    margin-bottom: 0 !important;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      fontsize: ${asRem(18)};
    }
  }
`;
const AccordionBodyStyle = styled.div `
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => asRem(theme.spacing.two)};
  padding-top: 0;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  border-bottom-left-radius: ${asRem(6)};
  border-bottom-right-radius: ${asRem(6)};
  padding-right: ${({ theme }) => asRem(theme.spacing.six)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)};
    padding-top: 0;
    padding-right: ${({ theme }) => asRem(theme.spacing.nine)};
  }

  strong {
    font-family: poppins-semibold;
  }
`;

var IconStyle = styled.i `
  aspect-ratio: 1/1;
  height: ${({ sm }) => asRem(sm)};
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: ${({ md }) => asRem(md)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    height: ${({ lg }) => asRem(lg)};
  }

  &:hover svg path,
  &:hover ~ svg path {
    fill: ${(props) => props.hoverColor};
    transition: fill 0.3s ease;
  }
`;

const CheckmarkIcon = ({ primaryColor, secondaryColor }) => (jsx("svg", { enableBackground: "new 0 0 40 40", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", children: jsxs("g", { transform: "translate(8.923914 11.25088)", children: [jsx("path", { d: "m10.3 17.6c.1-.1 0 0 0 0m-12.8-7.7c-.2 0-.2-.1-.2-.2zm28.2-8.5c.1-.2.1-.3.3-.4l.4.2c.2-.3.2-.6.2-.9-.1-.3-.2-.6-.4-.9 0 .1 0 .2.1.2-.2 0-.3-.4-.5-.5.1-.1.1-.2 0-.4 0 0-.2-.1-.3-.1-.2-.1-.4-.1-.5 0-.1-.1-.2-.2-.3-.3-.4-.1-.6 0-.8.1s-.3.2-.6.3c.1-.2-.2-.2.2-.4-.2.1-.4.1-.4.2-.1 0-.2.1-.3.2-.2.2-.3.3-.4.3 0 .1.1.2 0 .3h-.1c.1 0-.1.2.1.2-.7.1-.8.9-1.4 1-.2.3-.4.6-.6.8 0 0-.1 0 0-.1-.4.2.2.4-.2.7-.4 0 .1-.2-.1-.2-.5-.2.1 0-.2.3 0 0 0 0-.1 0 0 .3-.2.7-.4 1-.1-.2 0-.2-.2-.2-.1.1.3.1.1.4-.2 0-.4.1-.6 0l.2-.2c-.3 0-.3.3-.4.4l-.1-.1c-.3.4 0 .5-.4.9h.1c.1.4-.3.1-.3.4l-.3-.1c-.1.2-.2.6-.4.9-.1-.3.1-.6.2-.9-.1.1-.4.5-.3.6v-.1c0 .3-.1.6-.3.8-.4-.4-.8.6-1.3.5-.3.7-.9.9-1.4 1.5.6.1-.1.2.3.4-.1.1-.1.2-.2.2l-.6.2c-.2 0 0-.2-.1-.2-.3.3-.3 0-.6.1.2.1.2.2 0 .4l.4-.1c-.2.5-.6.1-.8.6v-.2c-.1.2-.7.7-.6 1.1-.1 0-.2 0-.2-.1-.5.4-.7 1.3-1.2 1.5l-.1-.1c-.1.1 0 .3-.2.3 0 0-.1-.1-.1-.1 0 .1-.1.3-.2.4v-.2c-.6.4-.4.9-.7 1.3-.3-.2-.7.1-.9.3-.2.3-.3.4-.4.5s0 .1 0 .1v.1c0 .1 0 .3-.1.5 0 0 0-.1-.1-.1v-.2c0-.1-.1-.1-.1-.2 0 0-.1-.1-.1-.1l-.1-.1c0-.1-.1-.2-.1-.2 0 .1-.3.1-.4.1 0-.2-.5-.2-.2-.4.2-.3-.1-.5-.3-.7l-.3.3c.1-.8-1.4-1.2-1.1-1.8-.2-.1-.3-.2-.5-.3l.1-.1c-.3-.4-.4-.6-.8-.9h.2c-.2-.2-.8 0-1-.2l.2-.2c-.4-.4-.5-1-1.1-1.2 0 0 .1-.1.2 0-.1-.3-.4-.9-.7-.6.1-.1 0-.2-.1-.3-.2-.1-.5-.3-.7-.4.1 0 .1-.1.2-.1-.3 0-.4 0-.5 0-.2 0-.3-.1-.6-.1-.1-.1 0-.2.1-.1-.2-.1-.3-.1-.4 0-.1 0-.2.1-.4 0 .1 0 .1-.1.2-.1-.4 0-.4.1-.6.2s-.7.2-.9.1c0 .1-.1.3-.2.4-.1 0-.1-.1 0-.1-.4.1-.5.4-.5.6s0 .4-.2.6c-.1 0-.1 0-.1.1 0-.5.3-.9.3-.8-.2-.1-.4.3-.5-.1 0 .2 0 .5.1.7.1.3.1.5.2.7 0 0 0 0-.1.1 0 .1.1.2.1.3s.1.2.1.3c-.1-.1 0 .1 0 .1.1.1.2.2.2.2.2-.1.3 0 .3-.2 0 0 0 0-.1-.1 0 0 0 0-.1 0l-.1-.1s-.1-.1-.2-.2c.1 0 .2.1.3.1s.1.1.1.2h.4c-.1.3 0 .7-.1.8.4.3.8.8 1.3.8.1.1 0 .2 0 .2-.1 0-.1-.1-.2-.1.3.1.6.6.8.5.1.3-.3 0 0 .3h-.1c.2.9 1.6.7 1.8 1.8 0-.1 0-.1 0-.1.5 1 1.8 1.6 2.2 2.7.1.3.3.2.6.3l-.1.1.4.1c.5.2.1.9.8 1.2l.1-.1c.1.2.5.5.4.5 0 0 .2 0 .2.1h-.2l.3.1c.1.1.2.1.3.2.2.2.1.2 0 .3s-.1.2.4.4h.6c.2-.1.3-.2.2-.2s-.3-.1-.3-.2h.2s0 0 0-.1c.5 0 1-.2 1.3-.5l.7-.8v-.1l.4-.1v.1c.3-.1 0-.2.3-.3l.1-.2c0 .1.2.1.1.2.4-.2.2-.6.5-.6.2-.3 0-.3-.1-.4l.2-.2.5.1-.2-.2s.1-.1.2 0c0-.2-.1 0-.2-.2.4-.1.4-.6.8-.4-.1-.2-.3.1-.2-.2.4.2.2-.3.5-.4.1.2-.1.3.2.2-.2-.3.4-.3.5-.5-.2-.2.2-.4.4-.7.1.1.6-.4.9-.6-.2-.2.1-.4.2-.6.1.1.2.2.1.3l.2-.2c0-.1 0-.2 0-.3l.1.2c.2-.2.2-.6.6-.8-.1-.1-.4-.1-.5-.2l.1-.2s.1.1.1.1 0-.1.1-.2v.2c.2-.1-.1-.2.1-.2.1.1.2 0 .2.1 0 0-.1.1-.1.1.1-.1.3-.2.5-.2-.1 0-.2-.1-.1-.2.2-.2.2 0 .4-.1 0-.1.2-.2 0-.3.1-.1.2 0 .2 0 0-.2.5-.6.2-.6.2-.5.9-.7 1.1-1.2h.1c.1-.3.4-.5.4-.8.1-.1.3-.1.3 0 .1-.2.1-.3.4-.5-.1.2.2 0-.1.2.3-.2.4-.2.5-.5.3.6-.5 1.2-.4 1.1l.8-.8c.1-.1-.9.7-.8.6l.2.2c.7-.3.3-1.1 1.1-1.2 0-.2-.3.2-.4 0 .2-.2.7-.2.8-.3.4-.2-.1-.5.3-.7-.1 0-.3-.1-.2-.4.2-.2.6 0 .5.1 0 .1-.1.1-.1 0 0 .1-.1.2.1.2v-.1c.2-.1.4-.4.5-.2.1-.2-.1-.2-.2-.1.4-.2.4-.4.7-.7-.1 0-.2 0-.2 0 .5-.3 0-.3.3-.6.3-.1.2.2.4-.1.2-.1.2.1.2.2.1-.4.5-.4.7-.5l-.1.2c0-.1.1-.2.2-.2h-.2c.1-.1.2-.1.2-.1 0-.1-.3-.1-.3-.4.2-.1.2-.4.5-.3-.4.3.2.1 0 .4-.1-.1 0-.1.1-.2v.1c.5-.2-.1-.3.2-.6.1.1.3.1.3 0-.1.1-.2-.1-.2-.2.3-.2.1-.3.3-.4l-.2.1c-.1-.1 0-.2.1-.4.1 0-.1.2 0 .1 0-.3.6-.2.6-.5.2-.1.2.1.4.1 0-.2.1-.2.3-.3.1 0 .1 0 .2-.1 0 0 0 0 .1-.1 0 0 .1-.1.1-.2-.3 0-.2.1-.2-.3 0 .1-.1.3-.2.4l-.2.3c0-.1 0-.3.1-.4-.1.2-.2.4-.3.4 0-.2 0-.2-.2-.2.3-.1.3-.2.4-.3", fill: secondaryColor }), jsx("path", { d: "m9.6 15.6c0-.1 0-.1 0 0m-12.5-7.8c0 .1 0 .1 0 0-.1 0-.1-.1-.1-.1s0 .1.1.1zm27.5-8.5c.1-.2.1-.3.2-.4l.4.1c.2-.3.2-.6.1-.9s-.2-.6-.4-.9v.2c-.2 0-.2-.4-.5-.5.1-.1.1-.2 0-.4 0 0-.2-.1-.3-.1-.2-.1-.4-.1-.4 0-.1-.1-.2-.2-.3-.3-.3-.1-.6 0-.7.1-.2.1-.3.2-.6.3.1-.2-.2-.2.2-.4-.2.1-.4.1-.4.2-.1 0-.2.1-.3.2 0 .3-.1.5-.2.5 0 .1.1.2 0 .3h-.1c.1 0-.1.2.1.2-.7.1-.8.9-1.4 1-.2.3-.4.6-.6.8 0 0-.1 0 0-.1-.4.2.2.4-.2.7-.3 0 .1-.2-.1-.2-.4-.2.1 0-.2.3 0 0 0 0-.1 0 0 .3-.2.7-.4 1-.1-.2 0-.2-.2-.2-.1.1.3.1.1.4-.2 0-.4.1-.6 0l.2-.2c-.3 0-.3.3-.4.4l-.1-.1c-.3.4 0 .5-.4.9h.1c.2.3-.1 0-.1.3l-.3-.1c-.1.2-.2.6-.4.9-.1-.3.1-.6.2-.8-.1.1-.4.5-.3.6 0-.1 0-.2.1-.2 0 .3-.1.6-.3.8-.4-.4-.7.6-1.3.5-.2.6-.9.9-1.4 1.4.5.1-.1.2.3.4-.1.1-.1.2-.2.2l-.6.2c-.2 0 0-.2-.1-.2-.3.3-.3 0-.5.1.2.1.1.2-.1.4l.4-.1c-.2.5-.6.1-.8.6v-.2c-.1.2-.7.7-.5 1.1-.1 0-.2 0-.2-.1-.5.4-.6 1.3-1.2 1.5-.1.1 0 .3-.2.3 0 0-.1-.1-.1-.1 0 .1-.1.3-.2.4v-.2c-.5.4-.4.9-.7 1.3-.3-.2-.7.1-.9.3-.1.1-.2.3-.3.4s0 .1 0 .1v.1c0 .1 0 .3-.1.5 0 0 0-.1-.1-.1v-.2c0-.1-.1-.1-.1-.2 0 0-.1-.1-.1-.1h-.1c0-.1-.1-.2-.1-.2 0 .1-.2.1-.3.1 0-.2-.5-.2-.2-.4.2-.3-.1-.5-.3-.7l-.4.2c.1-.8-1.3-1.2-1.1-1.8-.1 0-.3-.1-.4-.2l.2-.1c-.3-.4-.4-.5-.8-.9h.2c-.2-.2-.8 0-1-.2l.2-.2c-.4-.4-.5-1-1.1-1.2 0 0 .1-.1.2 0-.1-.3-.4-.9-.7-.6.1-.1 0-.2-.1-.3s-.4-.3-.7-.4c.1 0 .2-.1.3-.1-.3 0-.4 0-.6 0-.1 0-.2-.1-.5-.1-.1-.1 0-.2.1-.1-.2-.1-.3-.1-.4 0-.1 0-.2.1-.4 0 .1 0 .1-.1.2-.1-.4 0-.4.1-.6.2s-.6.2-.8.1c0 .1-.1.3-.2.4-.1 0-.1-.1 0-.1-.3.2-.4.4-.4.6s0 .4-.1.6c-.1 0-.1 0-.1.1 0-.5.3-.9.3-.8-.4-.2-.6.2-.7-.2 0 .2 0 .5.1.7 0 .3.1.5.1.7 0 0 0 0-.1.1 0 .1.1.2.1.2 0 .1.1.2.1.3s.1.2.1.3c.1.1.2.2.2.2.2-.1.3 0 .3-.2 0 0 0 0-.1-.1 0 0 0 0-.1 0l-.1-.1s-.1-.1-.2-.2c.1 0 .2.1.3.1s.1.1.1.2h.4c-.1.3 0 .7-.1.8.4.3.8.8 1.3.8.1.1 0 .2 0 .2-.1 0-.1-.1-.2-.1.3.1.5.6.8.5.1.3-.3 0 0 .3h-.1c.2.9 1.5.7 1.7 1.8 0-.1 0-.1 0-.1.5 1 1.7 1.6 2.1 2.7.1.3.3.2.5.3l-.1.2.4.1c.5.2.1.9.7 1.2l.1-.1c.1.2.5.5.3.5 0 0 .2 0 .2.1l-.1.1.3-.1c.1.1.2.1.3.2.2.2.1.2 0 .3s-.1.2.3.4h.6c.2-.1.3-.2.2-.2s-.3-.1-.3-.2h.2s0 0 0-.1c.5 0 .9-.2 1.2-.5l.7-.8v-.1l.2-.2v.1c.3-.1 0-.2.3-.3l.1-.2c0 .1.2.1.1.2.4-.2.2-.6.5-.6.2-.3 0-.3-.1-.4l.2-.2.4.1-.2-.2s.1-.1.2 0c0-.2-.1 0-.1-.2.4-.1.4-.6.8-.4-.1-.2-.3.1-.2-.2.4.2.2-.3.5-.4.1.2-.1.3.2.2-.2-.3.4-.3.5-.5-.2-.2.2-.4.4-.7.1.1.6-.4.9-.6-.2-.2.1-.4.2-.6.1.1.2.2.1.3l.2-.2c0-.1 0-.2 0-.3l.1.2c.2-.2.2-.6.6-.8-.1-.1-.4-.1-.5-.2l.1-.2s.1.1.1.1 0-.1.1-.2v.2c.5.2.3.2.4.1.1.1.2 0 .2.1 0 0-.1.1-.1.1.1-.1.3-.2.5-.2-.1 0-.2-.1-.1-.2.2-.2.2 0 .4-.1 0-.1.2-.2 0-.3.1-.1.2 0 .2 0 0-.2.5-.6.2-.6.1-.5.8-.7 1-1.1h.1c.1-.3.4-.5.4-.8.1-.1.3-.1.3 0 .1-.2.1-.3.4-.5-.1.2.1 0-.1.2.3-.2.4-.2.5-.5.1.2-.7.9-.6.7l.7-.7c.1-.1-.8.7-.7.6l.2.2c.7-.3.3-1.1 1.1-1.2 0-.2-.3.2-.4 0 .2-.2.7-.2.8-.3.4-.2-.1-.5.3-.7-.1 0-.3-.1-.2-.4.2-.2.5 0 .5.1s-.1.1-.1 0c0 .1-.1.2.1.2v-.1c.2-.1.4-.3.5-.2-.2-.2-.3-.2-.5-.1.4-.2.4-.4.7-.7-.1 0-.2 0-.2 0 .5-.3 0-.3.2-.6.3-.1.2.2.4-.1.2-.1.2.1.2.2.1-.4.5-.4.7-.5l-.1.2c0-.1.1-.2.2-.2h-.2c.1-.1.2-.1.2-.1 0-.1-.3-.1-.3-.4.2-.1.2-.4.4-.3-.4.3.2.1 0 .4 0-.1.1-.1.2-.2v.1c.5-.2-.1-.3.2-.6.1.1.3.1.3 0-.1.1-.2-.1-.2-.2.3-.2.1-.3.3-.4l-.2.1c-.1-.1 0-.2.1-.4.1 0-.1.2 0 .1 0-.3.5-.2.6-.5.2-.1.2.1.3.1 0-.2.1-.2.2-.3.1 0 .1 0 .2-.1 0 0 0 0 .1-.1 0 0 .1-.1.1-.2-.3 0-.2.1-.2-.3 0 .1-.1.3-.2.4l-.1.3c0-.1 0-.3.1-.4-.1.2-.2.4-.3.4 0-.2 0-.2-.2-.2.5-.1.5-.2.6-.3", fill: primaryColor })] }) }));

const CheckmarkIconSleep = ({ primaryColor }) => (jsx("svg", { width: "40", height: "41", viewBox: "0 0 40 41", xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 21.5011C6.41073 20.7294 6.90165 20.0728 7.69175 19.7028C8.75395 19.2054 9.76294 19.4135 10.7063 20.0196C11.6626 20.634 12.2917 21.517 12.8006 22.4855C13.0528 22.9656 13.2699 23.4627 13.5163 23.9802C13.5967 23.8945 13.6733 23.814 13.7487 23.7326C15.9776 21.327 18.2494 18.9609 20.7058 16.7664C22.7735 14.9191 24.9575 13.2159 27.4003 11.8429C29.1732 10.8464 31.0375 10.0506 33.0381 9.58227C33.3005 9.52085 33.5952 9.55915 33.8709 9.58809C34.0475 9.60664 34.0164 9.75475 33.9342 9.8482C33.8162 9.98229 33.6863 10.1145 33.5376 10.2147C30.0449 12.5698 26.868 15.2741 23.9469 18.2606C20.3739 21.9136 17.266 25.9082 14.5396 30.1813C14.1109 30.8533 13.7032 31.5378 13.2924 32.2202C13.1669 32.4287 13.0016 32.5647 12.7447 32.5481C12.4856 32.5313 12.3509 32.3734 12.2614 32.1448C11.4834 30.158 10.7246 28.1635 9.90463 26.1928C9.46101 25.1266 8.92577 24.0943 8.39642 23.0636C8.2329 22.7452 7.97836 22.4586 7.72001 22.1996C7.26783 21.7462 6.69518 21.5142 6 21.5011", fill: primaryColor }) }) }));

const CheckmarkCircleIcon = ({ primaryColor, secondaryColor }) => (jsxs("svg", { enableBackground: "new 0 0 117 117", viewBox: "0 0 117 117", xmlns: "http://www.w3.org/2000/svg", children: [jsx("path", { d: "M57.143,0c-31.559,0 -57.143,25.584 -57.143,57.143c0,31.559 25.584,57.143 57.143,57.143c31.559,-0 57.143,-25.584 57.143,-57.143c-0,-15.155 -6.021,-29.69 -16.737,-40.406c-10.716,-10.717 -25.251,-16.737 -40.406,-16.737Zm-0,107.143c-27.614,-0 -50,-22.386 -50,-50c-0,-27.614 22.386,-50 50,-50c27.614,-0 50,22.386 50,50c-0,13.261 -5.268,25.978 -14.645,35.355c-9.377,9.377 -22.094,14.645 -35.355,14.645Z", fill: primaryColor }), jsx("path", { d: "M87.002,34.511c-1.1,0.043 -2.143,0.612 -2.908,1.587c-10.257,12.666 -22.38,25.492 -33.238,38.555l-18.305,-16.896c-1.21,-1.127 -2.816,-1.371 -4.211,-0.64c-1.396,0.731 -2.368,2.325 -2.549,4.18c-0.181,1.856 0.457,3.689 1.672,4.806l21.146,19.542c1.689,1.571 4.06,1.362 5.551,-0.489c11.084,-13.687 24.476,-27.524 35.948,-41.689c1.262,-1.502 1.641,-3.808 0.951,-5.797c-0.689,-1.988 -2.304,-3.245 -4.057,-3.159Z", fill: primaryColor })] }));

const PlusIcon = ({ primaryColor, secondaryColor }) => (jsxs("svg", { enableBackground: "new 0 0 40 40", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", children: [jsx("clipPath", { id: "a", children: jsx("path", { d: "m23 34.2c0-.1 0-.2 0-.3v-.2.2c0-.4-.1-.7 0-1v.3-.7.4c0-.4-.1 0-.1-.4 0 .1 0-.4.1-.5 0-.2-.1-.4 0-.6 0-.1.1.1.1 0-.1-.2 0-.8-.1-1.1 0 .1.1.1.1.1l-.1-.1s0 0 0-.1c0 0 0 0-.1 0 0-.1.1-.1.1-.1s0 0 0-.1c0-.1-.1.2-.1-.3v.1c0-.6 0-1.1 0-1.7.1-.2 0 .5.1.3 0-.5 0-1-.1-1.5 0-.3 0-.6 0-.8v.1c-.1-.1.1-.6 0-.9 0 .1.1.1.1.1 0-.5 0-1.1-.1-1.8v.1c0-.1 0-.2 0-.3s0-.2 0-.2h.2c.1 0 .3 0 .2-.1.8.1 1.6 0 2.3 0h.4c-.1 0-.3 0-.2 0h.7c-.1-.1-.1 0-.3-.1.1 0 .3-.1.5-.1-.3 0 0 .1.1.1 0 0 0 0 0-.1.4.1.1-.1.6 0 .2 0 .4-.1.6 0 .1.1-.2 0-.2.1.2 0 .4-.1.6-.1h.2c-.1 0-.3 0-.4 0 .3.1.3.1.6.1h.5-.1c.4-.2.7 0 1.2-.1 0 0 .1-.1.1-.1s0 0 .1.1c0 .1 0 .1-.1.1h-.1c-.2 0-.2.1-.1.1h.1.1s0 0-.1 0h.1c.1 0 .2 0 .1 0h.3.4s.3 0 .2.1c.3 0-.1 0 0-.1h.9s0 0 0-.1v.1h.9.2c.1 0 .1 0 .2-.1s.2-.2.2-.2c.1-.2 0-.3 0-.5v-.2c0-.1.1.2.1.2 0-.3 0-.5 0-.8 0 .1 0 0 .1-.1 0-.2-.1-.2 0-.5 0 .1.1.1.1.2 0-.3-.1-.6-.1-.8 0-.1.1.2.1.3 0-.3 0-.8-.1-.9v.2c0-.1.1-.1.1 0v.4-.2c-.1.2 0 .8 0 1.2v-.1-.1-2.4c0-.3-.2-.5-.5-.5s0-.1.1-.1h.1.2c-.1-.1-.2-.1-.3-.1s-.1-.1-.4-.1l-.4.1-.1-.1h.4c-.2-.1-.3 0-.5 0 0 0-.1 0-.2-.1l-.4.1c-.1 0 .2-.1-.1-.1-.2 0 .2.1-.1.1-.2 0-.2-.1-.4 0 0 0 0 0 .1-.1-.2 0-.6 0-.7.1-.2-.1-.7 0-.7-.1-.1 0-.4.1-.6.1.2-.1 0-.1-.1-.1-.2 0-.6 0-.5-.1-.3.1-1 0-1.5.1h.1c-.3 0-.4 0-.5-.1 0 .1-.5.1-.7.2-.3-.1.2-.1.1-.2 0 .1-.6.1-.5.1-.3-.1-.2 0-.4-.1 0 .1-.2 0-.5.1-.4-.1-.1-.1-.5-.1-.2 0 .2-.1.2-.1-.4 0-.2.1-.3.1-.5 0-.2-.1-.4-.1-.3 0-.5.1-.8.1h-.1c0-.1 0-.2 0-.3 0-.2 0-.3 0-.5 0 0 0 0 0-.1 0 .1-.1.1-.1.1 0-.2-.1-.4 0-.4v.2-.2c.1-.2 0 .3.1.3 0-.4-.1-.8-.1-1.1.1-.1 0 .7.1.3v.5c.1-.4 0 .3.1 0 0-.1 0-.2 0-.3 0-.4 0-.5 0-1 0-.1-.1 0-.1-.1s0-.1 0-.1c0-.1 0-.2 0-.3 0-.4.2-.4.1-.9-.1-.2-.1-.2-.1-.7l.1.2c0-.6-.1-.3-.1-1 0 .1 0 .5 0 .4.1-.4 0-.3 0-.6l.1-.1c0-.6-.1-1.3-.1-2 0 0 0 .2.1 0 0-.9 0-1.9.1-2.7l-.5-.3c0-.1 0-.1 0-.1 0-.1 0-.2 0-.2s0 .1-.1 0c0-.1-.1-.2-.1-.3h.1c-.1-.2-.4-.4-.7-.4-.2 0-.4 0-.6 0-.4 0-.8 0-1.1 0h.1c-.5 0-.5.1-1 .1h.1c-.3 0-.5 0-.8 0h-.4c-.2 0-.4.1-.5.2.1.2 0 .4 0 .5v.4.7.5.1c0 .2 0 .5.1.5-.1.5-.1.4-.2 1.2 0 .2.1.3.1.6h-.1l.1.4-.1.2v.3c0-.1 0-.2.1-.2 0 .4 0 1-.1 1l.1 1s0-.2-.1-.3c.1.5-.1.1 0 .6 0-.1 0 0 .1 0v.3.5s0 .1-.1.1v.1h.1v.1s0 .1-.1.1-.1 0-.2-.1v.1 1.1h.1v.1s0 0-.1 0v.1.8c0-.3.1-.2.1 0v.1c0 .3-.1.2-.1 0v.4s0-.1-.1-.1v.1.1s-.1.1-.1.1h-.1s0 0 0-.1c-.3 0-.5 0-.7 0-.3 0-.5 0-.8 0 0 0-.1.1-.2.1s0 0-.1 0h-.1c-.5 0-1-.1-1.5-.1-.4 0-.1.1-.3.1 0-.1-.6-.1-.3-.1-.4 0-.6 0-.9 0 0 0 .1.1.1.1s-.1.1-.1.2c-.1-.1-.1-.1-.2-.2v-.1c-.2 0-.3 0-.6 0 .1 0 .2 0 .1.1-.2 0-.3 0-.3-.1-.2 0-.5 0-.7 0-.2 0-.3 0-.5 0-.2 0-.5 0-.7 0-.1 0-.1 0-.1 0s0 0-.1 0c-.3 0-.5 0-.7 0l-.8.1c-.4 0 .2 0-.1-.1-.2 0-.4 0-.6 0 0 0 0 0-.1 0h-.1c-.1 0-.1 0-.2 0s-.2.1-.3.2c0 0 0 .1-.1.1h.1v.1s0 0-.1 0c0 0 0 0-.1 0 0 .1 0 .1-.1.2v.3.5c-.2.6 0 2-.1 2.7v.4s0-.2.1-.1v.2c0 .1 0 .2.1.2.1.2.2.3.3.4.4 0 .5.1.6.1h.2.3 1.2c.8 0 1.7.1 2.5.1.6 0 .3-.2 1.1-.1l-.2.1c.7-.1 1.5 0 2.2 0 0 0 0-.1 0-.2.1 0 0 .1 0 .1h1.4c-.1 0-.1 0-.2 0 .2.1.9 0 .9 0 .2 0 0 0 .2.1.2 0 .6-.1.8 0h-.1.4.1v.8c.1.2 0 .8.1.9 0 0 0 0-.1.1h.1c-.1 0-.1 0-.1 0v1c0-.1 0 .3-.1.1 0 .3 0 .6.1.6-.1.5 0 1 0 1.3v.2c0 .7.1 1.4.1 2.1h.1s.1 0 0 .1c-.1 0-.1 0-.2 0v.4.1s0 0 0-.1c0-.1 0-.3 0-.5s0 0 0-.1c0-.2 0-.3-.1-.3 0 .5.1.9.1 1.3v.8c0 .2 0-.1-.1-.2v.1 1 .6.3.2.2s-.1-.1-.1-.2c0 .2.2.5.2.4s-.1-.1-.1-.2c0-.2.1 0 .2.2.2.1.4.1.4.1-.2.1.7 0 .3.2.1 0 .2 0 .2-.1.1 0 .2 0 0 .1.5 0 .3-.1.8-.1 0 0-.1 0-.1.1.2 0 .4-.1.7-.1h.2s0 0-.1 0c.3 0 .6 0 .9-.1h.5.2c.1 0 .2 0 .3-.1-.1.1 0 .1.1 0 .3.1.4-.1.5-.1zm11.1-13.2.1.3c0 .1 0 .1-.1.1zm-.1-1.5c.1-.1.1-.1 0 0 .1 0 .1 0 .1.1 0 0 0 0-.1-.1zm-.5 2.4c0-.1 0-.1 0 0zm.2-2.5c0 .1-.1.1-.1.1s0 0-.1-.1c0 0 0 0 .1-.1 0 0 .1 0 .1.1zm-.3-.2s.1 0 0 0c.1-.1.1 0 .1 0 0 .1 0 .1-.1 0 0 .1 0 .1 0 0zm0 2.4c-.1-.1-.1-.1 0 0zm-.1-1s0 .1 0 0c0 .1 0 .1 0 0zm-.1-2.1s0 .1 0 0zm-.1 3.3s.1 0 0 0c.1.1 0 .1 0 0 0 .1 0 .1 0 0zm.3.9s-.1 0-.2.1l-.1-.1zm-1.2-.1s.1 0 0 0zm.1-.9c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zm-.2-3.1s.1 0 0 0c.1 0 .1 0 0 0zm0 1.6s0 .1 0 0c0 .1 0 .1 0 0-.1.1-.1 0 0 0zm-.3-.3s0 .1 0 0c0 .1 0 .1 0 0zm-.2 2.6s0 .1 0 0zm-.1-2.5s.1 0 0 0c.1 0 .1 0 0 0zm0 .3s.1 0 0 0c0 .1 0 .1 0 0zm-.3 1.8c0 .1 0 .1 0 0 .1.1 0 .1 0 .1s-.1 0 0-.1c-.1.1-.1.1 0 0zm-1.5-1.7c0-.1 0-.1 0 0zm.6.8c0-.1 0-.1 0 0 0-.1 0-.1 0-.2h.1c0 .1 0 .1-.1.2zm.3 1h-.1c-.1-.1-.1-.1 0-.2h.2c0 .1 0 .1-.1.2.1 0 .1 0 0 0zm.2.6c0-.1 0-.1 0 0-.1-.1 0-.1 0-.1v.1c0-.1 0-.1 0 0zm.2-.7s0 .1 0 0c0 .1 0 .1 0 0zm-.1-2.3s.1 0 .1.1c0 0 0 .1-.1.1 0-.1-.1-.2 0-.2zm-.1 2.3c.1 0 .1 0 0 0v.1s0 0 0-.1zm0-1.2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1-2.3h.1c-.1.1-.1.1-.1 0-.1.1-.1 0 0 0zm-.2.5c.1 0 .1 0 0 0 .1 0 .1.1 0 0zm-.2.1v-.1c.1 0 .2 0 .2.1 0 0 0 0-.1.1v.1c0 .1 0 .1-.1.1 0-.2 0-.2 0-.3zm-.3-1.3c.1 0 .1 0 0 0v.1c0-.1 0-.1 0-.1zm-.1 4.5v.1c-.1 0-.1 0 0-.1-.1.1-.1 0 0 0zm-.1-.5c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1-2s.1.1.1.1v.1c-.1 0-.1-.1-.1-.2-.1.1 0 0 0 0zm-.1 1.2s.1 0 0 0v.1s0 0 0-.1zm0 .6h.1c0 .1 0 .1-.1 0 0 .1 0 .1 0 0zm-.2-.6c0 .1 0 .1 0 0zm-.1.9c.1.1.1.2.1.3-.1 0-.1.1-.2 0 0-.1 0-.1.1-.3-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm-.1-2.6v.1s-.1 0 0-.1c-.1.1 0 .1 0 0zm-.1.9c0 .1 0 .1 0 0zm-.1 1.4c-.1 0-.1 0-.1 0 0-.1 0-.1.1-.1-.1-.1 0-.1 0 .1 0-.1 0-.1 0 0zm-.1-3c0 .1 0 .1 0 0v.1s0 0 0-.1zm-.5-.4c.1 0 .1.1.2.1.1.1.1.2.1.3s0 .2-.1.2c-.1-.1-.1-.2-.1-.3s.1-.2.1-.2-.1.1-.1.1c-.2 0-.2 0-.1-.2zm-.1 3.4s.1.1.1.1h-.1c-.1 0-.1-.1 0-.1zm-.4-3.2s0 .1 0 0c0 .1 0 .1-.1.1s.1-.1.1-.1zm-.2-.1c0 .1-.1.1 0 0-.1 0-.1 0 0 0zm-.4 4.1c-.1 0-.1 0 0 0zm-.1-4c-.1.1-.1.1-.2 0zm-.1 2.4s-.1.1 0 0c-.1 0-.1 0 0 0zm-.3 1c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0-1c0-.1 0-.1 0 0 .1-.1.1-.1 0 0zm0-3s0 .1 0 0v.1c0 .1 0 0 0-.1 0 .1 0 .1 0 0zm-.2.8s0 .1 0 0zm0 1.7v.1s0 0-.1 0c0 0 0 0 .1-.1zm-.1 1.9c-.1 0 0 0 0 0zm-.3-.1s0 .1 0 0c.1-.1.1 0 .2.1v.1h-.1c-.1 0-.1-.1-.1-.2 0 .1 0 .1 0 0zm-.2-.2s.1 0 0 0c0 0 0 .1 0 0 0 .1 0 .1 0 0zm-1.5-1.1c0-.1 0-.1 0 0zm0-.6c.1 0 .1 0 0 0zm0-.3c.1 0 .1 0 0 0 .1.1 0 0 0 0zm.1.5c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.3 2.2c0-.1-.1-.1-.1-.2h.1s0 .1.1.1c0 0 0 .1-.1.1zm.1.1.3-.1c-.1 0-.1.1-.3.1zm.1-1.8s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1 0 0 0 0zm-.1-2.2c.1 0 .1.1.1.1s-.1 0-.1.1c-.1-.1-.1-.1 0-.2-.1 0-.1 0 0 0zm-.1 1.9c0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm-.2-2.9c-.1 0 0 0 0 0zm-.2 1.4c.1.1 0 .1 0 0 0 .1 0 .1 0 0zm.1.4s0 .1.1.1c-.1 0-.1 0-.2 0s0 0 .1-.1zm-17.5-1.5c.1.1 0 .1 0 0 0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1 0-.1 0 0 0zm0 2.3c.1.1.1.1 0 0 0 .1 0 .1 0 0zm0-1.6c-.1 0-.1 0 0 0zm-.3-.2h.1c0 .1-.1.1-.1 0 0 .1 0 .1 0 0zm0 .9c.1 0 .1 0 0 0 .1.1.1.1 0 0 .1.1 0 0 0 0zm.1.9c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0-.1-.2-.1-.1 0 0 0-.1 0-.1 0 0zm-.2-.7s0 .1 0 0-.1 0-.1-.1c0 0 .1 0 .1-.1v.1c.1.1 0 .1 0 .1zm.2-.2c0-.1 0 0 0 0zm.1 0c-.1 0-.1 0 0 0 0-.1 0-.1 0-.1zm0 1.2c.1-.1.1-.1 0 0 .1 0 .1 0 0 0 .1.1.1.1 0 0zm.2.4c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0-.1-.1 0-.1 0 0 0-.1 0 0 0 0zm.1-1.4c0 .1 0 .1 0 0-.1 0-.1-.1-.1-.2.1.1.2.2.1.2zm1.1-.9h.1v.1s0 0-.1-.1zm-.4-.9c.1 0 .1.1 0 0 0 .1 0 .1 0 0zm-.1 1.9s.1 0 0 0c.1 0 .1 0 0 0zm0 .5c-.1 0-.1 0-.1 0 0-.1 0-.1.1 0zm-.1-.2h.1c0 .1 0 .1-.1 0 0 .1 0 .1 0 0zm-.2-.9s.1 0 0 0c.1 0 .1 0 0 0zm-.1.1c0-.1 0-.1 0 0zm0 .2c.1 0 .1 0 0 0zm.2.5s.1 0 0 0c0 .1 0 .2-.1.2 0 0 0 0-.1-.1.1-.1.2-.1.2-.1zm-.1 2.9c.1 0 .1 0 0 0zm.1-2.5c-.1-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm0 0c.1.1.1.1 0 0 0 .1 0 .1 0 0zm0 .3c0-.1 0-.1 0 0 0-.1 0-.1 0-.2.1 0 .1.1 0 .2.1-.1.1-.1 0 0zm.2.5c-.1 0-.1-.1-.1-.1.1 0 .1 0 .1.1.1-.1.1 0 0 0zm0-.6c.1-.1.1-.1.1-.1 0 .1 0 .1-.1.1zm.2-2.4c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.1 3.2c.1 0 .1 0 0 0zm.5-3.4c0 .1 0 .1 0 0-.1.1 0 .1 0 0zm.2 3.3c-.1.1-.1.1-.2 0v-.1c.1 0 .1 0 .2.1zm.1-1.5c0-.1 0-.1 0 0zm2 .6s.1 0 0 0v.1zm0 .7c-.1 0-.1 0 0 0zm-1.5.8c0-.1 0-.1 0 0 .1-.1.1 0 0 0zm.1-3.5v.1s0 0-.1 0c0 0 0 0 0-.1 0 .1.1.1.1 0 .1 0 .1 0 0 0zm.1 2.9c.1 0 .1 0 0 0 0 .1 0 .1 0 0zm0-1.9c.1-.1.1-.1 0 0 .1 0 .1 0 0 0zm.1-1.5s0-.1.1-.1c0 0 0 .1.1.1 0 0 .1 0 .1.1v.2c-.2-.1-.2-.2-.3-.3zm0 3.6c.1-.1.1-.1 0 0 .1-.1.1 0 0 0 .1 0 .1 0 0 0zm.2-2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.1.1c0-.1 0-.1 0 0zm0-1s-.1-.1 0 0c-.1-.1-.1-.2-.1-.2h.1s.1.1.1.1c-.1 0-.1 0-.1.1zm.1-.2c0-.1 0-.1 0-.2v.2c0 .1 0 .1 0 0zm.1 2.2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0 .6c-.1 0-.1 0 0 0 0-.1 0-.1 0-.1zm0-3.1c-.1 0 0-.1 0 0 0-.1 0-.1 0 0zm.2.5s.1 0 0 0c.1 0 .1 0 0 0zm.3.1c.1 0 .1.1 0 0 .1.1.1.1 0 0 .1.1.1.1.1.1 0 .1-.1 0-.1-.1zm.1 3.6v-.1h.2c-.1.1-.1.1-.2.1zm.1-1.2c.1 0 0 .1 0 0zm.1 1.1c-.1-.1 0-.1 0-.1.1 0 .1.1 0 .1zm0-3.9c0-.1.1-.1 0 0 .1-.1.1-.1 0 0zm.2 4.1c0-.1 0-.1 0 0zm.2-3.8c0-.1 0-.1 0 0zm.2 4.2s0 .1 0 0c-.1 0-.1 0 0 0zm0-.3c0 .1 0 .1 0 0zm.6-3.9s0 .1 0 0v.1c-.1 0-.1 0 0-.1-.1 0 0 0 0 0zm.1 3.2c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1-3.4s-.1-.1 0 0c0-.1 0-.1 0-.1v.1c0-.1 0 0 0 0zm.1 1.1c.1 0 .1-.1 0 0 .1-.1.1 0 0 0 .1 0 .1 0 0 0zm.4-.7s0 .1 0 0zm0 .7c-.1 0-.1 0 0 0 0-.1 0-.1 0 0zm.2 2c0-.1 0-.1 0 0zm.1-1.5c0-.1 0-.1 0 0-.1-.1-.1-.1 0 0-.1-.1 0-.1 0 0 0-.1 0-.1 0 0zm0-1.9c0-.1 0-.1 0 0 0-.1 0 0 0 0 0-.1 0-.1 0 0 0-.1 0-.2 0-.2.1 0 .1 0 0 .2.1-.1.1-.1 0 0zm.4 1.5c0-.1 0-.1 0 0zm.1 1.8s-.1.1 0 0c-.1.1-.1 0 0 0-.1-.1 0-.1 0-.2zm2.2-1c0-.1 0-.1 0 0-.1-.1-.1-.1 0 0-.1-.1-.1-.1-.1-.1.1-.1.1-.1.1.1 0-.1 0-.1 0 0zm-.2.7c0 .1 0 .1 0 0v.1c0 .1-.1 0 0-.1-.1.1 0 .1 0 0zm-.6-2.2c0 .1 0 .1 0 0zm-.1.3c-.1 0-.1 0-.1-.1.1.1.1.1.1.1zm0 .5s0 .1 0 0zm-.2-1.6s.1 0 0 0c.1 0 .1 0 0 0zm.1 2c.1 0 .1 0 0 0 .1.1.1.2 0 .2 0-.1 0-.1 0-.2zm0 .2s0 .1 0 0c0 .1 0 .1 0 0zm-.1-.2v.1s0 0 0-.1zm-.1-1.7c0-.1 0-.1 0 0zm.1.1c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.2 1.2c.1 0 .1.1 0 0 .1.1 0 .1 0 .1s0 0 0-.1zm-.1-.9s.1 0 0 0c.1 0 .1.1 0 0 .1.1 0 .1 0 0zm.1 1c0 .1-.1.1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zm-.2-1.3s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0zm.1.5c0 .1 0 .1-.2 0zm-.4-.9c-.1 0 0-.1 0 0 0-.1 0-.1.1 0-.1 0-.1 0-.1 0zm.3 4.1s-.1-.1-.1-.2.1-.2.2-.2c0 .1 0 .2-.1.4zm.3-2c-.1 0-.1 0 0 0-.1-.1-.1-.2-.2-.3.2 0 .2.1.2.3zm.2 1.5c-.1-.1-.1.1-.2 0 0-.1.1-.1.1-.2.1.1.1.2.1.2s.1-.1.1-.1c.1 0 .1 0 .1.2 0 0-.1 0-.2-.1zm.1 1.2c0-.2 0-.3.1-.3h.1c0 .1 0 .1-.2.3zm.2-3c0-.1 0-.1 0 0zm0-.2c-.1-.1-.1-.2-.1-.2h.1c.1.1.1.2 0 .2.1 0 .1 0 0 0zm.1-.4c.1 0 .1 0 0 0v.1s0 0 0-.1zm.1 1.4s.1 0 0 0c.1.1.1.1 0 .1 0 0 0 0 0-.1zm.1.5c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0zm-.1-1.7c-.1 0-.1-.1 0-.2.1.1.1.2 0 .2zm.1-.5c-.1-.1 0-.1 0-.1zm.2 3.1c-.1 0-.1 0-.2-.1 0 0 .1-.1.1-.1.1 0 .1 0 .1.2 0-.1 0-.1 0 0zm0-3.8s.1 0 0 0zm.1 2.6c0-.2 0-.2.1-.2 0 .1 0 .1-.1.2zm.1.1c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1-1.1s-.1-.1-.1-.1 0 0 0-.1c.1-.1.1 0 .1.2zm.2-1.8c0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm-.1 2.7c0-.1 0-.1.1.1 0-.1-.1-.1-.1-.1zm.2 1.4c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.1-2.1c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1.8c-.1 0-.1 0 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm0-2.6c0-.1 0-.1 0 0zm.2 4.5c0-.1 0-.1 0 0 0-.1 0-.1 0-.1v.1c0-.1 0-.1 0 0zm0-1.9c0-.1 0-.1 0 0-.1-.1 0-.1 0-.1v.1c.1-.1 0-.1 0 0zm.1-.9c-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm.8-1.1c.1 0 0 .1 0 0zm-.3.3h.1v.1c0 .1 0 .1-.1.1 0-.1 0-.2 0-.2-.1 0-.1 0 0 0-.1-.1-.1 0 0 0zm.1.8c-.1 0-.1 0 0 0zm-.3-.3h.1s0 .1-.1 0c0 .1 0 .1 0 0zm-.1.4s.1 0 0 0h.1s0 0-.1 0zm.2 2c0-.1 0-.1 0 0 0-.1 0-.1 0-.2h-.1v-.1c0-.1.1 0 .1 0v.3c0-.1 0 0 0 0zm.1-2.6s0 .1 0 0c0 .1 0 .1 0 0zm.2 2.7c-.1-.1-.1-.1 0 0-.1-.1 0-.1 0-.2v.2c0-.1 0-.1 0 0zm-.1-1c.1 0 .1 0 0 0zm.1-.2c-.1-.1-.1 0-.2 0 0-.1 0-.2 0-.2.1 0 .2 0 .2.2h.1v.2c0-.1 0-.2-.1-.2zm4.9 2.9c-.1 0-.1-.1 0-.1 0 0 0 0 .1-.1.1 0 .1.1.1.1v.1c-.1 0-.1 0-.2 0zm-.2.6c0-.1 0-.1 0 0 0-.1 0 0 0 0zm-.3-.4c-.1 0-.1 0 0 0zm-.1 8.6c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1-.6h.1c0 .1 0 .1-.1 0 .1.1 0 0 0 0zm0-.5c.1-.1.1 0 .1 0v.1c-.1 0-.1 0-.1-.1zm-.3-3.1c.1-.1.1-.1 0 0 .1-.1.1 0 .1 0v.1c0-.1 0-.1-.1-.1zm.1 1.8c0-.1 0-.1 0 0zm-.4-6.2h-.1c0-.3 0-.3.1-.4.1.1.1.2 0 .4.1-.1.1 0 0 0zm-.2-3.8c.1-.1.1-.1.2 0-.1-.1-.2 0-.2 0zm-.1 3.4c.1 0 .1 0 0 0v.1s0 0 0-.1zm.2-4.5c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0-.1-.1 0-.1 0 0zm0-5.8c-.1 0-.1 0 0 0-.1 0 0 0 0 0s0 .1 0 0zm0-.9c-.1 0 0 0 0 0zm-.1 6.5c0-.1 0-.1 0 0zm-.1 10.4c0-.1 0-.1.1-.1 0 0 0 0-.1.1.1 0 .1 0 0 0zm.2-15.1c.1 0 .1 0 0 0 .1 0 .1.1 0 0 .1.1.1.1 0 0zm0 11c0 .1 0 .1 0 0zm.3-4.3c-.1 0-.1 0 0 0zm-.1 1.9c-.1 0-.1-.1 0 0 0-.1 0 0 0 0zm0-.7c.1 0 .1 0 0 0 .1.1.1.1 0 0 0 .1 0 .1 0 0zm.1-2.7c-.1 0-.1 0 0 0 0-.1 0-.1 0-.1zm-.1-.4c0-.1 0-.1 0 0 0 .1 0 .2-.1.3-.1-.1-.1-.1-.1-.2v-.1c.2-.1.2-.1.2 0 0-.1 0-.1.1-.1v.1s0 0-.1 0zm0-4.9c0 .1.1.1 0 0 .1.1.1.2.1.2h-.1s0-.1 0-.2zm0-2s.1 0 0 0c.1 0 .1 0 0 0 .1 0 .1.1 0 0zm.1 1.5c0-.1 0-.1 0 0zm0 1.2h.2c0 .1-.1.1-.1.1-.1 0-.1 0-.2.1h-.1v-.1c.1 0 .2-.1.2-.1zm.2-2.7h.1v.1c0 .1-.1.1-.1 0-.1 0-.1 0 0-.1-.1.1-.1 0 0 0zm-.1-3.9s0 .1 0 0c0 .1 0 .1 0 0zm.2 9.6v.1c-.1 0-.1 0 0-.1-.1 0 0 0 0 0zm0 2.2c0 .1.1.1.1.2 0 0-.1 0-.1-.1v-.1c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.2 0c-.1 0-.1 0-.1 0 .1-.1.1-.1.1 0zm-.2.4c0 .1 0 .1 0 0zm.1 10.1s0 .1 0 0c0 .1-.1.1 0 0-.1 0-.1 0 0 0zm.1.7c0 .1 0 .1-.1.1 0-.1 0-.1.1-.1zm-.3-7.4c0-.1 0-.1 0 0zm-.1-6.4c.1 0 .1 0 0 0zm0-2.3c0-.1 0-.1 0 0 0-.1.1-.1 0 0zm.1 2.8s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1 0 0 0 0zm0 5.6c0-.1 0 0 0 0zm0-10.6c0-.1 0-.1 0-.2 0 0 .1 0 .1.1 0 0 0 .1-.1.1.1 0 .1 0 0 0zm.1.2s.1 0 0 0zm0-1.4c-.1-.1-.1-.2-.1-.4.2.2.2.3.1.4zm-.4 5.9c0-.1.1 0 0 0 .1.1 0 .1 0 .1 0-.1 0-.1 0-.1zm0-1.5c0 .1 0 .1 0 0zm0 2.6c0 .1.1.1 0 0 0 .1 0 .1 0 0zm.1-2.1c0-.1.1-.1.1 0s0 .1-.1.1c.1 0 0 0 0-.1zm.1 6.8s0 .1 0 0c0 .1 0 .1 0 0zm0 5.4c0 .1 0 .1 0 0zm.1 3.4h.1c.1 0 .1 0-.1 0 .1 0 .1 0 0 0zm.4-16.2c0-.1 0-.1 0 0zm0 4s.1 0 0 0c0 .1 0 .1 0 0zm0 9.1s0 .1 0 0zm0 1.3c0-.1.1-.1 0 0zm.1.4s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1 0 0 0 0zm0-7.6c0-.1 0-.1 0 0 0-.1 0 0 0 0zm0-3.3s0 .1 0 0c0 .1 0 .1 0 0zm0-1.3c0-.1 0-.1 0 0 .1-.1.1-.1 0 0 .1-.1 0 0 0 0zm.1-.6c0-.1 0-.1 0 0zm0 11.7c0 .1 0 .1 0 0 .1.1 0 .1 0 .1 0 .1 0 0 0-.1 0 .1 0 .1 0 0zm.1-19.3s-.1-.1-.1-.1c0-.1 0-.1 0-.2.1.1.1.2.2.3zm0 7.3s0 .1 0 0c-.1 0-.1 0 0 0zm-.1 2.2s.1 0 0 0c.1 0 .1.1 0 0 .1.1.1.1 0 0 .1 0 .1.1.1.1s0 0-.1-.1c.1.1.1.1 0 0 0 .1 0 .1 0 0zm.2-3.1s.1 0 .1-.1v.1s-.1.1-.1.1zm.2-1.2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.1 3.4c0-.1.1 0 0 0 .1.1.1.1.1.1-.1 0-.1 0-.1 0 0-.1-.1-.1 0-.1zm.1 2.4c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0 0zm-.3-1s0 .1 0 0c0 .1 0 .1 0 0zm0 1.8s.1 0 0 0v.1s0 0 0-.1zm.1-1.6c0 .1 0 .1 0 0zm.1-.5c0-.1 0-.1 0-.1v.1c0-.1 0-.1 0 0zm0 .2v.2s0 0-.1 0c0-.1 0-.2.1-.2zm0 1.7s0 .1.1.1h-.1c-.1 0-.1-.1 0-.1-.1 0 0 0 0 0zm-.1-3.1c-.1 0-.2 0-.2 0s0-.1.1 0c.1-.1.1-.1.1 0zm0-.4s0 .1 0 0c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm-.2 2.1s.1 0 0 0c.1 0 .1 0 0 0zm.3 9.5c0 .1 0 .1 0 0zm0-7.5c.1 0 .1 0 0 0 .1.1 0 0 0 0zm.1 1.5c0-.1 0-.1 0 0zm.1-2.3c-.1 0 0-.1 0 0 0-.1 0 0 0 0zm0-1.4c0-.1 0-.1-.1-.1v-.1s.1 0 .1.1c.1 0 .1 0 0 .1zm.2-.8s0 .1 0 0c0 .1 0 .1 0 0zm.6 1.8c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.4 1c.1-.1.1-.1.1 0 0 0 0 0-.1 0zm.1-1.7c0-.1 0 0 0 0zm0 1.4c0-.1 0-.1 0 0 .1-.1.1-.1 0 0 .1 0 .1 0 0 0zm.1-4.4s0 .1 0 0zm-.2 2.2c.1 0 .1 0 0 0 0 .1 0 .1 0 0zm0 2.3c-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0zm-.1-3c0 .1 0 .1 0 0zm-.1-.8c.1 0 .1 0 0 0v.1s-.1 0-.1-.1.1-.1.1 0zm-.1 1.9c.1 0 .1 0 0 0 .1.1 0 .1 0 .1s0 0 0-.1zm0-.4c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1 0-.1 0 0 0zm-.1.8s0 .1 0 0c.1.1 0 .1 0 .1s-.1 0 0-.1c-.1 0 0 0 0 0zm-.2 1.3c.1 0 .1 0 0 0zm-.3-2.4s.1 0 0 0zm0 1.6c0 .1 0 .1 0 0-.1.1-.1.1-.1 0 .1.1.1 0 .1 0zm-.1-1.7c.1 0 .1 0 0 0zm0-1.6c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1 0 0 0 0 0zm-.1-.1c0-.1.1 0 0 0zm-.1 1.2c.1 0 .1 0 0 0 .1.1 0 .2 0 .2 0-.1 0-.1 0-.2zm0 .6c-.1 0 0 0 0 0zm-.1-3.1c0-.1 0-.1.1-.1 0 .1 0 .1-.1.1zm.1-1.3c-.1.1-.1 0-.1 0zm0-5.3v.2c.1 0 0-.1 0-.2zm0-.8v.4s0 0 0-.1c0 0 0-.2 0-.3zm0 5s0 .1 0 0c0 .1 0 .1 0 0zm-.1.7c.1 0 .1 0 0 0 .1.1 0 .1 0 0zm0-6.4c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1.1 0 0 0 0zm-.1 2.2s0 .1 0 0c0 .1 0 .1 0 0zm0-4c-.1 0 0 0 0 0zm-.1 6s0 .1 0 0zm0 2c.1 0 .1.1 0 0 .1.1.1.1 0 0 0 .1 0 .1 0 0zm-.2-7.7s0 .1 0 0c.1.1 0 .1 0 0 0 .1 0 .1 0 0zm0 2c0 .1-.1.2-.1.1-.1 0-.1-.1-.1-.2s.1-.2.1-.2c.1.2.1.2.1.3zm-.3 5.7s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1-.1 0 0 0zm-.1-7.4v.1zm-.1 8.1s0 .1 0 0c0 .1 0 .1 0 0zm0-4c-.1 0-.1 0 0 0zm-.1-1.1v.1zm.1 8.9c0 .1-.1.1-.1.1s0-.1-.1-.1c.1-.1.1-.1.2 0-.1 0 0 0 0 0zm-.2-4.9v-.1s.1 0 0 .1zm0-3.4s.1 0 0 0c.1.1 0 .1 0 0 0 .1 0 .1 0 0zm-.1-1.6s.1.1 0 0c0 .1 0 .1 0 0zm-.1-2.6s.1 0 0 0h.1v.1s0 0-.1 0c0 0 0 0 0-.1zm-.1 6.3c.1 0 .1 0 0 0 .1 0 .1.1.1.1v.1s0 .1-.1.1 0-.1 0-.1c0-.1 0-.1 0-.2zm0-3.9c0 .1-.1.1-.2.1 0 0 0 0 0-.1zm-.1-.1c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1.1-.1 0 0 0zm0 1.1c-.1 0-.1 0 0 0zm-.1 1c.1 0 .1 0 0 0v.1s0 0 0-.1zm-.1-3.5c0 .1.1.1.1.1-.1 0-.1 0-.1 0zm-.1 2.7s.1 0 0 0c0 .1 0 .1 0 0zm0 2.4c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0 .3s0 .1 0 0v.1c-.1 0-.1 0 0-.1-.1.1 0 0 0 0zm0 3.2s.1.1 0 .2h-.1-.1c0-.1 0-.1.1-.2 0-.1.1-.1.1 0zm-.3 2.9c.1 0 .1 0 0 0zm.1-.1c0-.1 0 0 0 0zm.1-8.2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1 3.8c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm0 1.7v.1c-.1 0-.1 0 0-.1-.1 0 0 0 0 0zm-.1 5.1c0-.1.1-.1.1-.1v.1s-.1.1-.1 0zm0 8.1c-.1 0-.2 0-.2-.1s0-.1.1-.1c0 0 .1.1.1.2zm-.2.2c.1-.1.1-.1.2-.1 0 0 0 .1.1.1-.2.1-.3 0-.3 0zm-.1.9s-.1-.1-.1-.1c.1-.1.1 0 .1.1zm-.3-6.5c0-.1 0 0 0 0zm0-.2c0-.1 0-.1 0 0 0-.1 0 0 0 0zm0-.9s0-.1-.1-.1c0 0-.1-.1-.1-.1h.1c0 .1 0 .1.1.1.1.1.1.1 0 .1zm0 2.3c-.1 0-.1-.1 0 0 0-.1 0-.1 0-.1zm-.6 6.8c0-.1 0-.1.1-.2 0 0 0 .1.1.1-.1.1-.1.1-.2.1zm-.2-3.1c.1 0 .1.1.1.2-.1-.1-.1-.1-.1-.2zm-.1-2.3c-.1-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm-.5.9c0-.1.1-.1.1-.1s.1 0 0 .1c0 0 0 0-.1 0zm0 2.8s.1 0 0 0c.1 0 .1 0 0 0zm-.2-2.1c.1 0 .1-.1 0 0 .1-.1.1-.1 0 0 .1 0 .1 0 0 0zm0-3.8c.1 0 .1 0 0 0 .1.1.1.1 0 0 0 .1 0 .1 0 0zm-.1-3.4v-.1-.1c0 .1.1.1 0 .2zm-.3-4.6c0-.1 0-.1 0 0 0-.1.1-.1 0 0 .1-.1.1-.1 0 0 .1 0 .1 0 0 0zm.1 2.2c.1 0 .1 0 0 0 .1.1 0 .1 0 0zm.2-2.4h-.1s0 0 0-.1 0-.1.1.1zm-.1-2.3c-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zm.1.1c0 .1 0 .1 0 0zm.2 3.2c-.1 0-.1 0-.2 0 0-.1.1-.1.1-.1s0 .1.1.1zm-.1 2.9c0-.1 0-.1 0 0 .1 0 .1 0 0 0zm.1-1.8c0-.1 0-.1 0-.2zm0 .5c0-.1 0-.1 0 0 0-.1 0 0 0 0zm0 .9c-.1 0-.1 0 0 0 0-.1 0-.1 0 0zm0 4.6s.1 0 0 0c.1 0 .1.1 0 0zm0-2.9v-.1c.1 0 .1.1 0 .1.1 0 .1 0 0 0zm0-2.1c-.1 0-.1-.1-.1-.1.1.1.1 0 .1.1.1 0 .1 0 0 0zm0-1.6v.2s-.1 0-.1.1c0 0-.1.1-.1.1s0-.1 0-.2c.1-.1.1-.2.2-.2zm-.2 1c.1 0 .1 0 0 0zm0-.4c.1 0 .1 0 0 0zm.1-1s.1 0 0 0c.1.1 0 .1 0 0 0 .1 0 .1 0 0 0 0 0 .1 0 0 0 .1 0 .1 0 0zm0-2c-.1 0-.1 0 0 0zm-.1-.3v.1c-.1 0-.1 0 0-.1-.1 0-.1 0 0 0zm-.2 5.9s.1 0 0 0zm0 3c.1 0 .1 0 0 0 .1 0 .1.1 0 0 0 .1 0 .1 0 0zm0 4.5c0-.1.1-.1 0 0 .1-.1.1-.1.1-.1 0 .1 0 .1-.1.1zm.1-.8c0-.1 0-.1 0 0zm.1-9.2c-.1 0-.1 0 0 0zm.1 4.1c0 .1 0 .1 0 0v.1s0 0 0-.1zm.2 5.9c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1-.1.1 0 0zm0 .5c0 .1 0 .1 0 0 .1.1.1.2.1.2-.1.1-.1 0-.1-.2-.1.1 0 .1 0 0zm.1-3.1c-.1 0-.2-.1-.2-.2.1 0 .2 0 .3.1 0 .1 0 .1-.1.1zm.7-16.9v.1.1s0 0-.1-.1c0-.1 0-.1.1-.1zm0 .8v.1c-.1 0-.1 0 0-.1-.1 0-.1 0 0 0zm0 5.8c-.1.1 0 .1-.1.2 0-.1 0-.1.1-.2-.1 0-.1-.1 0 0 0-.1 0 0 0 0zm-.1 1.3s.1 0 .1.1c0 0 0 .1-.1.1 0 0-.1-.1 0-.2-.1 0 0 0 0 0zm.2.1c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0 1.2c-.1.1-.1.1-.2.1v-.1h.1c0-.1 0-.1.1 0zm-.3-.5s0 .1 0 0c0 .1 0 .1 0 0zm.1.8c0-.1 0-.1 0 0zm-.1.8c.1 0 .1 0 0 0 .1.1.1.1 0 .1.1 0 0 0 0-.1zm.1 4.1c0 .1 0 .1 0 0zm-.1.1c0 .1 0 .1 0 0zm0 .6s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1-.1 0 0 0zm0 .4c0-.1 0-.1 0 0 .1-.1.1 0 0 0zm.1 4c-.1 0-.1-.1-.1-.1.1 0 .1 0 .1.1zm0-3.1c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1 4.2c0 .1 0 .1 0 0-.1.1-.1 0 0 0-.1 0 0 0 0 0zm0-6.2c0-.1 0-.1 0 0zm-.2-13.4c0-.1 0-.1 0-.1zm0 1.4c-.1 0-.1 0 0 0zm0 2c0 .1-.1 0 0 0-.1 0 0 0 0 0zm-.1-.9c0-.1 0-.1 0 0zm0 1s0 .1 0 0c0 .1 0 .1 0 0zm-.3 13.5c.1.1.1.1 0 .1zm-.1-2.2c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1 0 0 0 0 0zm.1-7.7c0-.1 0-.1 0-.1s.1 0 0 .1zm0 1.6c0-.1 0-.1 0 0zm0 1.8s0 .1 0 0c.1.1.1.1.1.2 0 0 0 .1-.1.1v-.1c-.1-.1-.1-.1 0-.2-.1.1-.1 0 0 0zm-.1-1.2c0-.1 0-.1 0-.1zm0 5.8c.1.1.1.1 0 0 .1.1 0 .1 0 0 0 .1 0 .1 0 0zm.2-1.3s0 .1 0 0c0 .1 0 .1 0 0-.1.1-.1 0 0 0zm-.1 2.9s.1 0 0 0c.1 0 .1 0 0 0zm0-.1s.1 0 0 0c.1 0 .1 0 0 0 .1.1.1.1 0 0zm.1 2.3v.1s0 0 0-.1zm0-2.9s.1 0 0 0c.1 0 .1 0 0 0zm.1-5.4c-.1 0-.1-.1 0 0-.1-.1-.1-.1 0 0 0-.1 0 0 0 0zm0 3.1c0-.1 0-.1 0 0zm0-3.6c0-.1 0-.1 0 0-.1-.1 0-.1 0-.1 0-.1.1-.1 0 .1.1-.1.1-.1 0 0 .1 0 .1-.1 0 0 .1-.1 0-.1 0 0zm.1-6.4h-.1c0-.1 0-.1.1 0-.1 0-.1 0 0 0zm-.2-.6c0-.1 0-.1 0 0 0-.1 0 0 0 0zm0 2.5c0 .1-.1 0 0 0-.1 0 0 0 0 0zm-.1.9c.1 0 .1 0 0 0zm0-2.9s-.1-.1 0 0c-.1-.1 0-.1 0-.1zm-.1-1.3c0-.1 0-.1 0 0 0-.1.1-.1 0 0zm0 3.3c0-.1 0 0 0 0 .1 0 .1.1.1.1-.1 0-.1-.1-.1-.1zm0 2.2c0 .1.1.1 0 0 .1.1 0 .2 0 .2s-.1 0-.1-.1c.1 0 .1 0 .1-.1zm0 .4s0 .1 0 0c0 .1 0 .1 0 0zm0 .8c.1.1 0 .1 0 .2 0-.1-.1-.2 0-.2zm0 4.7s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0-.1.1 0 0 0 0zm0 .8c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0 0 0 0zm.1 3.2s0 .1 0 0c0 .1 0 .1 0 0zm0-.5s0 .1 0 0c0 .1 0 .1 0 0zm.1 2.8v.1s0 0 0-.1zm.1.4s0 .1 0 0c0 .1-.1.1 0 0-.1 0-.1 0 0 0zm.1-8.4c0-.1 0-.2 0-.2h.1c.1.1.1.1 0 .2 0-.1 0-.1-.1 0zm.1 5.8c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0 .3s0 .1 0 0c0 .1 0 .1 0 0 0 .1-.1.1 0 0zm.1 1.2c.1 0 .1 0 0 0 .1.1 0 .1 0 .1s0 0 0-.1c-.1.1 0 0 0 0zm.1 1.2c.1 0 .1.1.1.1s-.1 0-.1-.1c0 .2 0 .2-.1.1 0 0 0-.1.1-.1zm.1-2.1s0 .1 0 0c0 .1 0 .1 0 0zm0-2.3c-.1-.1-.1-.2-.1-.3.1 0 .1 0 .2.1 0 .1 0 .1-.1.2zm0-4.1c.1 0 .1 0 .1.1 0 0-.1 0-.1-.1.1.1.1.1.1.1-.1 0-.1 0-.1-.1 0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1 4.5c0-.1 0-.1 0-.1zm.1 3.7c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1.2s.1 0 0 0v.1zm0-7.2c0 .1 0 .1 0 0zm0-.7c0-.1 0-.1.1-.1 0 .1-.1.1-.1.1zm0 2s0 .1 0 0c0 .1 0 .1 0 0zm-.1.5c-.1-.1-.1-.1 0-.1 0 0 .1 0 0 .1zm.2 7.2c-.1.1-.1.1 0 0-.1 0-.1 0 0 0zm0-6.6h.1c0 .1-.1.1-.1 0zm.1-3.3s0 .1 0 0c-.1.1-.1.1-.1 0 0 0 .1-.1.1 0zm0 1.5c-.1 0-.1 0 0 0zm0-.2c-.1 0 0-.1 0 0 0-.1 0 0 0 0zm.6-2c.1.1.1.1 0 .1 0 0 0 0-.1 0 0 0 0 0 .1-.1-.1 0-.1 0 0 0zm0-2.5c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zm-.2 5.7c0-.1 0-.1 0 0zm-.1-5.2c0-.1 0-.1 0 0 0-.1.1-.1 0 0 0-.1 0 0 0 0zm.1.4c.1 0 .1 0 0 0zm-.1-2c-.1 0-.1-.1-.1-.2.1-.1.2 0 .2.1.1.1 0 .1-.1.1zm-.1.9c0-.1 0-.1 0 0zm.2-6.4c0-.1 0-.1 0 0 0-.1 0 0 0 0zm-.1.4c0-.1 0-.1 0 0zm0 .2c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0 0 0 0zm-.1 7.1s0 .1 0 0c0 .1 0 .1 0 0-.1 0-.1 0-.1 0zm-.2 2.4c0-.1 0-.1 0-.2.1.1.1.2 0 .2zm0-.9c.1 0 .1 0 0 0 .1 0 0 .1 0 0zm0-.5c.1 0 .1 0 0 0 .1 0 .1 0 .1.1 0 0 0 0-.1-.1zm.1 1.1c0-.1 0 0 0 0zm0-3.1c0 .1-.1 0 0 0-.1 0 0 0 0 0zm0 13.8c0 .1 0 .1 0 0 0 .1-.1.1 0 0zm0-5.3s0 .1 0 0c0 .1 0 .1 0 0zm0-3.2c0-.1 0-.1 0 0zm.1-2.7c0-.1 0-.1.1-.2.1 0 .1.1.2.1-.2.1-.2.1-.3.1zm.1 1c0-.1 0-.1 0 0 0-.1.1-.1 0 0zm.1 2.2v.2c-.1-.1-.1-.1 0-.2zm0 .3c0 .1.1.1 0 .1 0 0 0 0 0-.1zm.1-.1c.1 0 .1 0 0 0zm.2-3.3c.1 0 .1 0 0 0 .1 0 .1.1 0 0 .1.1 0 0 0 0zm.1 2.5c0 .1 0 .1 0 0zm-.1-10.5c0-.1 0-.1 0-.1v.1c.1 0 .1 0 0 0zm.1-7.2c-.1 0-.1 0 0 0zm-.1 7.5c-.1 0-.1 0 0 0zm-.1 10.4c-.1 0-.1 0-.1-.1 0 0 .1 0 .1.1.1-.1.1-.1 0 0zm0-3.7c-.1 0 0-.1 0 0 0-.1 0-.1 0 0zm0-7.7v.2h-.1c-.1 0-.1-.1 0-.1 0-.1 0-.1.1-.1-.1 0 0 0 0 0zm-.1-6.8c0 .1-.1.2-.2.2v-.1c0-.1.1-.1.2-.1zm-.3 3.8s0 .1.1.1c-.1 0-.1 0-.1-.1zm0 6.5c0 .1 0 .1 0 0-.1 0-.1 0 0 0zm-.2-9c0-.1 0-.1 0 0 .1-.1.1 0 0 0 .1 0 .1 0 0 0zm0 7.4v.1c-.1 0-.1-.1 0-.1-.1 0-.1 0 0 0zm-.2-4.5s-.1 0-.1-.1c.1 0 .1 0 .1.1zm0 8c-.1 0-.1 0 0 0-.1.1-.1.1-.1.1s0 0 .1-.1c-.1.1-.1.1-.1.1v-.1-.1s0 0 0-.1c-.1.1 0 .1.1.2-.1-.1-.1-.1 0 0zm-.1-8.6c-.1-.1-.1-.1 0-.2zm-.1-1.9s0 .1 0 0c.1.1 0 .2 0 .2-.1 0-.1 0 0-.2-.1.1-.1 0 0 0zm-.1 1.2s0 .1 0 0c0 .1-.1.1 0 0-.1.1-.1.1-.1.1-.1 0 0 0 .1-.1-.1 0-.1 0 0 0zm-.2 1.5h-.1c.1-.1.1-.1.1 0zm0-2.7v.1c-.1.1-.1 0 0-.1-.1.1 0 0 0 0zm-.2-1.6v.1s0 0 0-.1c-.1 0 0 0 0 0zm0 5.7c-.1 0-.1 0-.1 0 0-.1 0-.1.1 0zm-.2-3.4s.1 0 0 0v.1s0 0 0-.1zm-.2 5.5c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zm-.2-7.9h.1c0 .1 0 .1-.1.2 0-.1-.1-.1 0-.2zm.1 1.5c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.2 4.3c0-.1.1 0 .1 0s.1.1.1.1 0 0 0-.1 0-.1.1-.1c0 .1 0 .1-.1.2-.1 0-.1 0-.2.1 0-.1 0-.2 0-.2zm.1.7c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0-.1-.1 0 0 0 0zm-.2-6.5s0 .1 0 0v.1s0 0 0-.1zm0 1.5c0 .1 0 .1 0 0zm0 4.2v.1s0 0 0-.1zm0 1.5c.2 0 .2 0 .2.2 0 0-.1 0-.1.1s0 0-.1-.1h-.1c0-.1 0-.2.1-.2zm-.1.4c0-.1.1-.1.1-.1s0 .1-.1.1zm0 .2c.1 0 .1 0 0 0h.1c.1 0 0 0-.1 0 .1 0 .1 0 0 0zm.1 1.2c.1 0 .1.1.1.2-.1-.1-.1-.2-.1-.2-.1 0 0 0 0 0zm-.2.3c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1-.3c-.1 0 0 0 0 0zm-.2 4.7c.1-.1.1-.1.2-.1 0 0 .1.1.1.1s-.1.1-.1.1c-.1 0-.1 0-.2-.1zm.1 1.7c0-.1 0-.1 0 0 0-.1.1-.1 0 0zm0 3.1s.1 0 0 0c.1 0 .1.1 0 .1 0 0 0 0 0-.1zm0 3.3c-.1-.1-.1-.1 0 0 0-.1 0-.2.1-.1 0 0 .1 0 .1.1-.1-.1-.2-.1-.2 0zm.1-3.8c0-.1 0-.1 0 0 .1-.1.1-.1 0 0 .1 0 .1 0 0 0zm0-.5s.1 0 0 0zm.1 5c.1-.1.1-.1.2-.1-.1.2-.1.2-.2.1 0 .1 0 .1 0 0zm0 3s0 .1 0 0c-.1 0-.1 0-.1 0zm-.1.5c.1 0 .1.1.1.1s-.1 0-.1-.1zm-.1-.1c0-.1 0-.1 0 0 0-.1.1-.1 0 0 .1 0 .1 0 0 0zm.2.9c-.1 0-.1 0-.1-.1 0-.1.1 0 .1.1 0-.1 0-.1 0 0zm0-1.2c0-.1 0 0 0 0zm0-.5c0-.1 0-.1 0 0 0-.1.1-.1 0 0 .1-.1 0 0 0 0zm.1 1.5c0-.1 0-.1 0 0 .1 0 .1 0 0 0zm.1-.7c-.1 0 0 0 0 0 0-.1 0 0 0 0zm0-8.2s.1 0 0 0c.1 0 .1 0 0 0 .1 0 .1.1.1.1s0 0-.1 0c.1 0 0 0 0-.1 0 0 .1 0 0 0 .1 0 .1 0 0 0zm.1 6.2c0 .1 0 .1 0 0-.1.1-.1.1 0 0zm0 3.2s.1-.1 0 0c.1-.1.1-.1 0 0 .1 0 .1 0 0 0zm.1-2.1c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.2 2.5c-.1 0-.1 0 0 0-.1-.1 0-.1 0-.1zm0-.7s0 .1 0 0zm.2-.8c-.1 0-.1 0 0 0-.1 0-.1-.1-.1-.1-.1 0-.1-.1-.1-.1s0 .1-.1.1c0 0 0 0-.1-.1 0 0 .1-.1.1-.1v.1c.2.1.2.1.3.2 0-.1 0 0 0 0zm0 1.9c0-.1 0-.1 0 0 0-.1.1-.1 0 0 0-.1 0-.1 0 0zm.1-.6c0-.1.1-.1 0 0zm0-4.5c0-.1.1-.1 0 0 .1 0 .1 0 0 0zm.2 1.3c-.1-.1 0-.1 0 0 0-.1 0-.1 0 0zm.1 3.3c0-.1.1-.2.1-.2s.1.1.1.1c-.1 0-.1 0-.1 0 .1 0 .1.1-.1.1.1 0 .1 0 0 0zm.2.4s.1 0 .1.1c-.1-.1-.1-.1-.1-.1zm.1-.1c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm.1 0c-.1 0-.1 0-.2 0s0 0 0-.1h-.1.1s0-.1.1-.1c.1.1 0 .1 0 .2 0-.1 0-.1.1 0 0-.1 0-.1 0 0zm.2.3c-.1 0-.1 0-.1 0v-.1c0-.1.1 0 .1 0 0-.1 0 0 0 .1 0-.1 0 0 0 0zm.1-1.6c0-.1 0 0 0 0zm0-8c-.1-.1-.1-.1 0-.1v-.1h.1c0 .1 0 .1-.1.1v.1c.1 0 .1 0 0 0zm.1.7c0-.1 0-.1 0 0 .1 0 .1 0 0 0h.1c0 .1 0 0-.1 0 .1 0 .1 0 0 0zm.1 6.9c0-.1 0-.1 0 0zm0 .2s.1 0 0 0c.1 0 .1 0 0 0 .1.1.1.1 0 0 .1.1 0 .1 0 0zm.1.3c0-.1 0-.1 0-.1s.1 0 0 .1c.1-.1 0 0 0 0zm.1-.5c.1 0 .1 0 0 0zm.1.2c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm-.1-1.8c.1-.1.1-.1.1 0 0 0 0 0-.1 0zm.3.9c-.1 0-.1 0 0 0zm0-3.7c-.1 0-.2.1-.2 0 0 0 .1-.1.1-.1.1 0 .1 0 .1.1zm.1 6.1c-.1 0 0 0 0 0zm.1-3.4c-.1 0 0 0 0 0zm.1-2.8c-.1 0-.1-.1 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm0 4.5c0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1-.7c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0zm.1.7c-.1 0 0 0 0 0zm0-7.7c.1 0 .1 0 0 0zm.2 6.7c0-.1-.1-.1 0 0 0-.1 0-.1 0 0zm.2 2.5c-.1 0 0 0 0 0zm0-.3s-.1 0-.2 0c.1 0 .1-.1.2-.1zm.1-1.2c0 .1 0 .1 0 0v.1s0 0 0-.1c-.1.1 0 .1 0 0zm.2 1.1h-.1s0-.1.1-.1c-.1 0 0 0 0 .1 0-.1 0 0 0 0zm.1-1.3c0-.1 0 0 0 0zm0-1.6c.1 0 .1 0 0 0zm.1.4c0-.1 0-.1 0 0zm.1.1c0-.1 0-.1 0 0 0-.1 0-.1 0-.1v.1c0-.1 0 0 0 0zm.1-1.1c0 .1 0 .1 0 0zm.1 3.8c-.1 0-.1 0 0 0-.1 0 0 0 0 0zm0-.9c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 0-.1 0-.1 0 0zm-.1-.2c0-.1.1 0 0 0 .1 0 .1 0 0 0zm.2 1.1c0-.1 0-.1 0 0zm0-5.1v-.1c0-.1 0 0 0 .1 0-.1 0-.1 0 0zm.1 5.7c0-.1 0-.1 0 0zm0-.3c0-.1 0 0 0 0zm.1-2.9c-.1 0-.1 0 0 0z" }) }), jsx("clipPath", { id: "b", children: jsx("path", { d: "m6.5 6.1h27.8v28.6h-27.8z" }) }), jsx("clipPath", { id: "c", children: jsx("path", { d: "m32.8 18.7c0-.3 0-.8-.1-.9v.2c0-.1.1-.1.1 0v.4-.2c-.1.2 0 .8 0 1.2l-.1-.1v-2.3c0-.3-.2-.5-.5-.5s0-.1.1-.1h.1.2c-.1-.1-.2-.1-.3-.1s-.1-.1-.4-.1l-.4.1-.1-.1h.4c-.2 0-.3 0-.5 0 0 0-.1 0-.2-.1l-.4.1c-.1 0 .2-.1-.1-.1-.2 0 .2.1-.1.1-.2 0-.1-.1-.4 0 0 0 0 0 .1-.1-.2 0-.6 0-.7.1-.2-.1-.7 0-.7-.1-.1 0-.4.1-.6.1.4-.1-.8 0-.7-.1-.3.1-1 0-1.5.1h.1c-.3 0-.4 0-.5-.1 0 .1-.5.1-.7.2-.3-.1.2-.1.1-.2 0 .1-.6.1-.5.1-.3-.1-.2 0-.4-.1 0 .1-.2 0-.4.1-.4-.1-.1-.1-.5-.1-.2 0 .2-.1.2-.1-.4 0-.2.1-.3.1-.5 0-.2-.1-.4-.1-.3 0-.5.1-.8.1h-.1c0-.1 0-.2 0-.2 0-.2 0-.3 0-.4 0 .1-.1.1-.1.1 0-.2-.1-.3 0-.4v.2-.2c.1-.2 0 .3.1.3 0-.4-.1-.8-.1-1.1.1-.1 0 .7.1.3v.4c.1-.3 0 .3.1 0 0-.6 0-.7 0-1.3 0-.1-.1 0-.1-.1-.1-.8.2-.7.1-1.3-.1-.2-.1-.2-.1-.7l.1.1c0-.6-.1-.3-.1-.9v.4c.1-.4 0-.3 0-.6l.1-.1c0-.6-.1-1.3-.1-2 0 0 0 .2.1 0 0-.9 0-1.8.1-2.6l-.1-.3c0-.1 0-.1 0-.1 0-.1 0-.1 0-.2s0 .1-.1 0c0-.1-.1-.2-.1-.3h.1c-.1-.2-.4-.4-.7-.4-.2 0-.4 0-.6 0-.4 0-.8 0-1.1 0h.1c-.5 0-.5.1-.9.1h.1c-.3 0-.5 0-.8 0h-.4c-.2 0-.4.1-.5.2s-.2.3-.2.5v.4.6c.1.1 0 1 .1 1.1-.1.6-.1.4-.1 1.2 0 .2.1.3.1.6h-.1l.1.4-.4.2v.3c0-.1 0-.2.1-.2 0 .4 0 1-.1 1l.1.9s0-.2-.1-.3c.1.5-.1.1 0 .5 0-.1 0 0 .1 0v1.1-.1 2.2c0-.3.1-.2.1 0l-.1.1c0 .1 0-.2.1.1 0 .3-.1.2-.1 0v.3s0-.1-.1-.1c0 0 0 .2 0 .1-.4 0-.6 0-.9 0s-.5 0-.8 0c0 .1-.3 0-.4.1-.5 0-1-.1-1.5-.1-.4 0-.1.1-.3.1 0-.1-.6-.1-.3-.1-.7 0-.8 0-1.7.1.1 0 .2 0 .1.1-.2 0-.3 0-.3-.1-.9.1-2.2-.2-2.9 0l-.8.1c-.4 0 .2 0-.1-.1-.2 0-.4 0-.6 0h-.1c-.1 0-.1 0-.2 0s-.2.1-.3.2-.1.2-.2.3v.3.5c-.2.5 0 1.9-.1 2.6v.4s0-.2.1-.1v.2c0 .1 0 .2.1.2.1.1.2.3.3.3s.1.1.2.1h.2.3 1.2c.8 0 1.7.1 2.5.1.6 0 .3-.2 1.1-.1l-.2.1c1.2-.1 2.5 0 3.6-.1-.1 0-.1 0-.2 0 .2.1.9 0 .9 0 .2 0 0 0 .2.1.2 0 .6-.1.8 0h-.1.4.1v.8c.1.2 0 .8.1.8-.1 0-.1.8 0 1.1 0-.1 0 .2-.1.1 0 .3 0 .6.1.6-.1.6.1 1.2-.1 1.5.1.9.1 1.8.1 2.7-.1 0 0-.9-.1-.9 0 .8.1 1.3.1 2.1 0 .2 0-.1-.1-.2v1.2.6.3.1.2s-.1-.1-.1-.2c0 .2.2.5.2.4 0 0-.1-.1-.1-.2 0-.2.1 0 .2.2.2.1.4.1.4.1-.2.1.7 0 .3.2.1 0 .2 0 .2-.1.1 0 .2 0 0 .1.5 0 .3-.1.8-.1 0 0-.1 0-.1.1.2 0 .5-.1.9-.1 0 0 0 0-.1 0 .3 0 .6 0 .9-.1h.5.2c.1 0 .2 0 .3-.1-.1.1 0 .1.1 0s.2-.2.2-.2c0-.1 0-.2 0-.3v-.2.2c0-.3-.1-.6 0-.9v.3-.6.4c0-.3-.1 0-.1-.4 0 .1 0-.3.1-.5 0-.2-.1-.3 0-.6 0-.1.1.1.1 0-.1-.2 0-.8-.1-1 0 .1.1.1.1.1l-.1-.1c0-.2 0-.2.1-.2 0-.5-.1.2-.1-.4v.1c0-.6 0-1.1 0-1.6.1-.2 0 .5.1.3 0-.8-.1-1.6-.1-2.3v.1c-.1-.1.1-.5 0-.9 0 .1.1.1.1.1 0-.5 0-1-.1-1.8v.1c0-.1 0-.2 0-.3s0-.2 0-.2h.2c.1 0 .3 0 .2-.1 1 .2 1.9-.1 2.7.1-.1 0-.2 0-.2 0h.7c-.1-.1-.1 0-.3-.1.1 0 .3-.1.5-.1-.3 0 0 .1.1.1.4.1.1-.1.6 0 .2 0 .4-.1.6 0 .1.1-.2 0-.2.1.3 0 .6-.1.9-.1-.1 0-.3 0-.4 0 .3.1.3.1.6.1h.5-.1c.4-.2.8 0 1.3-.1-.5.1-.1.1-.1.1.1 0 .3 0 .3.1.2-.1.4 0 .7 0 0 0 .3 0 .2.1.3 0-.1 0 0-.1.5-.1 1.1.1 1.8 0h.2c.1 0 .1 0 .2-.1s.2-.2.2-.2c.1-.2 0-.3 0-.5v-.2c0-.1.1.2.1.2 0-.3 0-.5 0-.8 0 .1 0 0 .1-.1 0-.2-.1-.2 0-.5 0 .1.1.1.1.2 0-.3-.1-.5-.1-.8 0-.4 0-.2 0-.1zm-11.3-10v.2s0-.1 0-.2zm0-.8v.4s0 0 0-.1c0 0 0-.2 0-.3zm2 13.2.3-.1c0 .1-.1.1-.3.1zm8.2 0-.1-.1h.3s-.1.1-.2.1zm.9-1.4v-.4.4c.1 0 .1 0 0 0z" }) }), jsx("clipPath", { id: "d", children: jsx("path", { d: "m5.2 4.9h27.6v27.7h-27.6z" }) }), jsx("g", { "clip-path": "url(#a)", children: jsx("path", { "clip-path": "url(#b)", d: "m5.3 4.8h30.2v31.1h-30.2z", fill: secondaryColor }) }), jsx("g", { "clip-path": "url(#c)", children: jsx("path", { "clip-path": "url(#d)", d: "m4 3.7h30.1v30.1h-30.1z", fill: primaryColor }) })] }));

const PlayIcon = ({ primaryColor }) => (jsx("svg", { height: "40", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "m29.4221383 20.9999219c.9610022-.5517908.9580286-1.448263 0-1.998512l-13.68209-7.8583834c-.9610021-.5519569-1.7400483-.1012268-1.7400483.9991056v15.7144031c0 1.1037477.7820197 1.5494898 1.7400483.9994063z", fill: primaryColor, fillRule: "evenodd" }) }));

const ChevronIcon = ({ primaryColor }) => (jsx("svg", { height: "40", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { fill: primaryColor, d: "m16.8577515 13.871078c.4628518-.4797661 1.2232746-.4934111 1.7071051-.0265264l5.5772028 5.7802482c.230615.2390425.3537757.5553086.3503235.8699153.0038717.3257642-.1194311.6426662-.3503235.8819963l-5.5531258 5.7560575c-.4605986.4774305-1.2210214.4910755-1.7055759.0234653l-.0256062-.0258009c-.4672013-.4842745-.4672013-1.2514922.0000064-1.7357734l4.7213084-4.8939043-4.7213148-4.8939109c-.4360545-.4519895-.4651248-1.150454-.0872109-1.6353069z" }) }));

const CloseIcon = ({ primaryColor }) => (jsx("svg", { width: "40", height: "40", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { fill: "none", fillRule: "evenodd", children: jsx("path", { d: "M20 8a1 1 0 0 1 1 1v10h10a1 1 0 0 1 0 2H21v10a1 1 0 0 1-2 0V21H9a1 1 0 0 1 0-2h10V9a1 1 0 0 1 1-1z", fill: primaryColor, transform: "rotate(45 20 20)" }) }) }));

const IconMap = {
    Plus: PlusIcon,
    Checkmark: CheckmarkIcon,
    CheckmarkCircle: CheckmarkCircleIcon,
    Play: PlayIcon,
    Chevron: ChevronIcon,
    Close: CloseIcon,
};
const IconMapSleep = {
    Plus: PlusIcon,
    Checkmark: CheckmarkIconSleep,
    CheckmarkCircle: CheckmarkCircleIcon,
    Play: PlayIcon,
    Chevron: ChevronIcon,
    Close: CloseIcon,
};

const spacing = {
    default: 4,
    one: 8,
    two: 16,
    three: 24,
    four: 32,
    five: 40,
    six: 48,
    seven: 56,
    eight: 64,
    nine: 72,
    ten: 80,
    eleven: 88,
    twelve: 96,
};

const breakpoints = {
    sm: '576px', // mobile large
    md: '768px', // tablet
    lg: '992px', // desktop small
    xl: '1200px', // desktop
    xxl: '1400px', // desktop large
};

const colors = {
    green: {
        c100: 'var(--green-c100)',
        c200: 'var(--green-c200)',
        c500: 'var(--green-c500)',
        c600: 'var(--green-c600)',
        c800: 'var(--green-c800)',
    },
    pink: {
        c100: 'var(--pink-c100)',
        c200: 'var(--pink-c200)',
        c500: 'var(--pink-c500)',
        c600: 'var(--pink-c600)',
        c800: 'var(--pink-c800)',
    },
    purple: {
        c100: 'var(--purple-c100)',
        c200: 'var(--purple-c200)',
        c500: 'var(--purple-c500)',
        c600: 'var(--purple-c600)',
        c800: 'var(--purple-c800)',
    },
    blue: {
        c100: 'var(--blue-c100)',
        c200: 'var(--blue-c200)',
        c500: 'var(--blue-c500)',
        c600: 'var(--blue-c600)',
        c800: 'var(--blue-c800)',
    },
    yellow: {
        c100: 'var(--yellow-c100)',
        c200: 'var(--yellow-c200)',
        c500: 'var(--yellow-c500)',
        c600: 'var(--yellow-c600)',
        c800: 'var(--yellow-c800)',
    },
    black: {
        o00: 'var(--black-o00)',
        o10: 'var(--black-o10)',
        o20: 'var(--black-o20)',
        o30: 'var(--black-o30)',
        o35: 'var(--black-o35)',
        o50: 'var(--black-o50)',
        o80: 'var(--black-o80)',
        o95: 'var(--black-o95)',
        c500: 'var(--black-c500)',
    },
    white: {
        o00: 'var(--white-o00)',
        o10: 'var(--white-o10)',
        o20: 'var(--white-o20)',
        o30: 'var(--white-o30)',
        o35: 'var(--white-o35)',
        o50: 'var(--white-o50)',
        o60: 'var(--white-o60)',
        o80: 'var(--white-o80)',
        o95: 'var(--white-o95)',
        c500: 'var(--white-c500)',
    },
    grey: {
        c100: 'var(--grey-c100)',
        c200: 'var(--grey-c200)',
        c500: 'var(--grey-c500)',
        c600: 'var(--grey-c600)',
        c800: 'var(--grey-c800)',
    },
    blueGrey: {
        c200: 'var(--blueGrey-c200)',
        c500: 'var(--blueGrey-c500)',
    },
    error: {
        c500: 'var(--error-c500)',
    },
    success: {
        c500: 'var(--success-c500)',
    },
    // for sleep theme
    sleep: {
        beige: {
            '-c100': 'var(--sleep-beige--c100)',
            c000: 'var(--sleep-beige-c000)',
            c100: 'var(--sleep-beige-c100)',
            c200: 'var(--sleep-beige-c200)',
            c300: 'var(--sleep-beige-c300)',
            c400: 'var(--sleep-beige-c400)',
            c500: 'var(--sleep-beige-c500)',
            c600: 'var(--sleep-beige-c600)',
            c700: 'var(--sleep-beige-c700)',
            c800: 'var(--sleep-beige-c800)',
            c900: 'var(--sleep-beige-c900)',
            c1000: 'var(--sleep-beige-c1000)',
            c1100: 'var(--sleep-beige-c1100)',
        },
        red: {
            c000: 'var(--sleep-red-c000)',
            c100: 'var(--sleep-red-c100)',
            c200: 'var(--sleep-red-c200)',
            c300: 'var(--sleep-red-c300)',
            c400: 'var(--sleep-red-c400)',
            c500: 'var(--sleep-red-c500)',
            c600: 'var(--sleep-red-c600)',
            c700: 'var(--sleep-red-c700)',
            c800: 'var(--sleep-red-c800)',
            c900: 'var(--sleep-red-c900)',
            c1000: 'var(--sleep-red-c1000)',
        },
        blue: {
            c000: 'var(--sleep-blue-c000)',
            c100: 'var(--sleep-blue-c100)',
            c200: 'var(--sleep-blue-c200)',
            c300: 'var(--sleep-blue-c300)',
            c400: 'var(--sleep-blue-c400)',
            c500: 'var(--sleep-blue-c500)',
            c600: 'var(--sleep-blue-c600)',
            c700: 'var(--sleep-blue-c700)',
            c800: 'var(--sleep-blue-c800)',
            c900: 'var(--sleep-blue-c900)',
            c1000: 'var(--sleep-blue-c1000)',
            c770: 'var(--sleep-blue-c770)',
            c790: 'var(--sleep-blue-c790)',
            c850: 'var(--sleep-blue-c850)',
        },
        grey: {
            c200: 'var(--sleep-grey-c200)',
            c500: 'var(--sleep-grey-c500)',
        },
        error: {
            c100: 'var(--sleep-error-c100)',
            c500: 'var(--sleep-error-c500)',
        },
        success: {
            c100: 'var(--sleep-success-c100)',
            c500: 'var(--sleep-success-c500)',
        },
    },
};
const primaryColors = ['green', 'purple', 'pink', 'yellow', 'blue'];
const isPrimaryColor = (color) => {
    return primaryColors.includes(color);
};
const sleepPrimaryColors = ['blue', 'red', 'beige'];
const isSleepPrimaryColor = (color) => {
    return sleepPrimaryColors.includes(color);
};

const themeUniversal = {
    id: 'theme_universal',
    name: 'Theme Universal',
    bodyFontSize: '16px',
    fontFamily: 'Poppins-Regular',
    spacing: spacing,
    breakpoints: breakpoints,
    colors: {
        ...colors,
        menu: {
            text: colors.blueGrey.c500,
            textHover: colors.blueGrey.c200,
            textTransparent: colors.white.c500,
            background: colors.white.c500,
            collapse: colors.green.c600,
        },
        tabs: {
            textColor: colors.blueGrey.c200,
            textFocus: colors.blueGrey.c500,
        },
        input: {
            text: colors.blueGrey.c500,
            background: colors.grey.c100,
            border: colors.grey.c100,
            placeholder: colors.grey.c600,
            focus: {
                border: colors.green.c500,
                background: colors.grey.c100,
                text: colors.blueGrey.c500,
            },
            disabled: {
                text: colors.blueGrey.c500,
                background: colors.grey.c100,
                border: colors.grey.c100,
            },
            error: {
                text: colors.blueGrey.c500,
                background: colors.grey.c100,
                border: colors.error.c500,
            },
            success: {
                border: colors.success.c500,
                background: colors.white.c500,
                text: colors.blueGrey.c500,
            },
        },
        button: {
            default: {
                text: colors.white.c500,
                background: colors.green.c500,
                border: colors.green.c500,
                hoverText: colors.white.c500,
                hoverBackground: colors.green.c600,
                hoverBorder: colors.green.c600,
            },
            inverted: {
                text: colors.green.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverText: colors.white.c500,
                hoverBackground: colors.green.c600,
                hoverBorder: colors.green.c600,
            },
            outline: {
                text: colors.green.c500,
                background: colors.white.c500,
                border: colors.green.c500,
                hoverText: colors.white.c500,
                hoverBackground: colors.green.c600,
                hoverBorder: colors.green.c600,
            },
            outlineInverted: {
                text: colors.white.c500,
                background: colors.green.c500,
                border: colors.white.c500,
                hoverText: colors.white.c500,
                hoverBackground: colors.green.c600,
                hoverBorder: colors.green.c600,
            },
            disabled: {
                text: colors.white.c500,
                background: colors.grey.c500,
                border: colors.grey.c500,
                hoverText: colors.white.c500,
                hoverBackground: colors.grey.c500,
                hoverBorder: colors.grey.c500,
            },
            roundBorder: {
                text: colors.white.o80,
                background: colors.green.c500,
                border: colors.white.o80,
                activeHoverText: colors.white.c500,
                activeHoverBorder: colors.green.c600,
                activeHoverBackground: colors.green.c600,
            },
        },
        link: {
            color: colors.blueGrey.c500,
            hoverColor: colors.green.c600,
        },
        section: {
            background: colors.green.c500,
        },
        text: colors.green.c500,
        carouselIndicator: colors.green.c500,
        badge: {
            text: colors.white.c500,
            background: colors.green.c600,
        },
        slider: {
            dotsActive: colors.green.c500,
            dotsHover: colors.green.c800,
        },
    },
    appearance: {
        input: {
            fontSize: asRem(15),
            borderRadius: asRem(2),
        },
    },
};

const themeCalm = {
    id: 'theme_calm',
    name: 'Theme Calm',
    colors: {
        menu: {
            collapse: colors.blue.c600,
        },
        button: {
            default: {
                background: colors.blue.c500,
                border: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            inverted: {
                text: colors.blue.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            outline: {
                text: colors.blue.c500,
                border: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            outlineInverted: {
                background: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            roundBorder: {
                background: colors.blue.c500,
                activeHoverBackground: colors.blue.c600,
                activeHoverBorder: colors.blue.c600,
            },
        },
        link: {
            color: colors.blueGrey.c500,
            hoverColor: colors.blue.c600,
        },
        section: {
            background: colors.blue.c500,
        },
        text: colors.blue.c500,
        carouselIndicator: colors.blue.c500,
        badge: {
            background: colors.blue.c600,
        },
        slider: {
            dotsActive: colors.blue.c500,
            dotsHover: colors.blue.c800,
        },
    },
};

const themeWork = {
    id: 'theme_work',
    name: 'Theme Work',
    colors: {
        menu: {
            collapse: colors.purple.c600,
        },
        button: {
            default: {
                background: colors.purple.c500,
                border: colors.purple.c500,
                hoverBackground: colors.purple.c600,
                hoverBorder: colors.purple.c600,
            },
            inverted: {
                text: colors.purple.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverBackground: colors.purple.c600,
                hoverBorder: colors.purple.c600,
            },
            outline: {
                text: colors.purple.c500,
                border: colors.purple.c500,
                hoverBackground: colors.purple.c600,
                hoverBorder: colors.purple.c600,
            },
            outlineInverted: {
                background: colors.purple.c500,
                hoverBackground: colors.purple.c600,
                hoverBorder: colors.purple.c600,
            },
            roundBorder: {
                background: colors.purple.c500,
                activeHoverBackground: colors.purple.c600,
                activeHoverBorder: colors.purple.c600,
            },
        },
        link: {
            color: colors.blueGrey.c500,
            hoverColor: colors.purple.c600,
        },
        section: {
            background: colors.purple.c500,
        },
        text: colors.purple.c500,
        carouselIndicator: colors.purple.c500,
        badge: {
            background: colors.purple.c600,
        },
        slider: {
            dotsActive: colors.purple.c500,
        },
    },
};

const themeFeeling = {
    id: 'theme_feeling',
    name: 'Theme Feeling',
    colors: {
        menu: {
            collapse: colors.pink.c600,
        },
        button: {
            default: {
                background: colors.pink.c500,
                border: colors.pink.c500,
                hoverBackground: colors.pink.c600,
                hoverBorder: colors.pink.c600,
            },
            inverted: {
                text: colors.pink.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverBackground: colors.pink.c600,
                hoverBorder: colors.pink.c600,
            },
            outline: {
                text: colors.pink.c500,
                border: colors.pink.c500,
                hoverBackground: colors.pink.c600,
                hoverBorder: colors.pink.c600,
            },
            outlineInverted: {
                background: colors.pink.c500,
                hoverBackground: colors.pink.c600,
                hoverBorder: colors.pink.c600,
            },
            roundBorder: {
                background: colors.pink.c500,
                activeHoverBackground: colors.pink.c600,
                activeHoverBorder: colors.pink.c600,
            },
        },
        link: {
            color: colors.blueGrey.c500,
            hoverColor: colors.pink.c600,
        },
        section: {
            background: colors.pink.c500,
        },
        text: colors.pink.c500,
        carouselIndicator: colors.pink.c500,
        badge: {
            background: colors.pink.c600,
        },
        slider: {
            dotsActive: colors.pink.c500,
            dotsHover: colors.pink.c800,
        },
    },
};

const themePodcast = {
    id: 'theme_podcast',
    name: 'Theme Podcast',
    colors: {
        menu: {
            collapse: colors.yellow.c600,
        },
        button: {
            default: {
                background: colors.yellow.c500,
                border: colors.yellow.c500,
                hoverBackground: colors.yellow.c600,
                hoverBorder: colors.yellow.c600,
            },
            inverted: {
                text: colors.yellow.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverBackground: colors.yellow.c600,
                hoverBorder: colors.yellow.c600,
            },
            outline: {
                text: colors.yellow.c500,
                border: colors.yellow.c500,
                hoverBackground: colors.yellow.c600,
                hoverBorder: colors.yellow.c600,
            },
            outlineInverted: {
                background: colors.yellow.c500,
                hoverBackground: colors.yellow.c600,
                hoverBorder: colors.yellow.c600,
            },
            roundBorder: {
                background: colors.yellow.c500,
                activeHoverBackground: colors.yellow.c600,
                activeHoverBorder: colors.yellow.c600,
            },
        },
        link: {
            color: colors.blueGrey.c500,
            hoverColor: colors.yellow.c600,
        },
        section: {
            background: colors.yellow.c500,
        },
        text: colors.yellow.c500,
        carouselIndicator: colors.yellow.c500,
        badge: {
            background: colors.yellow.c600,
        },
        slider: {
            dotsActive: colors.yellow.c500,
            dotsHover: colors.yellow.c800,
        },
    },
};

const themeSleep = {
    id: 'theme_sleep',
    name: 'Theme Sleep',
    colors: {
        menu: {
            collapse: colors.blue.c600,
        },
        button: {
            default: {
                background: colors.blue.c500,
                border: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            inverted: {
                text: colors.blue.c500,
                background: colors.white.c500,
                border: colors.white.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            outline: {
                text: colors.blue.c500,
                border: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            outlineInverted: {
                background: colors.blue.c500,
                hoverBackground: colors.blue.c600,
                hoverBorder: colors.blue.c600,
            },
            roundBorder: {
                background: colors.blue.c500,
                activeHoverBackground: colors.blue.c600,
                activeHoverBorder: colors.blue.c600,
            },
        },
        link: {
            color: colors.sleep.beige.c100,
            hoverColor: colors.sleep.red.c500,
        },
        section: {
            background: 'transparent',
        },
        text: colors.blue.c500,
        carouselIndicator: colors.blue.c500,
        badge: {
            background: colors.blue.c600,
        },
        slider: {
            dotsActive: colors.sleep.beige.c000,
            dotsHover: colors.sleep.blue.c300,
        },
    },
};

const useIsTheme = (directTheme) => {
    const theme = useTheme$1();
    return theme.id === directTheme.id;
};

const Icon = ({ name, size = 'medium', onClick, color, hoverColor, className = '', children, ...props }) => {
    const isSleep = useIsTheme(themeSleep);
    const handleOnPress = (evt) => {
        if (onClick) {
            onClick(evt);
        }
    };
    let iconSizes = { sm: 24, md: 24, lg: 28 };
    switch (true) {
        case size === 'small':
            iconSizes = { sm: 15, md: 20, lg: 25 };
            break;
        case size === 'large':
            iconSizes = { sm: 45, md: 60, lg: 75 };
            break;
        case typeof size === 'number':
            iconSizes = { sm: size, md: size, lg: size };
            break;
        case typeof size === 'object':
            iconSizes = { ...iconSizes, ...size };
            break;
    }
    return (jsx(IconStyle, { ...iconSizes, className: `icon ${className}`, onClick: handleOnPress, hoverColor: hoverColor || undefined, ...props, children: name
            ? (() => {
                const IconComponent = isSleep ? IconMapSleep[name] : IconMap[name];
                return (jsx(IconComponent, { primaryColor: Array.isArray(color) ? color[0] : color, secondaryColor: Array.isArray(color) ? color[1] : color }));
            })()
            : children }));
};

const AccordionContext = createContext(undefined);
const AccordionItem = ({ header, body, index, ...props }) => {
    const context = useContext(AccordionContext);
    if (!context) {
        throw new Error('AccordionItem must be used within an Accordion');
    }
    const { openIndex, setOpenIndex } = context;
    const isOpen = openIndex === index;
    const onClick = () => setOpenIndex(openIndex === index ? null : index);
    return (jsxs(AccordionItemStyle, { className: "mime-elements-accordion-item", ...props, children: [jsxs(AccordionHeaderStyle, { className: "mime-elements-accordion-header", isOpen: isOpen, onClick: onClick, children: [header, " ", jsx(Icon, { name: "Chevron", color: colors.blueGrey.c500, size: { sm: 40, md: 45, lg: 45 } })] }), jsx(AccordionBodyStyle, { className: "mime-elements-accordion-header", isOpen: isOpen, children: body })] }, `accordion_item_${index}`));
};
const Accordion = ({ children }) => {
    const [openIndex, setOpenIndex] = useState(null);
    const clonedChildren = React__default.Children.map(children, (child, index) => {
        if (!React__default.isValidElement(child)) {
            return null;
        }
        return React__default.cloneElement(child, { index });
    });
    return (jsx(AccordionContext.Provider, { value: { openIndex, setOpenIndex }, children: jsx(AccordionStyle, { className: "mime-elements-accordion", children: clonedChildren }) }));
};

var BackgroundImageStyle = styled.div `
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${(props) => props.image});
`;

const BackgroundImage = ({ className = '', image, onClick, children, ...props }) => {
    const handleOnPress = (evt) => {
        if (onClick) {
            onClick(evt);
        }
    };
    return (jsx(BackgroundImageStyle, { image: image, className: `image ${className}`, onClick: handleOnPress, ...props, children: children }));
};

var ButtonStyle = styled.button `
  font-family: poppins-semibold;
  font-size: ${asRem(16)};
  line-height: ${asRem(20)};
  letter-spacing: ${asRem(0.3)};
  text-transform: uppercase;
  white-space: nowrap;

  height: ${asRem(60)};
  width: 100%;
  border-radius: ${asRem(8)};
  border: ${asRem(2)} solid;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  transition-duration: 0.4s;

  &.btn-w-auto {
    display: inline-flex;
    width: auto;
    padding: ${asRem(24)} ${asRem(40)} ${asRem(20)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    width: auto;
    font-size: ${asRem(14)};
    padding: ${asRem(24)} ${asRem(40)} ${asRem(20)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: ${asRem(16)};
  }

  color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.default.text)};
  border-color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.default.border)};
  background-color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.default.background)};

  &:hover {
    color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.default.hoverText)};
    border-color: ${({ theme, color }) => (color ? theme.colors[color].c600 : theme.colors.button.default.hoverBorder)};
    background-color: ${({ theme, color }) => color ? theme.colors[color].c600 : theme.colors.button.default.hoverBackground};
  }

  &.btn-inverted {
    color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.inverted.text)};
    border-color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.inverted.border)};
    background-color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.inverted.background)};
  }

  &.btn-outline {
    color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.outline.text)};
    border-color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.outline.border)};
    background-color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.outline.background)};
  }

  &.btn-outline-inverted {
    color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.outlineInverted.text)};
    border-color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.outlineInverted.border)};
    background-color: ${({ theme, color }) => color ? theme.colors[color].c500 : theme.colors.button.outlineInverted.background};
  }

  &.btn-transparent {
    color: ${({ theme, color }) => (color ? theme.colors[color].c500 : theme.colors.button.outlineInverted.text)};
    border-color: transparent;
    background-color: transparent;
  }

  &.btn-outline,
  &.btn-inverted,
  &.btn-outline-inverted {
    &:hover {
      color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.outline.hoverText)};
      border-color: ${({ theme, color }) => (color ? theme.colors[color].c600 : theme.colors.button.outline.hoverBorder)};
      background-color: ${({ theme, color }) => color ? theme.colors[color].c600 : theme.colors.button.outline.hoverBackground};
    }
  }

  &.btn-transparent {
    &:hover {
      color: ${({ theme }) => theme.colors.blueGrey.c200};
    }
  }

  &[disabled] {
    color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.disabled.text)};
    border-color: ${({ theme, color }) => (color ? theme.colors.grey.c500 : theme.colors.button.disabled.border)};
    background-color: ${({ theme, color }) => (color ? theme.colors.grey.c500 : theme.colors.button.disabled.background)};

    &:hover {
      color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.disabled.hoverText)};
      border-color: ${({ theme, color }) => (color ? theme.colors.grey.c500 : theme.colors.button.disabled.hoverBorder)};
      background-color: ${({ theme, color }) => color ? theme.colors.grey.c500 : theme.colors.button.disabled.hoverBackground};
    }
  }

  &.btn-round-border {
    border-radius: ${asRem(28)} !important;
    height: ${asRem(48)};
    font-size: ${asRem(14)};
    padding-top: ${asRem(3)};
    width: ${asRem(200)};

    color: ${({ theme, color }) => (color ? theme.colors.white.o80 : theme.colors.button.roundBorder.text)};
    border-color: ${({ theme, color }) => (color ? theme.colors.white.o80 : theme.colors.button.roundBorder.border)};
    background-color: ${({ theme, color }) => color ? theme.colors[color].c500 : theme.colors.button.roundBorder.background};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      height: ${asRem(50)};
      padding-top: ${asRem(12)};
      padding-bottom: ${asRem(11)};
      font-size: ${asRem(16)};
      padding-left: ${asRem(40)};
      padding-right: ${asRem(40)};
      white-space: nowrap;
    }

    &:hover,
    &:active,
    &:focus {
      color: ${({ theme, color }) => (color ? theme.colors.white.c500 : theme.colors.button.roundBorder.activeHoverText)};
      border-color: ${({ theme, color }) => color ? theme.colors[color].c600 : theme.colors.button.roundBorder.activeHoverBorder};
      background-color: ${({ theme, color }) => color ? theme.colors[color].c600 : theme.colors.button.roundBorder.activeHoverBackground};
    }
  }

  i.icon {
    margin-right: ${({ theme }) => asRem(theme.spacing.default)};
    align-self: center;
  }
`;

var ButtonSleepStyle = styled.button `
    font-family: var(--sleep-fontfamily2), sans-serif;
    height: ${asRem(54)};
    max-width: 100%;
    color: ${({ theme }) => theme.colors.sleep.beige['-c100']};
    text-transform: uppercase;
    font-size: ${asRem(16)};
    font-weight: 600;
    letter-spacing: ${asRem(0.9)};
    border-radius: ${asRem(50)};
    white-space: nowrap;
    text-align: center;
    transition: box-shadow 0.1s ease-in-out;
    border: none;
    line-height: ${asRem(18.75)};
    padding: ${asRem(12)} ${asRem(24)};
    width: 100%;
    margin-bottom: ${asRem(16)};
    
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: center;

    background-image: var(--sleep-gradient-red500-right);
    background-color: ${({ theme }) => theme.colors.sleep.red.c800});
    align-self: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      width: auto;
  
      padding: ${asRem(12)} ${asRem(80)};
    }

    &:hover, &:focus, &:focus-visible {
      box-shadow: inset 0 0 0 ${asRem(1)} ${({ theme }) => theme.colors.sleep.beige.c200};
      background-image: var(--sleep-gradient-red500-left);
      color: ${({ theme }) => theme.colors.sleep.beige['-c100']} !important;
    }

    &[disabled] {
      box-shadow: none;
      background-image: linear-gradient(to right, ${({ theme }) => theme.colors.sleep.red.c500}40, ${({ theme }) => theme.colors.sleep.red.c800}40);
      color: rgba(0, 0, 0, 0.25) !important;
      &:hover {
        background-image: linear-gradient(to right, ${({ theme }) => theme.colors.sleep.red.c500}40, ${({ theme }) => theme.colors.sleep.red.c800}40);
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }

    &.btn-secondary {
      box-shadow: 0 ${asRem(1)} ${asRem(4)} 0 rgba(18, 24, 31, 0.25);
      background-image: var(--sleep-gradient-blue200-right);
      background-color: ${({ theme }) => theme.colors.sleep.blue.c200};
      min-width: ${asRem(300)};
      align-self: center;
  
      &:hover {
        box-shadow: inset 0 0 0 ${asRem(1)} ${({ theme }) => theme.colors.sleep.beige.c200};
        background-image: var(--sleep-gradient-blue200-right-neg);
        color:  ${({ theme }) => theme.colors.sleep.beige.c000} !important;
      }  
    }

    i.icon {
      margin-right: ${({ theme }) => asRem(theme.spacing.default)};
      align-self: center;
    }  
`;

// https://www.figma.com/file/wBAWu7yXOmgYTKKTywxD24/Balloon-Web-Library?type=design&node-id=47-638&mode=dev
const Button$2 = ({ className = '', id, type = 'default', color, children, disabled, href, onClick, dataCyName, target = '_blank', ...props }) => {
    const isSleep = useIsTheme(themeSleep);
    const ThemeButtonStyle = isSleep ? ButtonSleepStyle : ButtonStyle;
    const handleOnClick = (evt) => {
        if (href) {
            evt.preventDefault();
            if (target === '_blank') {
                window.open(href, '_blank', 'noopener noreferrer');
            }
            else {
                window.location.href = href;
            }
            return;
        }
        onClick?.(evt);
    };
    return (jsx(ThemeButtonStyle, { id: id, className: `${className} mime-elements-button btn-${type}`, color: color, disabled: disabled, onClick: handleOnClick, "data-cy-name": dataCyName, ...props, children: children }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes$A = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$A.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$A.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$A.exports;
var PropTypes$1 = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var cx = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

function _typeof$k(obj) { "@babel/helpers - typeof"; return _typeof$k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$k(obj); }

// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? "".concat(padding, "px") : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
var globalCssModule;
function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;
  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick$1(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};
  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}
var warned$1 = {};
function warnOnce(message) {
  if (!warned$1[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned$1[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated.\n").concat(explanation));
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}

// Shim Element if needed (e.g. in Node environment)
var Element$4 = (typeof window === "undefined" ? "undefined" : _typeof$k(window)) === 'object' && window.Element || function () {};
function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element$4)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func, DOMElement, PropTypes$1.shape({
  current: PropTypes$1.any
})]);
var tagPropType = PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.string, PropTypes$1.shape({
  $$typeof: PropTypes$1.symbol,
  render: PropTypes$1.func
}), PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.string, PropTypes$1.shape({
  $$typeof: PropTypes$1.symbol,
  render: PropTypes$1.func
})]))]);

// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600,
  // $carousel-transition
  Offcanvas: 300 // $offcanvas-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && _typeof$k(target) === 'object') {
    return 'current' in target;
  }
  return false;
}
function getTag(value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }
  return Object.prototype.toString.call(value);
}
function isObject$2(value) {
  var type = _typeof$k(value);
  return value != null && (type === 'object' || type === 'function');
}
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }
  var tag = getTag(value);
  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }
  if (isFunction$1(target)) {
    return target();
  }
  if (typeof target === 'string' && canUseDOM$1) {
    var selection = document.querySelectorAll(target);
    if (!selection.length) {
      selection = document.querySelectorAll("#".concat(target));
    }
    if (!selection.length) {
      throw new Error("The target '".concat(target, "' could not be identified in the dom, tip: check spelling"));
    }
    return selection;
  }
  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }
  return Array.isArray(els) || canUseDOM$1 && typeof els.length === 'number';
}
function getTarget(target, allElements) {
  var els = findDOMElements(target);
  if (isArrayOrNodeList(els)) {
    return els[0];
  }
  return els;
}
var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal):not(.offcanvas)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];

var _excluded$D = ["className", "cssModule", "fluid", "tag"];
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
function _objectWithoutProperties$r(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$r(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$r(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$z = {
  tag: tagPropType,
  fluid: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string]),
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object
};
function Container$1(props) {
  var className = props.className,
    cssModule = props.cssModule,
    fluid = props.fluid,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    attributes = _objectWithoutProperties$r(props, _excluded$D);
  var containerClass = 'container';
  if (fluid === true) {
    containerClass = 'container-fluid';
  } else if (fluid) {
    containerClass = "container-".concat(fluid);
  }
  var classes = mapToCssModules(cx(className, containerClass), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$D({}, attributes, {
    className: classes
  }));
}
Container$1.propTypes = propTypes$z;

var _excluded$C = ["className", "cssModule", "noGutters", "tag", "widths"];
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
function _objectWithoutProperties$q(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$q(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$q(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var rowColsPropType = PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]);
var propTypes$y = {
  tag: tagPropType,
  noGutters: deprecated(PropTypes$1.bool, 'Please use Bootstrap 5 gutter utility classes. https://getbootstrap.com/docs/5.0/layout/gutters/'),
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType,
  xxl: rowColsPropType,
  widths: PropTypes$1.array
};
function Row$1(props) {
  var className = props.className,
    cssModule = props.cssModule,
    noGutters = props.noGutters,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    _props$widths = props.widths,
    widths = _props$widths === void 0 ? rowColWidths : _props$widths,
    attributes = _objectWithoutProperties$q(props, _excluded$C);
  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var colSize = props[colWidth];
    delete attributes[colWidth];
    if (!colSize) {
      return;
    }
    var isXs = !i;
    colClasses.push(isXs ? "row-cols-".concat(colSize) : "row-cols-".concat(colWidth, "-").concat(colSize));
  });
  var classes = mapToCssModules(cx(className, noGutters ? 'gx-0' : null, 'row', colClasses), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$C({}, attributes, {
    className: classes
  }));
}
Row$1.propTypes = propTypes$y;

var _excluded$B = ["className", "cssModule", "widths", "tag"];
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
function _objectWithoutProperties$p(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$p(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$p(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var stringOrNumberProp$1 = PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]);
var columnProps$1 = PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.number, PropTypes$1.string, PropTypes$1.shape({
  size: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.number, PropTypes$1.string]),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);
var propTypes$x = {
  tag: tagPropType,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  xxl: columnProps$1,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  widths: PropTypes$1.array
};
var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-".concat(colWidth);
  }
  if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-".concat(colWidth, "-auto");
  }
  return isXs ? "col-".concat(colSize) : "col-".concat(colWidth, "-").concat(colSize);
};
var getColumnClasses = function getColumnClasses(attributes, cssModule) {
  var widths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : colWidths$1;
  var modifiedAttributes = attributes;
  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = modifiedAttributes[colWidth];
    delete modifiedAttributes[colWidth];
    if (!columnProp && columnProp !== '') {
      return;
    }
    var isXs = !i;
    if (isObject$2(columnProp)) {
      var _classNames;
      var colSizeInterfix = isXs ? '-' : "-".concat(colWidth, "-");
      var colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(cx((_classNames = {}, _defineProperty$i(_classNames, colClass, columnProp.size || columnProp.size === ''), _defineProperty$i(_classNames, "order".concat(colSizeInterfix).concat(columnProp.order), columnProp.order || columnProp.order === 0), _defineProperty$i(_classNames, "offset".concat(colSizeInterfix).concat(columnProp.offset), columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });
  return {
    colClasses: colClasses,
    modifiedAttributes: modifiedAttributes
  };
};
function Col$1(props) {
  var className = props.className,
    cssModule = props.cssModule,
    _props$widths = props.widths,
    widths = _props$widths === void 0 ? colWidths$1 : _props$widths,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    attributes = _objectWithoutProperties$p(props, _excluded$B);
  var _getColumnClasses = getColumnClasses(attributes, cssModule, widths),
    modifiedAttributes = _getColumnClasses.modifiedAttributes,
    colClasses = _getColumnClasses.colClasses;
  if (!colClasses.length) {
    colClasses.push('col');
  }
  var classes = mapToCssModules(cx(className, colClasses), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$B({}, modifiedAttributes, {
    className: classes
  }));
}
Col$1.propTypes = propTypes$x;

var _excluded$A = ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "container", "tag", "children"];
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$o(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$o(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$o(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$w = {
  children: PropTypes$1.node,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Theme the navbar by adding a background color  */
  color: PropTypes$1.string,
  /** Use any of the responsive containers to change how wide the content in your navbar is presented. */
  container: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string]),
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** This prop is passed if the background is dark, to make the text lighter */
  dark: PropTypes$1.bool,
  /** Determine if to show toggler button */
  expand: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string]),
  /** Make the navbar fixed at the top */
  fixed: PropTypes$1.string,
  /** Add `.navbar-light` class */
  light: PropTypes$1.bool,
  role: PropTypes$1.string,
  /** Use `position: sticky` which isn't fully supported in every browser */
  sticky: PropTypes$1.string,
  /** Set a custom element for this component */
  tag: tagPropType
};
var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  }
  if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }
  return "navbar-expand-".concat(expand);
};
function Navbar(props) {
  var _classNames;
  var _props$expand = props.expand,
    expand = _props$expand === void 0 ? false : _props$expand,
    className = props.className,
    cssModule = props.cssModule,
    light = props.light,
    dark = props.dark,
    fixed = props.fixed,
    sticky = props.sticky,
    color = props.color,
    _props$container = props.container,
    container = _props$container === void 0 ? 'fluid' : _props$container,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'nav' : _props$tag,
    children = props.children,
    attributes = _objectWithoutProperties$o(props, _excluded$A);
  var classes = mapToCssModules(cx(className, 'navbar', getExpandClass(expand), (_classNames = {
    'navbar-light': light,
    'navbar-dark': dark
  }, _defineProperty$h(_classNames, "bg-".concat(color), color), _defineProperty$h(_classNames, "fixed-".concat(fixed), fixed), _defineProperty$h(_classNames, "sticky-".concat(sticky), sticky), _classNames)), cssModule);
  var containerClass = container && container === true ? 'container' : "container-".concat(container);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$A({}, attributes, {
    className: classes
  }), container ? /*#__PURE__*/React__default.createElement("div", {
    className: containerClass
  }, children) : children);
}
Navbar.propTypes = propTypes$w;

var _excluded$z = ["className", "cssModule", "tag"];
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
function _objectWithoutProperties$n(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$n(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$n(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$v = {
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function NavbarBrand$1(props) {
  var className = props.className,
    cssModule = props.cssModule,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'a' : _props$tag,
    attributes = _objectWithoutProperties$n(props, _excluded$z);
  var classes = mapToCssModules(cx(className, 'navbar-brand'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$z({}, attributes, {
    className: classes
  }));
}
NavbarBrand$1.propTypes = propTypes$v;

var _excluded$y = ["className", "cssModule", "children", "tag"];
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty$g(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$m(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$m(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$m(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$u = {
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Set a custom element for this component */
  tag: tagPropType,
  type: PropTypes$1.string,
  /** Pass children so this component can wrap the child elements */
  children: PropTypes$1.node
};
function NavbarToggler(props) {
  var className = props.className,
    cssModule = props.cssModule,
    children = props.children,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'button' : _props$tag,
    attributes = _objectWithoutProperties$m(props, _excluded$y);
  var classes = mapToCssModules(cx(className, 'navbar-toggler'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$y({
    "aria-label": "Toggle navigation"
  }, _objectSpread$n({
    type: 'button'
  }, attributes), {
    className: classes
  }), children || /*#__PURE__*/React__default.createElement("span", {
    className: mapToCssModules('navbar-toggler-icon', cssModule)
  }));
}
NavbarToggler.propTypes = propTypes$u;

var _excluded$x = ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"];
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
function _objectWithoutProperties$l(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$l(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$l(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$t = {
  /** Adding card prop adds `.card-header-tabs` or `.card-header-pills` class */
  card: PropTypes$1.bool,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** fills the nav to extend to full available width */
  fill: PropTypes$1.bool,
  /** Change the horizontal alignment of your nav */
  horizontal: PropTypes$1.oneOf(['center', 'end']),
  /**  All horizontal space will be occupied by nav links, but unlike the `fill` above, every nav item will be the same width. */
  justified: PropTypes$1.bool,
  /** Add navbar for a full-height and lightweight navigation */
  navbar: PropTypes$1.bool,
  /** Make NavItems look like pills */
  pills: PropTypes$1.bool,
  /** Make NavItems look like tabs */
  tabs: PropTypes$1.bool,
  /** Set a custom element for this component */
  tag: tagPropType,
  /** Stack your navigation by changing the flex item direction */
  vertical: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string])
};
var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  }
  if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }
  return "flex-".concat(vertical, "-column");
};
function Nav(props) {
  var className = props.className,
    cssModule = props.cssModule,
    tabs = props.tabs,
    pills = props.pills,
    _props$vertical = props.vertical,
    vertical = _props$vertical === void 0 ? false : _props$vertical,
    horizontal = props.horizontal,
    justified = props.justified,
    fill = props.fill,
    navbar = props.navbar,
    card = props.card,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'ul' : _props$tag,
    attributes = _objectWithoutProperties$l(props, _excluded$x);
  var classes = mapToCssModules(cx(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-".concat(horizontal) : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$x({}, attributes, {
    className: classes
  }));
}
Nav.propTypes = propTypes$t;

var _excluded$w = ["className", "cssModule", "active", "tag"];
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
function _objectWithoutProperties$k(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$k(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$k(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$s = {
  /** Add active class to element */
  active: PropTypes$1.bool,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function NavItem$1(props) {
  var className = props.className,
    cssModule = props.cssModule,
    active = props.active,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'li' : _props$tag,
    attributes = _objectWithoutProperties$k(props, _excluded$w);
  var classes = mapToCssModules(cx(className, 'nav-item', active ? 'active' : false), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$w({}, attributes, {
    className: classes
  }));
}
NavItem$1.propTypes = propTypes$s;

function _typeof$j(obj) { "@babel/helpers - typeof"; return _typeof$j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$j(obj); }
var _excluded$v = ["className", "cssModule", "active", "tag", "innerRef"];
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
function _objectWithoutProperties$j(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$j(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$j(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$i(subClass, superClass); }
function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }
function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf$i(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$i(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$o(this, result); }; }
function _possibleConstructorReturn$o(self, call) { if (call && (_typeof$j(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$i(self); }
function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }
var propTypes$r = {
  /** Add active class to NavLink */
  active: PropTypes$1.bool,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Disable the link */
  disabled: PropTypes$1.bool,
  href: PropTypes$1.any,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func, PropTypes$1.string]),
  /** Function to be triggered on click */
  onClick: PropTypes$1.func,
  /** Set a custom element for this component */
  tag: tagPropType
};
var NavLink$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$o(NavLink, _React$Component);
  var _super = _createSuper$j(NavLink);
  function NavLink(props) {
    var _this;
    _classCallCheck$o(this, NavLink);
    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(_assertThisInitialized$i(_this));
    return _this;
  }
  _createClass$n(NavLink, [{
    key: "onClick",
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }
      if (this.props.href === '#') {
        e.preventDefault();
      }
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        active = _this$props.active,
        _this$props$tag = _this$props.tag,
        Tag = _this$props$tag === void 0 ? 'a' : _this$props$tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutProperties$j(_this$props, _excluded$v);
      var classes = mapToCssModules(cx(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);
      return /*#__PURE__*/React__default.createElement(Tag, _extends$v({}, attributes, {
        ref: innerRef,
        onClick: this.onClick,
        className: classes
      }));
    }
  }]);
  return NavLink;
}(React__default.Component);
NavLink$1.propTypes = propTypes$r;

var _excluded$u = ["className", "cssModule", "variant", "innerRef"];
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty$f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$i(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$i(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$i(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$q = {
  /** Disable the button if needed */
  active: PropTypes$1.bool,
  /** Aria label */
  'aria-label': PropTypes$1.string,
  /** Function to be triggered on click */
  onClick: PropTypes$1.func,
  /** Change the variant to white */
  variant: PropTypes$1.oneOf(['white']),
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string, PropTypes$1.func])
};
function CloseButton(props) {
  var className = props.className;
    props.cssModule;
    var variant = props.variant,
    innerRef = props.innerRef,
    attributes = _objectWithoutProperties$i(props, _excluded$u);
  var classes = mapToCssModules(cx(className, 'btn-close', variant && "btn-close-".concat(variant)));
  return /*#__PURE__*/React__default.createElement("button", _extends$u({
    ref: innerRef,
    type: "button",
    className: classes
  }, _objectSpread$m({
    'aria-label': 'close'
  }, attributes)));
}
CloseButton.propTypes = propTypes$q;

var _excluded$t = ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"];
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
function _objectWithoutProperties$h(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$h(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$h(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$p = {
  /** Manually set the visual state of the button to active */
  active: PropTypes$1.bool,
  /** Aria label */
  'aria-label': PropTypes$1.string,
  block: PropTypes$1.bool,
  /** Pass children so this component can wrap them */
  children: PropTypes$1.node,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change existing className with a new className */
  cssModule: PropTypes$1.object,
  /** Use the button as a close button */
  close: PropTypes$1.bool,
  /** Change color of Button to one of the available colors */
  color: PropTypes$1.string,
  /** Disables the button */
  disabled: PropTypes$1.bool,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func, PropTypes$1.string]),
  /** Function to be triggered on click */
  onClick: PropTypes$1.func,
  /** Adds outline to the button */
  outline: PropTypes$1.bool,
  /** Make the button bigger or smaller */
  size: PropTypes$1.string,
  /** Set a custom element for this component */
  tag: tagPropType
};
function Button$1(props) {
  var onClick = useCallback(function (e) {
    if (props.disabled) {
      e.preventDefault();
      return;
    }
    if (props.onClick) {
      return props.onClick(e);
    }
  }, [props.onClick, props.disabled]);
  var active = props.active,
    ariaLabel = props['aria-label'],
    block = props.block,
    className = props.className,
    close = props.close,
    cssModule = props.cssModule,
    _props$color = props.color,
    color = _props$color === void 0 ? 'secondary' : _props$color,
    outline = props.outline,
    size = props.size,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'button' : _props$tag,
    innerRef = props.innerRef,
    attributes = _objectWithoutProperties$h(props, _excluded$t);
  if (close) {
    return /*#__PURE__*/React__default.createElement(CloseButton, attributes);
  }
  var btnOutlineColor = "btn".concat(outline ? '-outline' : '', "-").concat(color);
  var classes = mapToCssModules(cx(className, 'btn', btnOutlineColor, size ? "btn-".concat(size) : false, block ? 'd-block w-100' : false, {
    active: active,
    disabled: props.disabled
  }), cssModule);
  if (attributes.href && Tag === 'button') {
    Tag = 'a';
  }
  return /*#__PURE__*/React__default.createElement(Tag, _extends$t({
    type: Tag === 'button' && attributes.onClick ? 'button' : undefined
  }, attributes, {
    className: classes,
    ref: innerRef,
    onClick: onClick,
    "aria-label": ariaLabel
  }));
}
Button$1.propTypes = propTypes$p;

var ManagerReferenceNodeContext = React$1.createContext();
var ManagerReferenceNodeSetterContext = React$1.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React$1.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = React$1.useRef(false);
  React$1.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React$1.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React$1.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React$1.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React$1.useLayoutEffect : React$1.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains$1(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$2(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React$1.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React$1.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React$1.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React$1.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (isEqual$1(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React$1.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React$1.useContext(ManagerReferenceNodeContext);

  var _React$useState = React$1.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React$1.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React$1.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React$1.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React$1.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var warning$1 = /*@__PURE__*/getDefaultExportFromCjs(warning_1);

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React$1.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React$1.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React$1.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  React$1.useEffect(function () {
    warning$1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'start', 'end']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */
var DropdownContext = /*#__PURE__*/React__default.createContext({});

var InputGroupContext = /*#__PURE__*/React__default.createContext({});

function _typeof$i(obj) { "@babel/helpers - typeof"; return _typeof$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$i(obj); }
var _excluded$s = ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "tag", "menuRole"];
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$g(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$g(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$g(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$h(subClass, superClass); }
function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }
function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf$h(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$h(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$n(this, result); }; }
function _possibleConstructorReturn$n(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$h(self); }
function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }
var propTypes$o = {
  a11y: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  direction: PropTypes$1.oneOf(['up', 'down', 'start', 'end', 'left', 'right']),
  group: PropTypes$1.bool,
  isOpen: PropTypes$1.bool,
  nav: PropTypes$1.bool,
  active: PropTypes$1.bool,
  size: PropTypes$1.string,
  tag: tagPropType,
  toggle: PropTypes$1.func,
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  dropup: PropTypes$1.bool,
  inNavbar: PropTypes$1.bool,
  setActiveFromChild: PropTypes$1.bool,
  menuRole: PropTypes$1.oneOf(['listbox', 'menu'])
};
var defaultProps$8 = {
  a11y: true,
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  inNavbar: false,
  setActiveFromChild: false
};
var preventDefaultKeys = [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down, keyCodes.end, keyCodes.home];
var Dropdown$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$n(Dropdown, _React$Component);
  var _super = _createSuper$i(Dropdown);
  function Dropdown(props) {
    var _this;
    _classCallCheck$n(this, Dropdown);
    _this = _super.call(this, props);
    _this.addEvents = _this.addEvents.bind(_assertThisInitialized$h(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized$h(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized$h(_this));
    _this.removeEvents = _this.removeEvents.bind(_assertThisInitialized$h(_this));
    _this.toggle = _this.toggle.bind(_assertThisInitialized$h(_this));
    _this.handleMenuRef = _this.handleMenuRef.bind(_assertThisInitialized$h(_this));
    _this.handleToggleRef = _this.handleToggleRef.bind(_assertThisInitialized$h(_this));
    _this.containerRef = /*#__PURE__*/React__default.createRef();
    _this.menuRef = /*#__PURE__*/React__default.createRef();
    _this.toggleRef = /*#__PURE__*/React__default.createRef();
    // ref for DropdownToggle
    return _this;
  }
  _createClass$m(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: "handleMenuRef",
    value: function handleMenuRef(menuRef) {
      this.menuRef.current = menuRef;
    }
  }, {
    key: "handleToggleRef",
    value: function handleToggleRef(toggleRef) {
      this.toggleRef.current = toggleRef;
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();
      var menu = this.getMenu();
      var toggle = this.getToggle();

      // Add a conditional check to avoid using toggle 
      // if there is no toggle component in the dropdown
      if (!toggle) {
        return;
      }
      var targetIsToggle = toggle.contains(e.target);
      var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
      var clickIsInInput = false;
      if (container) {
        // This is only for InputGroup with type dropdown
        clickIsInInput = container.classList.contains('input-group') && container.classList.contains('dropdown') && e.target.tagName === 'INPUT';
      }
      if ((targetIsToggle && !clickIsInInput || clickIsInMenu) && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }
      this.toggle(e);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this2 = this;
      var isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
      var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
      var isTab = keyCodes.tab === e.which;
      if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
        return;
      }
      if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
        e.preventDefault();
      }
      if (this.props.disabled) return;
      if (isTargetMenuCtrl) {
        if ([keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
          // Open the menu (if not open) and focus the first menu item
          if (!this.props.isOpen) {
            this.toggle(e);
          }
          setTimeout(function () {
            var _this2$getMenuItems$;
            return (_this2$getMenuItems$ = _this2.getMenuItems()[0]) === null || _this2$getMenuItems$ === void 0 ? void 0 : _this2$getMenuItems$.focus();
          });
        } else if (this.props.isOpen && isTab) {
          var _this$getMenuItems$;
          // Focus the first menu item if tabbing from an open menu. We need this
          // for cases where the DropdownMenu sets a custom container, which may
          // not be the natural next item to tab to from the DropdownToggle.
          e.preventDefault();
          (_this$getMenuItems$ = this.getMenuItems()[0]) === null || _this$getMenuItems$ === void 0 ? void 0 : _this$getMenuItems$.focus();
        } else if (this.props.isOpen && e.which === keyCodes.esc) {
          this.toggle(e);
        }
      }
      if (this.props.isOpen && isTargetMenuItem) {
        if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
          this.toggle(e);
          this.getMenuCtrl().focus();
        } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
          e.target.click();
          this.getMenuCtrl().focus();
        } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
          var $menuitems = this.getMenuItems();
          var index = $menuitems.indexOf(e.target);
          if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
            index = index !== 0 ? index - 1 : $menuitems.length - 1;
          } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
            index = index === $menuitems.length - 1 ? 0 : index + 1;
          }
          $menuitems[index].focus();
        } else if (keyCodes.end === e.which) {
          var _$menuitems = this.getMenuItems();
          _$menuitems[_$menuitems.length - 1].focus();
        } else if (keyCodes.home === e.which) {
          var _$menuitems2 = this.getMenuItems();
          _$menuitems2[0].focus();
        } else if (e.which >= 48 && e.which <= 90) {
          var _$menuitems3 = this.getMenuItems();
          var charPressed = String.fromCharCode(e.which).toLowerCase();
          for (var i = 0; i < _$menuitems3.length; i += 1) {
            var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
            if (firstLetter === charPressed) {
              _$menuitems3[i].focus();
              break;
            }
          }
        }
      }
    }
  }, {
    key: "handleProps",
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: "getContextValue",
    value: function getContextValue() {
      return {
        toggle: this.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar,
        disabled: this.props.disabled,
        // Callback that should be called by DropdownMenu to provide a ref to
        // a HTML tag that's used for the DropdownMenu
        onMenuRef: this.handleMenuRef,
        onToggleRef: this.handleToggleRef,
        menuRole: this.props.menuRole
      };
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.containerRef.current;
    }
  }, {
    key: "getMenu",
    value: function getMenu() {
      return this.menuRef.current;
    }
  }, {
    key: "getToggle",
    value: function getToggle() {
      return this.toggleRef.current;
    }
  }, {
    key: "getMenuCtrl",
    value: function getMenuCtrl() {
      if (this._$menuCtrl) return this._$menuCtrl;
      this._$menuCtrl = this.getToggle();
      return this._$menuCtrl;
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      if (this.props.menuRole === 'listbox') {
        return 'option';
      }
      return 'menuitem';
    }
  }, {
    key: "getMenuItems",
    value: function getMenuItems() {
      // In a real menu with a child DropdownMenu, `this.getMenu()` should never
      // be null, but it is sometimes null in tests. To mitigate that, we just
      // use `this.getContainer()` as the fallback `menuContainer`.
      var menuContainer = this.getMenu() || this.getContainer();
      return [].slice.call(menuContainer.querySelectorAll("[role=\"".concat(this.getItemType(), "\"]")));
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var _this3 = this;
      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      var _this4 = this;
      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this4.handleDocumentClick, true);
      });
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }
      return this.props.toggle(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
        _this5 = this;
      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        direction = _omit.direction,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        tag = _omit.tag;
        _omit.menuRole;
        var attrs = _objectWithoutProperties$g(_omit, _excluded$s);
      var Tag = tag || (nav ? 'li' : 'div');
      var subItemIsActive = false;
      if (setActiveFromChild) {
        React__default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
          if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
        });
      }
      var classes = mapToCssModules(cx(className, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {
        'btn-group': group
      }, _defineProperty$e(_classNames, "btn-group-".concat(size), !!size), _defineProperty$e(_classNames, "dropdown", !group), _defineProperty$e(_classNames, "dropup", direction === 'up'), _defineProperty$e(_classNames, "dropstart", direction === 'start' || direction === 'left'), _defineProperty$e(_classNames, "dropend", direction === 'end' || direction === 'right'), _defineProperty$e(_classNames, "show", isOpen), _defineProperty$e(_classNames, 'nav-item', nav), _classNames)), cssModule);
      if (this.context.insideInputGroup) {
        return /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
          value: this.getContextValue()
        }, /*#__PURE__*/React__default.createElement(Manager, null, React__default.Children.map(this.props.children, function (child) {
          return /*#__PURE__*/React__default.cloneElement(child, {
            onKeyDown: _this5.handleKeyDown
          });
        })));
      }
      return /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
        value: this.getContextValue()
      }, /*#__PURE__*/React__default.createElement(Manager, null, /*#__PURE__*/React__default.createElement(Tag, _extends$s({}, attrs, _defineProperty$e({}, typeof Tag === 'string' ? 'ref' : 'innerRef', this.containerRef), {
        onKeyDown: this.handleKeyDown,
        className: classes
      }))));
    }
  }]);
  return Dropdown;
}(React__default.Component);
Dropdown$2.propTypes = propTypes$o;
Dropdown$2.defaultProps = defaultProps$8;
Dropdown$2.contextType = InputGroupContext;

function _typeof$h(obj) { "@babel/helpers - typeof"; return _typeof$h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$h(obj); }
var _excluded$r = ["className", "cssModule", "divider", "tag", "header", "active", "text"];
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$g(subClass, superClass); }
function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }
function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf$g(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$g(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$m(this, result); }; }
function _possibleConstructorReturn$m(self, call) { if (call && (_typeof$h(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$g(self); }
function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }
var propTypes$n = {
  children: PropTypes$1.node,
  active: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  divider: PropTypes$1.bool,
  tag: tagPropType,
  header: PropTypes$1.bool,
  onClick: PropTypes$1.func,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  toggle: PropTypes$1.bool,
  text: PropTypes$1.bool
};
var DropdownItem$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$m(DropdownItem, _React$Component);
  var _super = _createSuper$h(DropdownItem);
  function DropdownItem(props) {
    var _this;
    _classCallCheck$m(this, DropdownItem);
    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(_assertThisInitialized$g(_this));
    _this.getTabIndex = _this.getTabIndex.bind(_assertThisInitialized$g(_this));
    return _this;
  }
  _createClass$l(DropdownItem, [{
    key: "onClick",
    value: function onClick(e) {
      var _this$props$toggle;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        header = _this$props.header,
        divider = _this$props.divider,
        text = _this$props.text;
      if (disabled || header || divider || text) {
        e.preventDefault();
        return;
      }
      if (this.props.onClick) {
        this.props.onClick(e);
      }
      if ((_this$props$toggle = this.props.toggle) !== null && _this$props$toggle !== void 0 ? _this$props$toggle : true) {
        this.context.toggle(e);
      }
    }
  }, {
    key: "getRole",
    value: function getRole() {
      if (this.context.menuRole === 'listbox') {
        return 'option';
      }
      return 'menuitem';
    }
  }, {
    key: "getTabIndex",
    value: function getTabIndex() {
      var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        header = _this$props2.header,
        divider = _this$props2.divider,
        text = _this$props2.text;
      if (disabled || header || divider || text) {
        return '-1';
      }
      return '0';
    }
  }, {
    key: "render",
    value: function render() {
      var tabIndex = this.getTabIndex();
      var role = tabIndex > -1 ? this.getRole() : undefined;
      var _omit = omit(this.props, ['toggle']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        divider = _omit.divider,
        _omit$tag = _omit.tag,
        Tag = _omit$tag === void 0 ? 'button' : _omit$tag,
        header = _omit.header,
        active = _omit.active,
        text = _omit.text,
        props = _objectWithoutProperties$f(_omit, _excluded$r);
      var classes = mapToCssModules(cx(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header && !text,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider,
        'dropdown-item-text': text
      }), cssModule);
      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        } else if (text) {
          Tag = 'span';
        }
      }
      return /*#__PURE__*/React__default.createElement(Tag, _extends$r({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        role: role,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(React__default.Component);
DropdownItem$2.propTypes = propTypes$n;
DropdownItem$2.contextType = DropdownContext;

function _typeof$g(obj) { "@babel/helpers - typeof"; return _typeof$g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$g(obj); }
var _excluded$q = ["className", "cssModule", "dark", "end", "right", "tag", "flip", "modifiers", "persist", "strategy", "container", "updateOnSelect"];
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$f(subClass, superClass); }
function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }
function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf$f(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$f(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$l(this, result); }; }
function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$f(self); }
function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }
var propTypes$m = {
  tag: tagPropType,
  children: PropTypes$1.node.isRequired,
  dark: PropTypes$1.bool,
  end: PropTypes$1.bool,
  /** Flips the menu to the opposite side if there is not enough space to fit */
  flip: PropTypes$1.bool,
  modifiers: PropTypes$1.array,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  style: PropTypes$1.object,
  persist: PropTypes$1.bool,
  strategy: PropTypes$1.string,
  container: targetPropType,
  /** Update popper layout when a click event comes up. This leverages event bubbling. */
  updateOnSelect: PropTypes$1.bool,
  right: deprecated(PropTypes$1.bool, 'Please use "end" instead.')
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  start: 'left',
  end: 'right',
  down: 'bottom'
};
var DropdownMenu$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$l(DropdownMenu, _React$Component);
  var _super = _createSuper$g(DropdownMenu);
  function DropdownMenu() {
    _classCallCheck$l(this, DropdownMenu);
    return _super.apply(this, arguments);
  }
  _createClass$k(DropdownMenu, [{
    key: "getRole",
    value: function getRole() {
      if (this.context.menuRole === 'listbox') {
        return 'listbox';
      }
      return 'menu';
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        dark = _this$props.dark,
        end = _this$props.end,
        right = _this$props.right,
        _this$props$tag = _this$props.tag,
        tag = _this$props$tag === void 0 ? 'div' : _this$props$tag,
        _this$props$flip = _this$props.flip,
        flip = _this$props$flip === void 0 ? true : _this$props$flip,
        _this$props$modifiers = _this$props.modifiers,
        modifiers = _this$props$modifiers === void 0 ? [] : _this$props$modifiers,
        persist = _this$props.persist,
        strategy = _this$props.strategy,
        container = _this$props.container,
        updateOnSelect = _this$props.updateOnSelect,
        attrs = _objectWithoutProperties$e(_this$props, _excluded$q);
      var classes = mapToCssModules(cx(className, 'dropdown-menu', {
        'dropdown-menu-dark': dark,
        'dropdown-menu-end': end || right,
        show: this.context.isOpen
      }), cssModule);
      var Tag = tag;
      if (persist || this.context.isOpen && !this.context.inNavbar) {
        var position1 = directionPositionMap[this.context.direction] || 'bottom';
        var position2 = end || right ? 'end' : 'start';
        var poperPlacement = "".concat(position1, "-").concat(position2);
        var poperModifiers = [].concat(_toConsumableArray(modifiers), [{
          name: 'flip',
          enabled: !!flip
        }]);
        var persistStyles = {};
        if (persist) {
          persistStyles.display = 'block';
          persistStyles.visibility = this.context.isOpen ? 'visible' : 'hidden';
        }
        var popper = /*#__PURE__*/React__default.createElement(Popper, {
          placement: poperPlacement,
          modifiers: poperModifiers,
          strategy: strategy
        }, function (_ref) {
          var ref = _ref.ref,
            style = _ref.style,
            placement = _ref.placement,
            update = _ref.update;
          var combinedStyle = _objectSpread$l(_objectSpread$l(_objectSpread$l({}, _this.props.style), persistStyles), style);
          var handleRef = function handleRef(tagRef) {
            // Send the ref to `react-popper`
            ref(tagRef);
            // Send the ref to the parent Dropdown so that clicks outside
            // it will cause it to close
            var onMenuRef = _this.context.onMenuRef;
            if (onMenuRef) onMenuRef(tagRef);
          };
          return /*#__PURE__*/React__default.createElement(Tag, _extends$q({
            tabIndex: "-1",
            role: _this.getRole(),
            ref: handleRef
          }, attrs, {
            style: combinedStyle,
            "aria-hidden": !_this.context.isOpen,
            className: classes,
            "data-popper-placement": placement,
            onClick: function onClick() {
              return updateOnSelect && update();
            }
          }));
        });
        if (container) {
          return /*#__PURE__*/ReactDOM__default.createPortal(popper, getTarget(container));
        }
        return popper;
      }
      var onMenuRef = this.context.onMenuRef;
      return /*#__PURE__*/React__default.createElement(Tag, _extends$q({
        tabIndex: "-1",
        role: this.getRole()
      }, attrs, {
        ref: onMenuRef,
        "aria-hidden": !this.context.isOpen,
        className: classes,
        "data-popper-placement": attrs.placement,
        "data-bs-popper": "static"
      }));
    }
  }]);
  return DropdownMenu;
}(React__default.Component);
DropdownMenu$2.propTypes = propTypes$m;
DropdownMenu$2.contextType = DropdownContext;

function _typeof$f(obj) { "@babel/helpers - typeof"; return _typeof$f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$f(obj); }
var _excluded$p = ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"];
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$d(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$e(subClass, superClass); }
function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }
function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf$e(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$e(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$k(this, result); }; }
function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$e(self); }
function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }
var propTypes$l = {
  caret: PropTypes$1.bool,
  color: PropTypes$1.string,
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  disabled: PropTypes$1.bool,
  onClick: PropTypes$1.func,
  'aria-haspopup': PropTypes$1.bool,
  split: PropTypes$1.bool,
  tag: tagPropType,
  nav: PropTypes$1.bool,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string, PropTypes$1.func])
};
var defaultProps$7 = {
  color: 'secondary',
  'aria-haspopup': true
};
var DropdownToggle$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$k(DropdownToggle, _React$Component);
  var _super = _createSuper$f(DropdownToggle);
  function DropdownToggle(props) {
    var _this;
    _classCallCheck$k(this, DropdownToggle);
    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(_assertThisInitialized$e(_this));
    return _this;
  }
  _createClass$j(DropdownToggle, [{
    key: "onClick",
    value: function onClick(e) {
      if (this.props.disabled || this.context.disabled) {
        e.preventDefault();
        return;
      }
      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }
      if (this.props.onClick) {
        this.props.onClick(e);
      }
      this.context.toggle(e);
    }
  }, {
    key: "getRole",
    value: function getRole() {
      return this.context.menuRole || this.props['aria-haspopup'];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        props = _objectWithoutProperties$d(_this$props, _excluded$p);
      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(cx(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/React__default.createElement("span", {
        className: "visually-hidden"
      }, ariaLabel);
      var Tag;
      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button$1;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      // extracted the rendering of the Tag component
      var returnFunction = function returnFunction(_ref) {
        var ref = _ref.ref;
        var handleRef = function handleRef(tagRef) {
          ref(tagRef);
          var onToggleRef = _this2.context.onToggleRef;
          if (onToggleRef) onToggleRef(tagRef);
        };
        return /*#__PURE__*/React__default.createElement(Tag, _extends$p({}, props, _defineProperty$c({}, typeof Tag === 'string' ? 'ref' : 'innerRef', handleRef), {
          className: classes,
          onClick: _this2.onClick,
          "aria-expanded": _this2.context.isOpen,
          "aria-haspopup": _this2.getRole(),
          children: children
        }));
      };

      // No Reference component if the component is in Navbar
      if (this.context.inNavbar) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, returnFunction({
          ref: this.context.onToggleRef
        }));
      }

      // Normal rendering if component not in NavBar
      return /*#__PURE__*/React__default.createElement(Reference, {
        innerRef: innerRef
      }, returnFunction);
    }
  }]);
  return DropdownToggle;
}(React__default.Component);
DropdownToggle$2.propTypes = propTypes$l;
DropdownToggle$2.defaultProps = defaultProps$7;
DropdownToggle$2.contextType = DropdownContext;

function _extends$o() {
  _extends$o = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$o.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf$d(o, p) {
  _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$d(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$d(subClass, superClass);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
  enter: PropTypes$1.number,
  exit: PropTypes$1.number,
  appear: PropTypes$1.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape({
  enter: PropTypes$1.string,
  exit: PropTypes$1.string,
  active: PropTypes$1.string
}), PropTypes$1.shape({
  enter: PropTypes$1.string,
  enterDone: PropTypes$1.string,
  enterActive: PropTypes$1.string,
  exit: PropTypes$1.string,
  exitDone: PropTypes$1.string,
  exitActive: PropTypes$1.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$c(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes$1.shape({
    current: typeof Element === 'undefined' ? PropTypes$1.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes$1.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes$1.oneOfType([PropTypes$1.func.isRequired, PropTypes$1.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes$1.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes$1.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes$1.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes$1.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes$1.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes$1.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes$1.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes$1.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes$1.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes$1.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes$1.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes$1.func
} : {}; // Name the function so it is clearer in the documentation

function noop$3() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$3,
  onEntering: noop$3,
  onEntered: noop$3,
  onExit: noop$3,
  onExiting: noop$3,
  onExited: noop$3
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

function _assertThisInitialized$d(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var _excluded$o = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes$k = _objectSpread$k(_objectSpread$k({}, Transition.propTypes), {}, {
  children: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.node), PropTypes$1.node]),
  tag: tagPropType,
  baseClass: PropTypes$1.string,
  baseClassActive: PropTypes$1.string,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string, PropTypes$1.func])
});
var defaultProps$6 = _objectSpread$k(_objectSpread$k({}, Transition.defaultProps), {}, {
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  "in": true
});
function Fade(props) {
  var ref = useRef(null);
  var _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    _props$baseClass = props.baseClass,
    baseClass = _props$baseClass === void 0 ? 'fade' : _props$baseClass,
    _props$baseClassActiv = props.baseClassActive,
    baseClassActive = _props$baseClassActiv === void 0 ? 'show' : _props$baseClassActiv,
    className = props.className,
    cssModule = props.cssModule,
    children = props.children,
    _props$innerRef = props.innerRef,
    innerRef = _props$innerRef === void 0 ? ref : _props$innerRef,
    otherProps = _objectWithoutProperties$c(props, _excluded$o);
  var transitionProps = pick$1(_objectSpread$k({
    defaultProps: defaultProps$6
  }, otherProps), TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);
  return /*#__PURE__*/React__default.createElement(Transition, _extends$n({
    nodeRef: innerRef
  }, transitionProps), function (status) {
    var isActive = status === 'entered';
    var classes = mapToCssModules(cx(className, baseClass, isActive && baseClassActive), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends$n({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}
Fade.propTypes = propTypes$k;
Fade.defaultProps = defaultProps$6;

function _typeof$e(obj) { "@babel/helpers - typeof"; return _typeof$e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$e(obj); }
var _excluded$n = ["tag", "horizontal", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"];
var _transitionStatusToCl;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$c(subClass, superClass); }
function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }
function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf$d(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$d(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$j(this, result); }; }
function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$c(self); }
function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }
function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes$j = _objectSpread$j(_objectSpread$j({}, Transition.propTypes), {}, {
  /** Make content animation appear horizontally */
  horizontal: PropTypes$1.bool,
  /** Set if Collapse is open or closed */
  isOpen: PropTypes$1.bool,
  children: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.node), PropTypes$1.node]),
  /** Set a custom element for this component */
  tag: tagPropType,
  /** Add custom class */
  className: PropTypes$1.node,
  navbar: PropTypes$1.bool,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  innerRef: PropTypes$1.shape({
    current: PropTypes$1.object
  })
});
var defaultProps$5 = _objectSpread$j(_objectSpread$j({}, Transition.defaultProps), {}, {
  horizontal: false,
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _defineProperty$a(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), _defineProperty$a(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), _defineProperty$a(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), _defineProperty$a(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);
function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}
var Collapse = /*#__PURE__*/function (_Component) {
  _inherits$j(Collapse, _Component);
  var _super = _createSuper$e(Collapse);
  function Collapse(props) {
    var _this;
    _classCallCheck$j(this, Collapse);
    _this = _super.call(this, props);
    _this.state = {
      dimension: null
    };
    _this.nodeRef = props.innerRef || /*#__PURE__*/React__default.createRef();
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_assertThisInitialized$c(_this));
    });
    return _this;
  }
  _createClass$i(Collapse, [{
    key: "onEntering",
    value: function onEntering(_, isAppearing) {
      var node = this.getNode();
      this.setState({
        dimension: this.getDimension(node)
      });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: "onEntered",
    value: function onEntered(_, isAppearing) {
      var node = this.getNode();
      this.setState({
        dimension: null
      });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: "onExit",
    value: function onExit() {
      var node = this.getNode();
      this.setState({
        dimension: this.getDimension(node)
      });
      this.props.onExit(node);
    }
  }, {
    key: "onExiting",
    value: function onExiting() {
      var node = this.getNode();
      // getting this variable triggers a reflow
      this.getDimension(node); // eslint-disable-line no-unused-vars
      this.setState({
        dimension: 0
      });
      this.props.onExiting(node);
    }
  }, {
    key: "onExited",
    value: function onExited() {
      var node = this.getNode();
      this.setState({
        dimension: null
      });
      this.props.onExited(node);
    }
  }, {
    key: "getNode",
    value: function getNode() {
      return this.nodeRef.current;
    }
  }, {
    key: "getDimension",
    value: function getDimension(node) {
      return this.props.horizontal ? node.scrollWidth : node.scrollHeight;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        Tag = _this$props.tag,
        horizontal = _this$props.horizontal,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children;
        _this$props.innerRef;
        var otherProps = _objectWithoutProperties$b(_this$props, _excluded$n);
      var dimension = this.state.dimension;
      var transitionProps = pick$1(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);
      return /*#__PURE__*/React__default.createElement(Transition, _extends$m({}, transitionProps, {
        "in": isOpen,
        nodeRef: this.nodeRef,
        onEntering: this.onEntering,
        onEntered: this.onEntered,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }), function (status) {
        var collapseClass = getTransitionClass(status);
        var classes = mapToCssModules(cx(className, horizontal && 'collapse-horizontal', collapseClass, navbar && 'navbar-collapse'), cssModule);
        var style = dimension === null ? null : _defineProperty$a({}, horizontal ? 'width' : 'height', dimension);
        return /*#__PURE__*/React__default.createElement(Tag, _extends$m({}, childProps, {
          style: _objectSpread$j(_objectSpread$j({}, childProps.style), style),
          className: classes,
          ref: _this2.nodeRef
        }), children);
      });
    }
  }]);
  return Collapse;
}(Component);
Collapse.propTypes = propTypes$j;
Collapse.defaultProps = defaultProps$5;

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */
var CarouselContext = /*#__PURE__*/React__default.createContext({});

function _typeof$d(obj) { "@babel/helpers - typeof"; return _typeof$d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$d(obj); }
var _excluded$m = ["in", "children", "cssModule", "slide", "tag", "className"];
function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$b(subClass, superClass); }
function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }
function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf$c(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$c(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$i(this, result); }; }
function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$b(self); }
function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }
var CarouselItem$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$i(CarouselItem, _React$Component);
  var _super = _createSuper$d(CarouselItem);
  function CarouselItem(props) {
    var _this;
    _classCallCheck$i(this, CarouselItem);
    _this = _super.call(this, props);
    _this.state = {
      startAnimation: false
    };
    _this.onEnter = _this.onEnter.bind(_assertThisInitialized$b(_this));
    _this.onEntering = _this.onEntering.bind(_assertThisInitialized$b(_this));
    _this.onExit = _this.onExit.bind(_assertThisInitialized$b(_this));
    _this.onExiting = _this.onExiting.bind(_assertThisInitialized$b(_this));
    _this.onExited = _this.onExited.bind(_assertThisInitialized$b(_this));
    return _this;
  }
  _createClass$h(CarouselItem, [{
    key: "onEnter",
    value: function onEnter(node, isAppearing) {
      this.setState({
        startAnimation: false
      });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: "onEntering",
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({
        startAnimation: true
      });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: "onExit",
    value: function onExit(node) {
      this.setState({
        startAnimation: false
      });
      this.props.onExit(node);
    }
  }, {
    key: "onExiting",
    value: function onExiting(node) {
      this.setState({
        startAnimation: true
      });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: "onExited",
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        isIn = _this$props["in"],
        children = _this$props.children,
        cssModule = _this$props.cssModule,
        _this$props$slide = _this$props.slide,
        slide = _this$props$slide === void 0 ? true : _this$props$slide,
        _this$props$tag = _this$props.tag,
        Tag = _this$props$tag === void 0 ? 'div' : _this$props$tag,
        className = _this$props.className,
        transitionProps = _objectWithoutProperties$a(_this$props, _excluded$m);
      return /*#__PURE__*/React__default.createElement(Transition, _extends$l({}, transitionProps, {
        enter: slide,
        exit: slide,
        "in": isIn,
        onEnter: this.onEnter,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }), function (status) {
        var direction = _this2.context.direction;
        var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
        var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'end' ? 'carousel-item-start' : 'carousel-item-end');
        var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'end' ? 'carousel-item-next' : 'carousel-item-prev');
        var itemClasses = mapToCssModules(cx(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
        return /*#__PURE__*/React__default.createElement(Tag, {
          className: itemClasses
        }, children);
      });
    }
  }]);
  return CarouselItem;
}(React__default.Component);
CarouselItem$1.propTypes = _objectSpread$i(_objectSpread$i({}, Transition.propTypes), {}, {
  /** Set a custom element for this component */
  tag: tagPropType,
  "in": PropTypes$1.bool,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  children: PropTypes$1.node,
  /** Enable/disable animation */
  slide: PropTypes$1.bool,
  /** Add custom class */
  className: PropTypes$1.string
});
CarouselItem$1.defaultProps = _objectSpread$i(_objectSpread$i({}, Transition.defaultProps), {}, {
  timeout: TransitionTimeouts.Carousel
});
CarouselItem$1.contextType = CarouselContext;

function _typeof$c(obj) { "@babel/helpers - typeof"; return _typeof$c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$c(obj); }
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$a(subClass, superClass); }
function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }
function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf$b(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$b(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$h(this, result); }; }
function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$a(self); }
function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }
var SWIPE_THRESHOLD = 40;
var propTypes$i = {
  /** the current active slide of the carousel */
  activeIndex: PropTypes$1.number,
  /** a function which should advance the carousel to the next slide (via activeIndex) */
  next: PropTypes$1.func.isRequired,
  /** a function which should advance the carousel to the previous slide (via activeIndex) */
  previous: PropTypes$1.func.isRequired,
  /** controls if the left and right arrow keys should control the carousel */
  keyboard: PropTypes$1.bool,
  /** If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it.
   */
  pause: PropTypes$1.oneOf(['hover', false]),
  /** Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load. */
  ride: PropTypes$1.oneOf(['carousel']),
  /** the interval at which the carousel automatically cycles */
  interval: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string, PropTypes$1.bool]),
  children: PropTypes$1.array,
  /** called when the mouse enters the Carousel */
  mouseEnter: PropTypes$1.func,
  /** called when the mouse exits the Carousel */
  mouseLeave: PropTypes$1.func,
  /** controls whether the slide animation on the Carousel works or not */
  slide: PropTypes$1.bool,
  /** make the controls, indicators and captions dark on the Carousel */
  dark: PropTypes$1.bool,
  fade: PropTypes$1.bool,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Enable touch support */
  enableTouch: PropTypes$1.bool
};
var propsToOmit$1 = Object.keys(propTypes$i);
var defaultProps$4 = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true,
  enableTouch: true,
  fade: false
};
var Carousel$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$h(Carousel, _React$Component);
  var _super = _createSuper$c(Carousel);
  function Carousel(props) {
    var _this;
    _classCallCheck$h(this, Carousel);
    _this = _super.call(this, props);
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized$a(_this));
    _this.renderItems = _this.renderItems.bind(_assertThisInitialized$a(_this));
    _this.hoverStart = _this.hoverStart.bind(_assertThisInitialized$a(_this));
    _this.hoverEnd = _this.hoverEnd.bind(_assertThisInitialized$a(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized$a(_this));
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_assertThisInitialized$a(_this));
    _this.touchStartX = 0;
    _this.touchStartY = 0;
    _this.state = {
      activeIndex: _this.props.activeIndex,
      direction: 'end',
      indicatorClicked: false
    };
    return _this;
  }
  _createClass$g(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.activeIndex === this.state.activeIndex) return;
      this.setInterval();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(e) {
      if (!this.props.enableTouch) {
        return;
      }
      this.touchStartX = e.changedTouches[0].screenX;
      this.touchStartY = e.changedTouches[0].screenY;
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(e) {
      if (!this.props.enableTouch) {
        return;
      }
      var currentX = e.changedTouches[0].screenX;
      var currentY = e.changedTouches[0].screenY;
      var diffX = Math.abs(this.touchStartX - currentX);
      var diffY = Math.abs(this.touchStartY - currentY);

      // Don't swipe if Y-movement is bigger than X-movement
      if (diffX < diffY) {
        return;
      }
      if (diffX < SWIPE_THRESHOLD) {
        return;
      }
      if (currentX < this.touchStartX) {
        this.props.next();
      } else {
        this.props.previous();
      }
    }
  }, {
    key: "getContextValue",
    value: function getContextValue() {
      return {
        direction: this.state.direction
      };
    }
  }, {
    key: "setInterval",
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }
      setInterval.toString = function () {
        return _setInterval.toString();
      };
      return setInterval;
    }(function () {
      var _this2 = this;
      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (this.props.interval) {
        this.cycleInterval = setInterval(function () {
          _this2.props.next();
        }, parseInt(this.props.interval, 10));
      }
    })
  }, {
    key: "clearInterval",
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }
      clearInterval.toString = function () {
        return _clearInterval.toString();
      };
      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: "hoverStart",
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _this$props;
        (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
      }
    }
  }, {
    key: "hoverEnd",
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _this$props2;
        (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
      }
    }
  }, {
    key: "renderItems",
    value: function renderItems(carouselItems, className) {
      var _this3 = this;
      var slide = this.props.slide;
      return /*#__PURE__*/React__default.createElement("div", {
        className: className
      }, carouselItems.map(function (item, index) {
        var isIn = index === _this3.state.activeIndex;
        return /*#__PURE__*/React__default.cloneElement(item, {
          "in": isIn,
          slide: slide
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        cssModule = _this$props3.cssModule,
        slide = _this$props3.slide,
        className = _this$props3.className,
        dark = _this$props3.dark,
        fade = _this$props3.fade;
      var attributes = omit(this.props, propsToOmit$1);
      var outerClasses = mapToCssModules(cx(className, 'carousel', fade && 'carousel-fade', slide && 'slide', dark && 'carousel-dark'), cssModule);
      var innerClasses = mapToCssModules(cx('carousel-inner'), cssModule);

      // filter out booleans, null, or undefined
      var children = this.props.children.filter(function (child) {
        return child !== null && child !== undefined && typeof child !== 'boolean';
      });
      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem$1;
      });

      // Rendering only slides
      if (slidesOnly) {
        return /*#__PURE__*/React__default.createElement("div", _extends$k({}, attributes, {
          className: outerClasses,
          onMouseEnter: this.hoverStart,
          onMouseLeave: this.hoverEnd
        }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
          value: this.getContextValue()
        }, this.renderItems(children, innerClasses)));
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];
        return /*#__PURE__*/React__default.createElement("div", _extends$k({}, attributes, {
          className: outerClasses,
          onMouseEnter: this.hoverStart,
          onMouseLeave: this.hoverEnd
        }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
          value: this.getContextValue()
        }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight));
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this4.setState({
            indicatorClicked: true
          }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = /*#__PURE__*/React__default.cloneElement(indicators, {
        onClickHandler: wrappedOnClick
      });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];
      return /*#__PURE__*/React__default.createElement("div", _extends$k({}, attributes, {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = null;
      var activeIndex = prevState.activeIndex,
        direction = prevState.direction,
        indicatorClicked = prevState.indicatorClicked;
      if (nextProps.activeIndex !== activeIndex) {
        // Calculate the direction to turn
        if (nextProps.activeIndex === activeIndex + 1) {
          direction = 'end';
        } else if (nextProps.activeIndex === activeIndex - 1) {
          direction = 'start';
        } else if (nextProps.activeIndex < activeIndex) {
          direction = indicatorClicked ? 'start' : 'end';
        } else if (nextProps.activeIndex !== activeIndex) {
          direction = indicatorClicked ? 'end' : 'start';
        }
        newState = {
          activeIndex: nextProps.activeIndex,
          direction: direction,
          indicatorClicked: false
        };
      }
      return newState;
    }
  }]);
  return Carousel;
}(React__default.Component);
Carousel$1.propTypes = propTypes$i;
Carousel$1.defaultProps = defaultProps$4;

var _excluded$l = ["items", "activeIndex", "cssModule", "onClickHandler", "className"];
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function CarouselIndicators(props) {
  var items = props.items,
    activeIndex = props.activeIndex,
    cssModule = props.cssModule,
    onClickHandler = props.onClickHandler,
    className = props.className,
    attributes = _objectWithoutProperties$9(props, _excluded$l);
  var listClasses = mapToCssModules(cx(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(cx({
      active: activeIndex === idx
    }), cssModule);
    return /*#__PURE__*/React__default.createElement("button", {
      "aria-label": item.caption,
      "data-bs-target": true,
      type: "button",
      key: "".concat(item.key || Object.values(item).join('')),
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return /*#__PURE__*/React__default.createElement("div", _extends$j({
    className: listClasses
  }, attributes), indicators);
}
CarouselIndicators.propTypes = {
  /** The current active index */
  activeIndex: PropTypes$1.number.isRequired,
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Array of items to show */
  items: PropTypes$1.array.isRequired,
  /** Function to be triggered on click */
  onClickHandler: PropTypes$1.func.isRequired
};

function _typeof$b(obj) { "@babel/helpers - typeof"; return _typeof$b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$b(obj); }
function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$9(subClass, superClass); }
function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }
function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$g(this, result); }; }
function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$b(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$9(self); }
function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }
var propTypes$h = {
  children: PropTypes$1.node.isRequired,
  node: PropTypes$1.any
};
var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits$g(Portal, _React$Component);
  var _super = _createSuper$b(Portal);
  function Portal() {
    _classCallCheck$g(this, Portal);
    return _super.apply(this, arguments);
  }
  _createClass$f(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!canUseDOM$1) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return /*#__PURE__*/ReactDOM__default.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(React__default.Component);
Portal.propTypes = propTypes$h;

function _typeof$a(obj) { "@babel/helpers - typeof"; return _typeof$a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$a(obj); }
function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$8(subClass, superClass); }
function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }
function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$9(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$9(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$f(this, result); }; }
function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$8(self); }
function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }
function noop$2() {}
var FadePropTypes = PropTypes$1.shape(Fade.propTypes);
var propTypes$g = {
  /** */
  autoFocus: PropTypes$1.bool,
  /** Add backdrop to modal */
  backdrop: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.oneOf(['static'])]),
  /** add custom classname to backdrop */
  backdropClassName: PropTypes$1.string,
  backdropTransition: FadePropTypes,
  /** Vertically center the modal */
  centered: PropTypes$1.bool,
  /** Add children for the modal to wrap */
  children: PropTypes$1.node,
  /** Add custom className for modal content */
  contentClassName: PropTypes$1.string,
  className: PropTypes$1.string,
  container: targetPropType,
  cssModule: PropTypes$1.object,
  external: PropTypes$1.node,
  /** Enable/Disable animation */
  fade: PropTypes$1.bool,
  /** Make the modal fullscreen */
  fullscreen: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.oneOf(['sm', 'md', 'lg', 'xl'])]),
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string, PropTypes$1.func]),
  /** The status of the modal, either open or close */
  isOpen: PropTypes$1.bool,
  /** Allow modal to be closed with escape key. */
  keyboard: PropTypes$1.bool,
  /** Identifies the element (or elements) that labels the current element. */
  labelledBy: PropTypes$1.string,
  modalClassName: PropTypes$1.string,
  modalTransition: FadePropTypes,
  /** Function to be triggered on close */
  onClosed: PropTypes$1.func,
  /** Function to be triggered on enter */
  onEnter: PropTypes$1.func,
  /** Function to be triggered on exit */
  onExit: PropTypes$1.func,
  /** Function to be triggered on open */
  onOpened: PropTypes$1.func,
  /** Returns focus to the element that triggered opening of the modal */
  returnFocusAfterClose: PropTypes$1.bool,
  /** Accessibility role */
  role: PropTypes$1.string,
  /** Make the modal scrollable */
  scrollable: PropTypes$1.bool,
  /** Two optional sizes `lg` and `sm` */
  size: PropTypes$1.string,
  /** Function to toggle modal visibility */
  toggle: PropTypes$1.func,
  trapFocus: PropTypes$1.bool,
  /** Unmounts the modal when modal is closed */
  unmountOnClose: PropTypes$1.bool,
  wrapClassName: PropTypes$1.string,
  zIndex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])
};
var propsToOmit = Object.keys(propTypes$g);
var defaultProps$3 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  scrollable: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop$2,
  onClosed: noop$2,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  },

  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: 'body',
  trapFocus: false
};
var Modal$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$f(Modal, _React$Component);
  var _super = _createSuper$a(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck$f(this, Modal);
    _this = _super.call(this, props);
    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(_assertThisInitialized$8(_this));
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_assertThisInitialized$8(_this));
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_assertThisInitialized$8(_this));
    _this.handleEscape = _this.handleEscape.bind(_assertThisInitialized$8(_this));
    _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind(_assertThisInitialized$8(_this));
    _this.handleTab = _this.handleTab.bind(_assertThisInitialized$8(_this));
    _this.onOpened = _this.onOpened.bind(_assertThisInitialized$8(_this));
    _this.onClosed = _this.onClosed.bind(_assertThisInitialized$8(_this));
    _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind(_assertThisInitialized$8(_this));
    _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind(_assertThisInitialized$8(_this));
    _this.trapFocus = _this.trapFocus.bind(_assertThisInitialized$8(_this));
    _this.state = {
      isOpen: false,
      showStaticBackdropAnimation: false
    };
    return _this;
  }
  _createClass$e(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        autoFocus = _this$props.autoFocus,
        onEnter = _this$props.onEnter;
      if (isOpen) {
        this.init();
        this.setState({
          isOpen: true
        });
        if (autoFocus) {
          this.setFocus();
        }
      }
      if (onEnter) {
        onEnter();
      }

      // traps focus inside the Modal, even if the browser address bar is focused
      document.addEventListener('focus', this.trapFocus, true);
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.isOpen && !prevProps.isOpen) {
        this.init();
        this.setState({
          isOpen: true
        });
        // let render() renders Modal Dialog first
        return;
      }

      // now Modal Dialog is rendered and we can refer this._element and this._dialog
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }
      if (this._element && prevProps.zIndex !== this.props.zIndex) {
        this._element.style.zIndex = this.props.zIndex;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearBackdropAnimationTimeout();
      if (this.props.onExit) {
        this.props.onExit();
      }
      if (this._element) {
        this.destroy();
        if (this.props.isOpen || this.state.isOpen) {
          this.close();
        }
      }
      document.removeEventListener('focus', this.trapFocus, true);
      this._isMounted = false;
    }

    // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
  }, {
    key: "handleBackdropClick",
    value: function handleBackdropClick(e) {
      if (e.target === this._mouseDownElement) {
        e.stopPropagation();
        var backdrop = this._dialog ? this._dialog.parentNode : null;
        if (backdrop && e.target === backdrop && this.props.backdrop === 'static') {
          this.handleStaticBackdropAnimation();
        }
        if (!this.props.isOpen || this.props.backdrop !== true) return;
        if (backdrop && e.target === backdrop && this.props.toggle) {
          this.props.toggle(e);
        }
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (e.which !== 9) return;
      if (this.modalIndex < Modal.openCount - 1) return; // last opened modal

      var focusableChildren = this.getFocusableChildren();
      var totalFocusable = focusableChildren.length;
      if (totalFocusable === 0) return;
      var currentFocus = this.getFocusedChild();
      var focusedIndex = 0;
      for (var i = 0; i < totalFocusable; i += 1) {
        if (focusableChildren[i] === currentFocus) {
          focusedIndex = i;
          break;
        }
      }
      if (e.shiftKey && focusedIndex === 0) {
        e.preventDefault();
        focusableChildren[totalFocusable - 1].focus();
      } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
        e.preventDefault();
        focusableChildren[0].focus();
      }
    }
  }, {
    key: "handleBackdropMouseDown",
    value: function handleBackdropMouseDown(e) {
      this._mouseDownElement = e.target;
    }
  }, {
    key: "handleEscape",
    value: function handleEscape(e) {
      if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
        if (this.props.keyboard) {
          e.preventDefault();
          e.stopPropagation();
          this.props.toggle(e);
        } else if (this.props.backdrop === 'static') {
          e.preventDefault();
          e.stopPropagation();
          this.handleStaticBackdropAnimation();
        }
      }
    }
  }, {
    key: "handleStaticBackdropAnimation",
    value: function handleStaticBackdropAnimation() {
      var _this2 = this;
      this.clearBackdropAnimationTimeout();
      this.setState({
        showStaticBackdropAnimation: true
      });
      this._backdropAnimationTimeout = setTimeout(function () {
        _this2.setState({
          showStaticBackdropAnimation: false
        });
      }, 100);
    }
  }, {
    key: "onOpened",
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop$2)(node, isAppearing);
    }
  }, {
    key: "onClosed",
    value: function onClosed(node) {
      var unmountOnClose = this.props.unmountOnClose;
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop$2)(node);
      if (unmountOnClose) {
        this.destroy();
      }
      this.close();
      if (this._isMounted) {
        this.setState({
          isOpen: false
        });
      }
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: "getFocusableChildren",
    value: function getFocusableChildren() {
      return this._element.querySelectorAll(focusableElements.join(', '));
    }
  }, {
    key: "getFocusedChild",
    value: function getFocusedChild() {
      var currentFocus;
      var focusableChildren = this.getFocusableChildren();
      try {
        currentFocus = document.activeElement;
      } catch (err) {
        currentFocus = focusableChildren[0];
      }
      return currentFocus;
    }
  }, {
    key: "trapFocus",
    value: function trapFocus(ev) {
      if (!this.props.trapFocus) {
        return;
      }
      if (!this._element) {
        // element is not attached
        return;
      }
      if (this._dialog && this._dialog.parentNode === ev.target) {
        // initial focus when the Modal is opened
        return;
      }
      if (this.modalIndex < Modal.openCount - 1) {
        // last opened modal
        return;
      }
      var children = this.getFocusableChildren();
      for (var i = 0; i < children.length; i += 1) {
        // focus is already inside the Modal
        if (children[i] === ev.target) return;
      }
      if (children.length > 0) {
        // otherwise focus the first focusable element in the Modal
        ev.preventDefault();
        ev.stopPropagation();
        children[0].focus();
      }
    }
  }, {
    key: "init",
    value: function init() {
      try {
        this._triggeringElement = document.activeElement;
      } catch (err) {
        this._triggeringElement = null;
      }
      if (!this._element) {
        this._element = document.createElement('div');
        this._element.setAttribute('tabindex', '-1');
        this._element.style.position = 'relative';
        this._element.style.zIndex = this.props.zIndex;
        this._mountContainer = getTarget(this.props.container);
        this._mountContainer.appendChild(this._element);
      }
      this._originalBodyPadding = getOriginalBodyPadding();
      if (Modal.openCount < 1) {
        Modal.originalBodyOverflow = window.getComputedStyle(document.body).overflow;
      }
      conditionallyUpdateScrollbar();
      if (Modal.openCount === 0) {
        document.body.className = cx(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
        document.body.style.overflow = 'hidden';
      }
      this.modalIndex = Modal.openCount;
      Modal.openCount += 1;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this._element) {
        this._mountContainer.removeChild(this._element);
        this._element = null;
      }
      this.manageFocusAfterClose();
    }
  }, {
    key: "manageFocusAfterClose",
    value: function manageFocusAfterClose() {
      if (this._triggeringElement) {
        var returnFocusAfterClose = this.props.returnFocusAfterClose;
        if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
        this._triggeringElement = null;
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (Modal.openCount <= 1) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp("(^| )".concat(modalOpenClassName, "( |$)"));
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        document.body.style.overflow = Modal.originalBodyOverflow;
      }
      this.manageFocusAfterClose();
      Modal.openCount = Math.max(0, Modal.openCount - 1);
      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: "clearBackdropAnimationTimeout",
    value: function clearBackdropAnimationTimeout() {
      if (this._backdropAnimationTimeout) {
        clearTimeout(this._backdropAnimationTimeout);
        this._backdropAnimationTimeout = undefined;
      }
    }
  }, {
    key: "renderModalDialog",
    value: function renderModalDialog() {
      var _classNames,
        _this3 = this;
      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';
      return /*#__PURE__*/React__default.createElement("div", _extends$i({}, attributes, {
        className: mapToCssModules(cx(dialogBaseClass, this.props.className, (_classNames = {}, _defineProperty$8(_classNames, "modal-".concat(this.props.size), this.props.size), _defineProperty$8(_classNames, "".concat(dialogBaseClass, "-centered"), this.props.centered), _defineProperty$8(_classNames, "".concat(dialogBaseClass, "-scrollable"), this.props.scrollable), _defineProperty$8(_classNames, 'modal-fullscreen', this.props.fullscreen === true), _defineProperty$8(_classNames, "modal-fullscreen-".concat(this.props.fullscreen, "-down"), typeof this.props.fullscreen === 'string'), _classNames)), this.props.cssModule),
        role: "document",
        ref: function ref(c) {
          _this3._dialog = c;
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(cx('modal-content', this.props.contentClassName), this.props.cssModule)
      }, this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var unmountOnClose = this.props.unmountOnClose;
      if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
        var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
        this._element.style.display = isModalHidden ? 'none' : 'block';
        var _this$props2 = this.props,
          wrapClassName = _this$props2.wrapClassName,
          modalClassName = _this$props2.modalClassName,
          backdropClassName = _this$props2.backdropClassName,
          cssModule = _this$props2.cssModule,
          isOpen = _this$props2.isOpen,
          backdrop = _this$props2.backdrop,
          role = _this$props2.role,
          labelledBy = _this$props2.labelledBy,
          external = _this$props2.external,
          innerRef = _this$props2.innerRef;
        var modalAttributes = {
          onClick: this.handleBackdropClick,
          onMouseDown: this.handleBackdropMouseDown,
          onKeyUp: this.handleEscape,
          onKeyDown: this.handleTab,
          style: {
            display: 'block'
          },
          'aria-labelledby': labelledBy,
          'aria-modal': true,
          role: role,
          tabIndex: '-1'
        };
        var hasTransition = this.props.fade;
        var modalTransition = _objectSpread$h(_objectSpread$h(_objectSpread$h({}, Fade.defaultProps), this.props.modalTransition), {}, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _objectSpread$h(_objectSpread$h(_objectSpread$h({}, Fade.defaultProps), this.props.backdropTransition), {}, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });
        var Backdrop = backdrop && (hasTransition ? /*#__PURE__*/React__default.createElement(Fade, _extends$i({}, backdropTransition, {
          "in": isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(cx('modal-backdrop', backdropClassName), cssModule)
        })) : /*#__PURE__*/React__default.createElement("div", {
          className: mapToCssModules(cx('modal-backdrop', 'show', backdropClassName), cssModule)
        }));
        return /*#__PURE__*/React__default.createElement(Portal, {
          node: this._element
        }, /*#__PURE__*/React__default.createElement("div", {
          className: mapToCssModules(wrapClassName)
        }, /*#__PURE__*/React__default.createElement(Fade, _extends$i({}, modalAttributes, modalTransition, {
          "in": isOpen,
          onEntered: this.onOpened,
          onExited: this.onClosed,
          cssModule: cssModule,
          className: mapToCssModules(cx('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
          innerRef: innerRef
        }), external, this.renderModalDialog()), Backdrop));
      }
      return null;
    }
  }]);
  return Modal;
}(React__default.Component);
Modal$1.propTypes = propTypes$g;
Modal$1.defaultProps = defaultProps$3;
Modal$1.openCount = 0;
Modal$1.originalBodyOverflow = null;

var _excluded$k = ["className", "cssModule", "tag"];
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$f = {
  /** Add custom class */
  className: PropTypes$1.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes$1.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function ModalBody(props) {
  var className = props.className,
    cssModule = props.cssModule,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    attributes = _objectWithoutProperties$8(props, _excluded$k);
  var classes = mapToCssModules(cx(className, 'modal-body'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$h({}, attributes, {
    className: classes
  }));
}
ModalBody.propTypes = propTypes$f;

function _typeof$9(obj) { "@babel/helpers - typeof"; return _typeof$9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$9(obj); }
var _excluded$j = ["className", "cssModule", "tag", "innerRef"];
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$7(subClass, superClass); }
function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }
function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$8(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$8(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$e(this, result); }; }
function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$7(self); }
function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }
var propTypes$e = {
  children: PropTypes$1.node,
  tag: tagPropType,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func, PropTypes$1.string]),
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object
};
var Form$1 = /*#__PURE__*/function (_Component) {
  _inherits$e(Form, _Component);
  var _super = _createSuper$9(Form);
  function Form(props) {
    var _this;
    _classCallCheck$e(this, Form);
    _this = _super.call(this, props);
    _this.getRef = _this.getRef.bind(_assertThisInitialized$7(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized$7(_this));
    return _this;
  }
  _createClass$d(Form, [{
    key: "getRef",
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: "submit",
    value: function submit() {
      if (this.ref) {
        this.ref.submit();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        _this$props$tag = _this$props.tag,
        Tag = _this$props$tag === void 0 ? 'form' : _this$props$tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutProperties$7(_this$props, _excluded$j);
      var classes = mapToCssModules(className, cssModule);
      return /*#__PURE__*/React__default.createElement(Tag, _extends$g({}, attributes, {
        ref: innerRef,
        className: classes
      }));
    }
  }]);
  return Form;
}(Component);
Form$1.propTypes = propTypes$e;

var _excluded$i = ["className", "cssModule", "valid", "tooltip", "tag"];
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$d = {
  children: PropTypes$1.node,
  tag: tagPropType,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  valid: PropTypes$1.bool,
  tooltip: PropTypes$1.bool
};
function FormFeedback(props) {
  var className = props.className,
    cssModule = props.cssModule,
    _props$valid = props.valid,
    valid = _props$valid === void 0 ? undefined : _props$valid,
    tooltip = props.tooltip,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    attributes = _objectWithoutProperties$6(props, _excluded$i);
  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = mapToCssModules(cx(className, valid ? "valid-".concat(validMode) : "invalid-".concat(validMode)), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$f({}, attributes, {
    className: classes
  }));
}
FormFeedback.propTypes = propTypes$d;

var _excluded$h = ["className", "cssModule", "row", "disabled", "check", "inline", "floating", "noMargin", "tag", "switch"];
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$c = {
  children: PropTypes$1.node,
  row: PropTypes$1.bool,
  check: PropTypes$1.bool,
  "switch": PropTypes$1.bool,
  inline: PropTypes$1.bool,
  floating: PropTypes$1.bool,
  noMargin: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  tag: tagPropType,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object
};
function FormGroup(props) {
  var className = props.className,
    cssModule = props.cssModule,
    row = props.row,
    disabled = props.disabled,
    check = props.check,
    inline = props.inline,
    floating = props.floating,
    noMargin = props.noMargin,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    switchProp = props["switch"],
    attributes = _objectWithoutProperties$5(props, _excluded$h);
  var formCheck = check || switchProp;
  var classes = mapToCssModules(cx(className, row ? 'row' : false, formCheck ? 'form-check' : false, switchProp ? 'form-switch' : false, formCheck || noMargin ? false : 'mb-3', formCheck && inline ? 'form-check-inline' : false, formCheck && disabled ? 'disabled' : false, floating && 'form-floating'), cssModule);
  if (Tag === 'fieldset') {
    attributes.disabled = disabled;
  }
  return /*#__PURE__*/React__default.createElement(Tag, _extends$e({}, attributes, {
    className: classes
  }));
}
FormGroup.propTypes = propTypes$c;

function _typeof$8(obj) { "@babel/helpers - typeof"; return _typeof$8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$8(obj); }
var _excluded$g = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$6(subClass, superClass); }
function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }
function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$7(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$7(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$d(this, result); }; }
function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$6(self); }
function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }
var propTypes$b = {
  children: PropTypes$1.node,
  type: PropTypes$1.string,
  size: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  bsSize: PropTypes$1.string,
  valid: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  tag: tagPropType,
  innerRef: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func, PropTypes$1.string]),
  plaintext: PropTypes$1.bool,
  addon: PropTypes$1.bool,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object
};
var Input$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$d(Input, _React$Component);
  var _super = _createSuper$8(Input);
  function Input(props) {
    var _this;
    _classCallCheck$d(this, Input);
    _this = _super.call(this, props);
    _this.getRef = _this.getRef.bind(_assertThisInitialized$6(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized$6(_this));
    return _this;
  }
  _createClass$c(Input, [{
    key: "getRef",
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.ref) {
        this.ref.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        _this$props$type = _this$props.type,
        type = _this$props$type === void 0 ? 'text' : _this$props$type,
        bsSize = _this$props.bsSize,
        valid = _this$props.valid,
        invalid = _this$props.invalid,
        tag = _this$props.tag,
        addon = _this$props.addon,
        plaintext = _this$props.plaintext,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutProperties$4(_this$props, _excluded$g);
      var checkInput = ['switch', 'radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = /\D/g;
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var rangeInput = type === 'range';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');
      var formControlClass = 'form-control';
      if (plaintext) {
        formControlClass = "".concat(formControlClass, "-plaintext");
        Tag = tag || 'input';
      } else if (rangeInput) {
        formControlClass = 'form-range';
      } else if (selectInput) {
        formControlClass = 'form-select';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }
      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }
      var classes = mapToCssModules(cx(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? selectInput ? "form-select-".concat(bsSize) : "form-control-".concat(bsSize) : false, formControlClass), cssModule);
      if (Tag === 'input' || tag && typeof tag === 'function') {
        attributes.type = type === 'switch' ? 'checkbox' : type;
      }
      if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
        warnOnce("Input with a type of \"".concat(type, "\" cannot have children. Please use \"value\"/\"defaultValue\" instead."));
        delete attributes.children;
      }
      return /*#__PURE__*/React__default.createElement(Tag, _extends$d({}, attributes, {
        ref: innerRef,
        className: classes,
        "aria-invalid": invalid
      }));
    }
  }]);
  return Input;
}(React__default.Component);
Input$2.propTypes = propTypes$b;

var _excluded$f = ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"];
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var colWidths = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var stringOrNumberProp = PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]);
var columnProps = PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string, PropTypes$1.number, PropTypes$1.shape({
  size: stringOrNumberProp,
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes$a = {
  children: PropTypes$1.node,
  hidden: PropTypes$1.bool,
  check: PropTypes$1.bool,
  size: PropTypes$1.string,
  "for": PropTypes$1.string,
  tag: tagPropType,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  xxl: columnProps,
  widths: PropTypes$1.array
};
var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-".concat(colWidth);
  }
  if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-".concat(colWidth, "-auto");
  }
  return isXs ? "col-".concat(colSize) : "col-".concat(colWidth, "-").concat(colSize);
};
function Label(props) {
  var className = props.className,
    cssModule = props.cssModule,
    hidden = props.hidden,
    _props$widths = props.widths,
    widths = _props$widths === void 0 ? colWidths : _props$widths,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'label' : _props$tag,
    check = props.check,
    size = props.size,
    htmlFor = props["for"],
    attributes = _objectWithoutProperties$3(props, _excluded$f);
  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];
    if (!columnProp && columnProp !== '') {
      return;
    }
    var isXs = !i;
    var colClass;
    if (isObject$2(columnProp)) {
      var _classNames;
      var colSizeInterfix = isXs ? '-' : "-".concat(colWidth, "-");
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(cx((_classNames = {}, _defineProperty$7(_classNames, colClass, columnProp.size || columnProp.size === ''), _defineProperty$7(_classNames, "order".concat(colSizeInterfix).concat(columnProp.order), columnProp.order || columnProp.order === 0), _defineProperty$7(_classNames, "offset".concat(colSizeInterfix).concat(columnProp.offset), columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  var colFormLabel = size || colClasses.length;
  var formLabel = !(check || colFormLabel);
  var classes = mapToCssModules(cx(className, hidden ? 'visually-hidden' : false, check ? 'form-check-label' : false, size ? "col-form-label-".concat(size) : false, colClasses, colFormLabel ? 'col-form-label' : false, formLabel ? 'form-label' : false), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$c({
    htmlFor: htmlFor
  }, attributes, {
    className: classes
  }));
}
Label.propTypes = propTypes$a;

/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */
var TabContext = /*#__PURE__*/React__default.createContext({});

function _typeof$7(obj) { "@babel/helpers - typeof"; return _typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$7(obj); }
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$5(subClass, superClass); }
function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }
function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$6(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$6(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$c(this, result); }; }
function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$5(self); }
function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }
var propTypes$9 = {
  tag: tagPropType,
  activeTab: PropTypes$1.any,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object
};
var TabContent = /*#__PURE__*/function (_Component) {
  _inherits$c(TabContent, _Component);
  var _super = _createSuper$7(TabContent);
  function TabContent(props) {
    var _this;
    _classCallCheck$c(this, TabContent);
    _this = _super.call(this, props);
    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }
  _createClass$b(TabContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        _this$props$tag = _this$props.tag,
        Tag = _this$props$tag === void 0 ? 'div' : _this$props$tag;
      var attributes = omit(this.props, Object.keys(propTypes$9));
      var classes = mapToCssModules(cx('tab-content', className), cssModule);
      return /*#__PURE__*/React__default.createElement(TabContext.Provider, {
        value: {
          activeTabId: this.state.activeTab
        }
      }, /*#__PURE__*/React__default.createElement(Tag, _extends$b({}, attributes, {
        className: classes
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.activeTab !== nextProps.activeTab) {
        return {
          activeTab: nextProps.activeTab
        };
      }
      return null;
    }
  }]);
  return TabContent;
}(Component);
TabContent.propTypes = propTypes$9;

var _excluded$e = ["className", "cssModule", "tabId", "tag"];
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes$8 = {
  tag: tagPropType,
  className: PropTypes$1.string,
  cssModule: PropTypes$1.object,
  tabId: PropTypes$1.any
};
function TabPane(props) {
  var className = props.className,
    cssModule = props.cssModule,
    tabId = props.tabId,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    attributes = _objectWithoutProperties$2(props, _excluded$e);
  var getClasses = function getClasses(activeTabId) {
    return mapToCssModules(cx('tab-pane', className, {
      active: tabId === activeTabId
    }), cssModule);
  };
  return /*#__PURE__*/React__default.createElement(TabContext.Consumer, null, function (_ref) {
    var activeTabId = _ref.activeTabId;
    return /*#__PURE__*/React__default.createElement(Tag, _extends$a({}, attributes, {
      className: getClasses(activeTabId)
    }));
  });
}
TabPane.propTypes = propTypes$8;

function _typeof$6(obj) { "@babel/helpers - typeof"; return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$6(obj); }
function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$4(subClass, superClass); }
function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }
function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf$5(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$5(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }
function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$6(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$4(self); }
function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }
var omitKeys = ['defaultOpen'];
var UncontrolledDropdown$2 = /*#__PURE__*/function (_Component) {
  _inherits$b(UncontrolledDropdown, _Component);
  var _super = _createSuper$6(UncontrolledDropdown);
  function UncontrolledDropdown(props) {
    var _this;
    _classCallCheck$b(this, UncontrolledDropdown);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized$4(_this));
    return _this;
  }
  _createClass$a(UncontrolledDropdown, [{
    key: "toggle",
    value: function toggle(e) {
      var _this2 = this;
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, function () {
        if (_this2.props.onToggle) {
          _this2.props.onToggle(e, _this2.state.isOpen);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(Dropdown$2, _extends$9({
        isOpen: this.state.isOpen,
        toggle: this.toggle
      }, omit(this.props, omitKeys)));
    }
  }]);
  return UncontrolledDropdown;
}(Component);
UncontrolledDropdown$2.propTypes = _objectSpread$g({
  defaultOpen: PropTypes$1.bool,
  onToggle: PropTypes$1.func
}, Dropdown$2.propTypes);

const StyledCarouselIndicators = styled(CarouselIndicators).attrs({
    className: 'mime-elements-carousel-indicators',
}) `
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  height: auto;
  width: auto;
  margin-bottom: ${({ theme }) => asRem(theme.spacing.ten)};

  button {
    border-radius: 50% !important;
    width: 12px !important;
    height: 12px !important;
    margin: 0 6px !important;
  }

  & [data-bs-target] {
    opacity: 1 !important;
    background-color: ${({ theme }) => theme.colors.grey.c500}!important;
    transition: background-color 0.3s ease !important;
  }

  & .active {
    background-color: ${({ theme }) => theme.colors.carouselIndicator}!important;
  }
`;

const Carousel = Carousel$1;
const CarouselItem = CarouselItem$1;

const Form = Form$1;

const Container = Container$1;
const Row = Row$1;
const Col = Col$1;

var Style$8 = styled.span `
  display: block;
  width: 100%;
  white-space: pre-line;

  margin-bottom: 0 !important;

  h1 {
    font-family: Poppins-Light;
    font-size: ${asRem(32)};
    line-height: ${asRem(42)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(48)};
      line-height: ${asRem(58)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(54)};
      line-height: ${asRem(64)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  ,
  h2 {
    font-family: poppins-semibold;
    font-size: ${asRem(24)};
    line-height: ${asRem(34)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(28)};
      line-height: ${asRem(38)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(32)};
      line-height: ${asRem(42)};
    }
  }

  ,
  h3 {
    font-family: poppins-light;
    font-size: ${asRem(24)};
    line-height: ${asRem(34)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(28)};
      line-height: ${asRem(38)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(32)};
      line-height: ${asRem(42)};
    }
  }

  ,
  h4 {
    font-family: poppins-semibold;
    font-size: ${asRem(20)};
    line-height: ${asRem(28)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(24)};
      line-height: ${asRem(34)};
    }
  }

  ,
  h5 {
    font-family: poppins-semibold;
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(20)};
      line-height: ${asRem(30)};
    }
  }
`;

var StyleSleep = styled.span `
  margin: 0;
  padding: 0;
  font-family: var(--sleep-fontfamily1), 'Georgia', serif;
  font-variant: lining-nums;
  color: ${({ theme }) => theme.colors.sleep.beige.c100} !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  h1 {
    font-size: ${asRem(32)};
    line-height: ${asRem(42)};
    font-weight: normal;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(48)};
      line-height: ${asRem(58)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(55)};
      line-height: ${asRem(55)};
    }
  }

  h2 {
    font-size: ${asRem(24)};
    line-height: ${asRem(34)};
    font-weight: normal;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(28)};
      line-height: ${asRem(38)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(36)};
      line-height: ${asRem(36)};
    }

  }

  h3 {
    font-size: ${asRem(20)};
    line-height: ${asRem(28)};
    font-weight: bold;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(24)};
      line-height: ${asRem(34)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(26)};
      line-height: ${asRem(27)};
    }
  }

  h4 {
    font-size: ${asRem(18)};
    line-height: ${asRem(28)};
    margin-bottom: 0;
    font-weight: bold;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(18)};
      line-height: ${asRem(26)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(22)};
      line-height: ${asRem(23)};
    }
  }

  h5 {
  }
`;

const Headline = ({ level, className = '', children, ...props }) => {
    const isSleep = useIsTheme(themeSleep);
    const Tag = `h${level}`;
    return isSleep ? (jsx(StyleSleep, { children: jsx(Tag, { className: [`mime-elements-headline-${level}`, className].filter((c) => !!c).join(' '), ...props, children: children }) })) : (jsx(Style$8, { children: jsx(Tag, { className: [`mime-elements-headline-${level}`, className].filter((c) => !!c).join(' '), ...props, children: children }) }));
};

const Image = ({ src, className = '', alt = '', height, sizes, srcSet, width, ...props }) => {
    return (jsx("img", { src: src, className: `mime-elements-image ${className}`, alt: alt, height: height, sizes: sizes, srcSet: srcSet, width: width, ...props }));
};

var Style$7 = styled.div `
  width: 100%;

  .form-control {
    display: block;
    width: 100%;
    padding: ${asRem(16)} ${asRem(12)};
    font-size: ${asRem(15)};
    font-weight: 400;
    line-height: 1.5;
    appearance: none;
    background-clip: padding-box;
    border-radius: ${asRem(6)};
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    color: ${({ theme }) => theme.colors.input.text};
    background-color: ${({ theme }) => theme.colors.input.background};
    border: 2px solid ${({ theme }) => theme.colors.input.border};

    &:focus {
      outline: 0;
      box-shadow: none;
      color: ${({ theme }) => theme.colors.input.focus.text};
      background-color: ${({ theme }) => theme.colors.input.focus.background};
      border-color: ${({ theme }) => theme.colors.input.focus.border};
    }
    &[disabled] {
      opacity: 0.7;
      color: ${({ theme }) => theme.colors.input.disabled.text};
      background-color: ${({ theme }) => theme.colors.input.disabled.background};
      border-color: ${({ theme }) => theme.colors.input.disabled.border};
    }
    &.is-invalid {
      outline: 0;
      box-shadow: none;
      padding-right: ${asRem(56)};
      background-repeat: no-repeat;
      background-position: right ${asRem(14)} center;
      background-size: ${asRem(28)} ${asRem(28)};

      color: ${({ theme }) => theme.colors.input.error.text};
      background-color: ${({ theme }) => theme.colors.input.error.background};
      border-color: ${({ theme }) => theme.colors.input.error.border};
    }
    &.is-valid {
      color: ${({ theme }) => theme.colors.input.success.text};
      background-color: ${({ theme }) => theme.colors.input.success.background};
      border-color: ${({ theme }) => theme.colors.input.success.border};
    }
  }
`;

var SleepStyle$2 = styled.div `
  width: 100%;

  .form-control {
    font-family: var(--sleep-fontfamily2), sans-serif;
    display: block;
    width: 100%;
    font-size: ${asRem(18)};
    font-weight: 400;
    line-height: ${asRem(23)};
    appearance: none;
    padding-right: ${asRem(12)};
    padding-left: 0;
    color: ${({ theme }) => theme.colors.sleep.beige.c100};
    border: none;
    background: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.sleep.blue.c200};

    &::placeholder {
      font-weight: 400;
      color: ${({ theme }) => theme.colors.sleep.beige.c100};
    }

    &:focus, &:focus-visible {
      outline: 0;
      box-shadow: none;
      color: ${({ theme }) => theme.colors.sleep.beige.c100};
      border-bottom: 2px solid ${({ theme }) => theme.colors.sleep.blue.c200};
      background-color: ${({ theme }) => theme.colors.sleep.blue.c400};
    }

    &[disabled] {
      opacity: 0.7;
      color: ${({ theme }) => theme.colors.input.disabled.text};
      background-color: ${({ theme }) => theme.colors.input.disabled.background};
      border-color: ${({ theme }) => theme.colors.input.disabled.border};
    }

    &.is-invalid {
      border-color: ${({ theme }) => theme.colors.sleep.red.c500};
    }
  }

  .feedback-message {
    font-weight: 400;
    font-size: ${asRem(14)};
    color: ${({ theme }) => theme.colors.sleep.red.c500};
  }
`;

const InputComponent = ({ id, name, className, type = 'text', feedbackMessage, disabled, placeholder, valid, dataCyName, onChange, onBlur, ...props }, ref) => {
    const ThemeStyle = useIsTheme(themeSleep) ? SleepStyle$2 : Style$7;
    return (jsx(ThemeStyle, { children: jsxs(FormGroup, { children: [jsx(Input$2, { id: id, "data-cy-name": dataCyName, innerRef: ref, className: ['mime-elements-input', className].filter((c) => !!c).join(' '), name: name, type: type, valid: valid, invalid: valid !== undefined ? !valid : undefined, placeholder: placeholder, disabled: disabled, onChange: onChange, onBlur: onBlur, ...props }), feedbackMessage && (jsx(FormFeedback, { valid: valid, className: "feedback-message", children: feedbackMessage }))] }) }));
};
const Input$1 = React__default.forwardRef(InputComponent);

var StyledLink = styled.span `
  .link,
  a {
    display: inline;
    color: ${({ theme, color }) => color ? (isPrimaryColor(color) ? theme.colors[color].c500 : color) : theme.colors.link.color};
    text-decoration: underline;
    text-decoration-line: underline;

    &:focus,
    &:hover {
      // use underline instead of outline
      // for highlight. btn-link has this by
      // default, but <a> does not.
      outline: none;
      color: ${({ theme }) => theme.colors.link.hoverColor};
      transition: color 0.15s ease-in-out;
      cursor: pointer;
    }
  }
`;

const getSleepColorPrimaryShade = (colorName) => {
    switch (colorName) {
        case 'beige':
            return 'c100';
        case 'blue':
            return 'c300';
        case 'red':
            return 'c500';
        default:
            return 'c300';
    }
};

var StyledLinkSleep = styled.span `
  .link,
  a {
    display: inline;
    color: ${({ theme, color }) => color
    ? isSleepPrimaryColor(color)
        ? theme.colors.sleep[color][getSleepColorPrimaryShade(color)]
        : color
    : theme.colors.link.color};
    text-decoration: underline;
    text-decoration-line: underline;

    &:focus,
    &:hover {
      // use underline instead of outline
      // for highlight. btn-link has this by
      // default, but <a> does not.
      outline: none;
      filter: brightness(160%);
      transition: color 0.15s ease-in-out;
      cursor: pointer;
    }
  }
`;

const Link$2 = ({ component: PassedComponent, to, href, className, color, children, onClick, dataCyName, ...props }) => {
    const ThemedLink = useIsTheme(themeSleep) ? StyledLinkSleep : StyledLink;
    let link = null;
    if (to && PassedComponent) {
        link = (jsx(PassedComponent, { className: "link", to: to, "data-cy-name": dataCyName, ...props, children: children }));
    }
    else if (onClick || href) {
        // Use onClick if provided, regardless of href
        link = (jsx("a", { href: href || '#', className: "link", "data-cy-name": dataCyName, rel: href ? 'noopener noreferrer' : undefined, target: href ? '_blank' : undefined, onClick: (event) => {
                // If no href is provided, prevent default navigation
                if (!href) {
                    event.preventDefault();
                }
                onClick && onClick(event);
            }, ...props, children: children }));
    }
    return (jsx(ThemedLink, { className: `mime-elements-link ${className}`, color: color, children: link }));
};

// List Item Margins -> 3/4 of Fontsize
var ListStyle = styled.ul `
  list-style-type: disc !important;
  list-style-position: outside !important;
  margin-left: ${asRem(16)};
  padding-left: 0 !important;
  width: 100%;
  text-align: left !important;
  font-size: ${asRem(16)};
  line-height: ${asRem(24)};

  li {
    display: list-item !important; // Wichtig für Bullet-Anzeige
    list-style-type: disc !important;
    &::marker {
      unicode-bidi: isolate;
      font-variant-numeric: tabular-nums;
      text-transform: none;
      text-indent: 0px !important;
      text-align: start !important;
      text-align-last: start !important;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};
  }

  &.withIcons {
    list-style: none;
    margin-top: ${({ theme }) => asRem(theme.spacing.two)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.four)};

    li {
      display: flex !important;
      align-items: center;
      list-style-type: none !important;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        align-items: center;
      }
    }

    .icon {
      align-self: flex-start;
      margin-right: ${({ theme }) => asRem(theme.spacing.two)};

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        align-self: center;
        margin-right: ${({ theme }) => asRem(theme.spacing.one)};
      }
    }
  }

  &.small,
  &.withIcons .small {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
    }

    li {
      margin-bottom: ${asRem(10.5)};

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        margin-bottom: ${asRem(12)};
      }
    }
  }

  &.small-bold,
  &.withIcons .small-bold {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
    }

    li {
      margin-bottom: ${asRem(10.5)};

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        margin-bottom: ${asRem(12)};
      }
    }
  }

  &.extra-small,
  &.withIcons .extra-small {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      line-height: ${asRem(18)};
    }

    li {
      margin-bottom: ${asRem(9)};
    }
  }

  &.extra-small-bold,
  &.withIcons .extra-small-bold {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      line-height: ${asRem(18)};
    }

    li {
      margin-bottom: ${asRem(9)};
    }
  }
`;

var ListItemStyle = styled.li `
  white-space: pre-line;
  width: 100%;
  align-items: center;
  margin-bottom: ${asRem(12)};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: ${asRem(13.5)};
  }

}`;

var ListItemStyleSleep = styled.li `
  font-family: var(--sleep-fontfamily2), sans-serif;
  font-size: ${asRem(18)};
  line-height: ${asRem(23)};
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  color: ${({ theme }) => theme.colors.sleep.beige.c100};

  white-space: pre-line;
  width: 100%;
  align-items: center;
  margin-bottom: ${asRem(12)};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: ${asRem(13.5)};
  }

}`;

const ListItem = ({ children }) => jsx(ListItemStyle, { children: children });
const List = ({ children, className = '', icon, ...props }) => {
    const ThemeListItem = useIsTheme(themeSleep) ? ListItemStyleSleep : ListItem;
    const renderItem = (child, index = 0) => {
        if (icon) {
            return (jsxs(ThemeListItem, { className: "mime-elements-list-item", children: [icon, " ", child] }, `ListItem-${index}`));
        }
        return (jsx(ThemeListItem, { className: "mime-elements-list-item", children: child }, `ListItem-${index}`));
    };
    return (jsx(ListStyle, { className: ['mime-elements-list', className, '', icon ? 'withIcons' : ''].join(' '), ...props, children: children && Array.isArray(children) ? children.map(renderItem) : renderItem(children) }));
};

var StyledParagraph = styled.p `
  white-space: pre-line;
  display: block;
  width: 100%;
  margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
  font-size: ${asRem(16)};
  line-height: ${asRem(24)};

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};
  }

  &.bold {
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
  }

  &.small {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};
    margin-bottom: ${asRem(14)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.small-bold {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};
    margin-bottom: ${asRem(14)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.extra-small {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      line-height: ${asRem(18)};
    }
  }

  &.extra-small-bold {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      line-height: ${asRem(18)};
    }
  }

  &.intro {
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};
    margin-bottom: ${asRem(18)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(20)};
      line-height: ${asRem(28)};
    }
  }
`;

var StyledParagraphSleep = styled.p `
  font-family: var(--sleep-fontfamily2) !important;
  color: ${({ theme }) => theme.colors.sleep.beige.c100} !important;
  font-weight: 400;
  font-size: ${asRem(16)};
  line-height: ${asRem(24)};
  letter-spacing: ${asRem(0.15)};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  align-self: center;
  margin: ${asRem(20)} 0 ${asRem(30)};

  white-space: pre-line;
  display: block;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${asRem(18)};
    line-height: ${asRem(23)};
  }

  &.bold {
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    font-weight: 600;
  }

  &.small {
    font-size: ${asRem(14)};
    line-height: ${asRem(24)};
    margin-bottom: ${asRem(14)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.small-bold {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};
    margin-bottom: ${asRem(14)};
    font-weight: 600;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.extra-small {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(14)};
      line-height: ${asRem(23)};
      line-height: ${asRem(18)};
    }
  }

  &.extra-small-bold {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};
    font-weight: 600;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(14)};
      line-height: ${asRem(23)};
      line-height: ${asRem(18)};
    }
  }
`;

const Paragraph = ({ className = '', children, ...props }) => {
    const ThemedParagraph = useIsTheme(themeSleep) ? StyledParagraphSleep : StyledParagraph;
    return (jsx(ThemedParagraph, { className: ['mime-elements-paragraph', className].filter((c) => !!c).join(' '), ...props, children: children }));
};

var StyledSpan = styled.span `
  font-size: ${asRem(16)};
  line-height: ${asRem(24)};
  margin: 0 !important;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};
  }

  &.small {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
    }
  }

  &.small-bold {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
    }
  }

  &.extra-small {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(12)};
      line-height: ${asRem(18)};
    }
  }

  &.extra-small-bold {
    font-family: Poppins-SemiBold;
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(12)};
      line-height: ${asRem(18)};
    }
  }

  &.intro {
    font-family: Poppins-Regular;
    font-size: ${asRem(18)};
    line-height: ${asRem(26)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(20)};
      line-height: ${asRem(28)};
    }
  }
`;

var StyledSpanSleep = styled.span `
  font-family: var(--sleep-fontfamily2) !important;
  color: ${({ theme }) => theme.colors.sleep.beige.c100} !important;
  font-weight: 400;
  font-size: ${asRem(16)};
  line-height: ${asRem(24)};
  letter-spacing: ${asRem(0.15)};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  align-self: center;
  margin: ${asRem(20)} 0 ${asRem(30)};

  white-space: pre-line;
  display: block;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${asRem(18)};
    line-height: ${asRem(23)};
  }

  &.bold {
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    font-weight: 600;
  }

  &.small {
    font-size: ${asRem(14)};
    line-height: ${asRem(24)};
    margin-bottom: ${asRem(14)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.small-bold {
    font-size: ${asRem(14)};
    line-height: ${asRem(22)};
    margin-bottom: ${asRem(14)};
    font-weight: 600;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(16)};
      line-height: ${asRem(24)};
      margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
    }
  }

  &.extra-small {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(14)};
      line-height: ${asRem(23)};
      line-height: ${asRem(18)};
    }
  }

  &.extra-small-bold {
    font-size: ${asRem(12)};
    line-height: ${asRem(20)};
    letter-spacing: ${asRem(0.1)};
    margin-bottom: ${asRem(12)};
    font-weight: 600;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${asRem(14)};
      line-height: ${asRem(23)};
      line-height: ${asRem(18)};
    }
  }
`;

const Span = ({ className = '', children, ...props }) => {
    const ThemedSpan = useIsTheme(themeSleep) ? StyledSpanSleep : StyledSpan;
    return (jsx(ThemedSpan, { className: ['mime-elements-span', className].filter((c) => !!c).join(' '), ...props, children: children }));
};

const BottomLine = ({ primaryColor }) => (jsx("svg", { enableBackground: "new 0 0 2400 9.5", viewBox: "0 0 2400 9.5", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { "clip-rule": "evenodd", d: "m1304.6 8-1.4-.1-.7-.1-.6-.1-.4-.1-.5-.1-.5-.1-.5-.2h-.2l-.5-.1-.5-.1h-.6l-1.1-.1h-1.5-2.6s0-.1.1-.1h.2l.6-.1h.8l2.6-.1h.4.3c.1 0 .1-.1 0-.1h-.2l-.3-.1h-.2l-14.9-.9h-.1-.3-.6-1-2.3-3c.3.3-.2.5-1 .6l-.5.1h-.6-1-3.2-.4-.2c-.2 0-.2.1-.1.2l.2.1.5.1.8.2.7.1c-3.8 0-7.6 0-11.2 0l-5.4-.1-15.6-.2-5-.1c-6.7-.1-13.2 0-19.8.2-.2 0-.5-.1-.7-.1l-.9-.1c-.2 0-.3 0-.5 0l-1-.1-1.1-.1-1.8-.1-1.9-.1-2-.1-3.6-.1-12.1-.1-2.4-.1-1.6-.1-1.4-.1-1.2-.1-.6-.1c-1-.1-1.4-.4-1.1-.6h-3c-.5 0-1 0-1.5 0h-2.8l-2.7.1-2.6.1-2.5.1c-.4 0-.8 0-1.2.1l-2.3.1c-1.1.1-2.2.2-3.2.3l-2 .2c-.3 0-.6.1-1 .1 1.2.1 2.5 0 3.8 0l2-.1h.9c-.2 0-.4.1-.6.1l-.8.1-1 .1-1.8.1h-1.4l-3 .1-3.9.1h-5.7-1.7l2.1-.1 9.3-.5 3.7-.2 2.6-.2 1.6-.1 1.5-.1c.7-.1 1.4-.1 2-.2l-3 .1-3.1.1-5.6.2-16.2.7-2.4-.9c-2.2.2-3.7.2-4.9.2h-.8l-1.1-.1-1.1-.1-.8-.1h-.8c-1 0-2.3 0-4.1.2l-.8.1 1.5.3h-1.2-2.2-2-1.8l-2.3.1-2.7.1-4.9.3-2.7.2-2.3.1-1.7.1h-1.9-2.2l.6-.4c-1.2 0-2.6 0-4.1 0l-3.4.1c-2.6.1-5.3.1-7.5-.2l-.9-.1h8.7c-.2-.1-.6-.3-1.2-.4l-.8-.1c-.1 0-.3 0-.4-.1l-1-.1-2.1-.2-3.2-.3-1.4-.1c-.1 0-.3 0-.4 0h-1.5-.8l-1 .1h-.6l-.5.1-.4.1-.4.1-.2.1-.1.1-.1.1-.1.1-.1.2-.1.1s-.1 0-.1.1l-.2.1-.3.1h-.4-.6c-.1 0-.2 0-.4 0l-.5-.2-.2-.1c-.1-.1-.2-.1-.1-.1h.1l.4-.1 1.4-.2.6-.1 1-.2-8.3.2-3.7.1-6.1.2-3.5.1-2.3.1-2.1.1c-.3 0-.7 0-1 .1l-1.9.1c-.9.1-1.8.1-2.6.2-.3-.1-.2-.1-.1-.2h.1.1c-2.3 0-4.6 0-6.8.1l-2.6.1-3.7.2-3.5.2-2.2.1-2.1.1c-1.7 0-3.3 0-4.8-.1l-.9-.1 2.1-.1c-1-.1-2.1-.2-3.2-.2h-1.4c-.2 0-.5 0-.7 0h-1.4-2.1l-3.5.1-4 .1h-1.8-1.1-1-.9c-1.5-.1-2.5-.3-3-.6l-.7-.1h-.1.1.3l3.7-.1h.6.3.1.1s0 0 0-.1h-.1l-.4-.1-.4-.1-.9-.1h-1.4-1.8-1.1-1-1.2-.7l-1-.3-.8.1-1 .1-1.7.3-.8.1-.6.1-.7.1h-.7-.8-.9-1.6-1.3-.4.6.1.2.1l.1-.1s.1 0 .2-.1h-6.2l-8.4.1-13.3.2c-2.3-.3-5.2-.4-8.4-.5h-2.8-2.9-6.1-6.3-3.1-3.1c-5.1 0-9.8-.2-13.7-.7l.6.1.4.1c.3.1.4.1.2.2h-.2l-.5.1-.8.1-2.1.2h-.4-.1c.1 0 .1-.1 0-.1h-.1-1.1-1-.8l-.7.1-.6.1-.7.1-1.8.3-.4.1c-.6-.1-1.3-.1-2.2-.1h-1.3-1.3-2.2l-4.2.2h-1.2-1.1c-.7 0-1.2 0-1.6-.1 0 .1-.2.1-.5.2h-.4-.5-1.4-2.5-2.6l2-.1 1.1-.1.8-.1.4-.1.3-.1.2-.1.1-.1v-.1-.1-.1-.1l.1-.1.1-.1.2-.1.3-.1.4-.1h.2c-1.4 0-2.6 0-3.7 0h-1.6l-1.5.1-1.4.1-1.3.1-2.4.2-3.1.9-1.2.1-1.2.1-1.3.1-1.4.1h-1.5c-.5 0-1 0-1.6 0h-1.7c-.3 0-.6 0-.9 0h-1l-7.1-.6c-.3.1-1.1.3-2.1.4l-.9.1-1 .1-1.7.1-2.3.1-3.4.1h-.7-.5c-.3 0-.4.1-.4.1l-3.3-.4c-.1 0-.2 0-.3 0l-.5-.1-.4-.1c-.4-.1-.5-.2-.4-.3-.8 0-1.7.1-2.7.1h-1.9-5.3-1.2-1.1-1c-.6 0-1.1.1-1.5.2l-.3.1 5.1.2c-2.2 0-4.3-.1-6.2-.1h-2.9l-2.8.1-2.6.1-9.8.1-2.4.1c-3.1.1-6.3.1-9.6-.1l-1.3-.1.2-1.4c-3.2-.2-6.3-.1-9.2 0l-4.3.2c-2.9.1-5.6.1-8.5-.2l1.5.3h.2.1-.1l-.4.1-3.5.3h.6 1.3 1.5l6.9-.2h1.8.9.9l-10.9.8 17-.4-4.7.4-.7.1h-.2-.1-.1.1.1l.4.1 1.4.3c-2.2.1-4 .1-5.5.1h-1.4-1.3l-4.2-.2h-1.2c-.2 0-.4 0-.7 0h-1.4c-1.5 0-3.2 0-5.3.2l-.7-.2c-.9-.1-1-.2-1.1-.3v-.1c-.1-.1-.3-.3-1.3-.4l-.8-.1c-3.1.2-6.1.1-9 0l-2.8-.1-2.7-.1c-1.8-.1-3.5-.2-5.1-.1h-1.2l.5-.1c.2 0 .3-.1.3-.1l-6.7.1h-1.5-.9l-.8.1c-.1 0-.2 0-.4 0l-.6.1c-.1 0-.2 0-.3 0l-.2.1 4.9.2h-1.2-.7-.7l-2.9.2h-1.2-.9-1-1.1-2l-1.5-.1-1.7.1-1.1.1-.7.1-.6.1-.5.1-.2.1v.1c-.1.1-.1.1 0 .1h.1.1l.5.1h.4.9.7-.5-.5-.9-.9l-.8-.1-.5-.1h-.5-.4c-.5-.1-.6-.2-.1-.4h-.8-1.5-1.3-1.1l-.9.1-.8.1-.7.1-.8.1-1.9.4-.4.1h-.9-.6-.7-.8-1-1.2l-1.3-.1-1.6-.1.9-.1h.4c.1 0 .2-.1 0-.1h-1-1.9-1.7-.5l1-.1.5-.1h.2c.2-.1.2-.1.2-.2h-.1l-.2-.1-.4-.2h-.1v-.1h.1.2.3.6.6 1.1 1.5 1.2c-.3-.1-.8-.2-1.6-.3h-.8-.9-1.4-5.7-1.4c-.7 0-1.3 0-1.8-.1l-1.2.1-.6.1-.5.1c-.1 0-.1 0-.2 0l-.3.1-.2.1c-.2.1-.2.2-.2.3v.1l.2.2.1.1c.1.1-.1.3-1 .4 0-.1-.2-.1-.5-.1h-.4-.6l-1.8-.1-2.3-.3 3 .6h-2.9-2c-.7 0-1.4 0-2.2.1h-1.1l5.2-.2h-1.5l-1.6-.1-5.4-.3-2-.1-2.1-.1-2.2-.1c-2.9-.1-6.1 0-9.4.1l2.3-.2 1.1-.1.6-.1h.2.1c.1-.1.1-.1-.1-.2h-.2-.3l-.7-.1h-.6l-1.1-.2-3.3.1h-1.2-.5c-.2 0-.3 0-.5 0h-.3-.2c-.1 0-.1-.1-.1-.1v-.1-.1s0-.1-.1-.1l-.1-.1-.2-.1-.3-.1-.4-.1-.6-.1-.9.2h-1.6l-1.7.1-.9.1-.9.1-.5.1-1.5.3h-.4l-.6-.1-1.3.1h-.9-1.5-2.5l-3.4-.1h-.4-.2c-.1 0-.1.1 0 .1l.2.1.3.1.5.1.9.1h.5l-3.1-.1h-2.8-3.9-7.4-2.5-2.7l-2.7-.1 1.6.1 1 .1.5.1h.1c.1 0 .1 0 0 .1h-.1-.2l-.6.1h-1.3l-1.5.1.3-.1c.2 0 .2-.1.1-.1h-.2-.3-.4l-1.3-.1-4-.1-4.3-.1-1.8-.1-1-.1-1.1.3-.5-.2h-.3-.2c-.1 0-.1-.1 0-.1h.1.4l.7-.1 2.9-.1s0 .1.2.1h.5.7 1 .4.6l.8-.1.4-.1.4-.1h.1l.2-.1c.3-.1.3-.2.1-.4l-.3-.1-.4-.1-.7-.1-.6-.1-.6-.1-.7-.1-1.2-.1-1.4-.1h-1c-.2 0-.4 0-.5 0l-2.1.1-1.3.1-1.1.1-.8.2h-.5l-.5.1-.3.1h-.1l-.2.1-.1.1c-.1 0-.1.1-.1.1v.1l.1.1.1.1.2.1.4.1.3.1c-1.4 0-2.7 0-3.8 0h-1.6c-.7 0-1.4.1-2 .1l-1.2.1-1.1.1-3.5.4-1 .1-1.1.1-1.2.1c-1.5.1-3.4.1-5.8 0h-.6l-1.2-.1-2.6-.2-4.6-.4-2.3-.2-2.4-.2-1.6-.1-1.6-.1c-.3 0-.5 0-.8 0h-1.6c-1 .1-1 .2-.4.3h.4l.7.1 4.4.2.7.1h.3c.4.1.4.1-.2.2l-.5.1c-5.5-.6-11.2-.6-17.1-.4l-5 .2-3.4.1-3.5.1c-4.7.2-9.6.2-14.8 0l-2-.1 2.2-.8h-4.7-3.2c-1.1 0-2.2 0-3.3 0h-1.7l6.1.4h-1.6-1.8-2.7l-2.2-.1-1.2-.1-.8-.1h-.4-.3l.2 0c-.2-.1-.1-.2.5-.3l-2.1.1-1.9.1-1.7.1h-1.5-1.4-1.3-1.3-1.3l-5.5-.2-2-.1h4.4-.2c-.1 0-.1 0 0-.1h.2l.5-.1 1.5-.1h.4l-2.5-.1-2.8-.1h-1.7-1.5-1.8l-6.2.2c-.2 0-.4 0-.6 0 .4-.1.2-.2-.2-.3l-.4-.1h-.6l-.9-.1-1.3-.1h-1-.6l-1.6.1-1.8.1h-1.9l-3.1.1-4.4.1-5.9.1-3.6.1c-.6 0-1.2 0-1.8 0h-1.7v-.2c-4.9.1-9.9 0-15 0l-7.6-.2c-6.4-.1-12.8-.2-19 0l-4.5.2h1.2.2l.4.1.2.1c.2.1.2.1 0 .2h-.5-.6l-1.6.1-4.1.1-6.6.1h-1.7-1-.8l-.4-.1-.7-.2-.4-.1c-.1 0-.1 0-.2 0l-.5-.1h-.6c-.1 0-.2 0-.4 0h-.8c0 .2-.7.3-1.6.4h-.7l-3.4.2h-.8-.7c-.2 0-.4 0-.6.1h-.8-.6c-.1 0-.2 0-.2 0l-.4-.1c-.1 0-.1 0-.1 0l-.2-.1-.1-.1-.3-.2s-.1 0-.1-.1l-.2-.1h-.1-.3-.5-.6-.8-1-1.8-.8-.7c-.1 0-.2 0-.3 0l-.5.1-.4.1-.3.1c-.5.1-.5.3-.3.4l-.4-.1-.7-.1-.8-.1-1-.1-1.6-.1-2.5-.1-2.6-.1-1.9-.1c-.2 0-.4 0-.6 0 .6-.1 1.3-.1 2-.1h1.1 1 .8.3c.2-.1 0-.2-.3-.2l-.5-.1-.6.1h-.5c-.4-.1-.7-.1-.6-.3h-.8-.6c-.2 0-.3 0-.5 0h-.4l-.4.1-.4.2h-.4-.3-.4-.7-.6-1.3l4.7-.5c-.8-.1-1.6-.1-2.4 0h-1.2l-1.6.1h.3c2-.2 2-.5 1.7-.8l-.1-.1h-.1-1.5l-1.6.1-.9.1-.7.1h-.5l-.3.1-.2.1c-.3.1-.3.2-.2.3l.1.1.2.1.4.1 1.3.4.4.1c.4.1.6.3.5.4-5-.2-9.5-.2-13.8-.1l-4.7.1-4.5.1c-1.5 0-2.9.1-4.4.1h-1.5l1.6-.6h-1.4l-2.3.1-1 .1-.8.1-.7.1-.7.1-.6.1h-.3-6.6l1.5-.1 1.2-.1.7-.1.5-.1c.8-.1 1.2-.3 1.3-.6l-2.4.1-7.1.1h-2-1.2l-1.2.1-1.1.1c-.3 0-.7.1-.9.1l-.8.1c-.5.1-.9.2-1.2.3h-.1l.3-.1-3.5-.1-18.5-.4-3.2-.1-1.9-.1h-.6-.3-.1c-2.1 0-4.3 0-6.5 0h-9.4-2-1.7l-1.4.1-.8.1-.4.1c-.3.1-.5.1-.6.2h-.5c-1.3 0-2.7 0-4.2-.1l-2.1-.1-3.6-.2-1.6-.1h-1.5c-2.5-.1-4.7 0-6.2.4l-2-.2-.9-.1h-.2-.1.1.4l2-.1 1-.1.6-.1.3-.1.3-.1h.1c-1.5-.1-3-.1-4.5-.1h-1.5l-1.3.1-3.3.2h-1.2c-2.1.1-3.8 0-4.7-.5l-2.3.1-.7.1h-.2-.1.2l2.2.2h.3c.3.1.4.1.1.2l-.3.1c-.3-.2-.9-.3-1.8-.4l-.8-.1h-.9-1-1.7-2.5-4.1-3.2-2.1c-1.7 0-3.3-.1-4.7-.2l-.5.1-.3.1-.2.1c-.1 0 0 .1.1.1h.2l.6.1h.1c.1 0 .1 0 0 .1h-.2l-.5.1h-1.6c-.1 0-.3 0-.5 0 .2-.1 0-.1-.3-.2h-.4-.5l-1.1-.1h-2l-1.5.7-7.9-1.8-1.6.1-.8.1-.7.1-.7.1-.6.1-.3.1-.2.1s0 0-.1 0l-.1.1v.1.1l.1.1h-.1l-.3.1h-.3l-.8.2h-.9l-1.7.1-3.1.1h-.8l.9-.1c-1.1-.2-2.4-.3-4-.2h-1.2l-5.7.2-2.5.1h-1.8c-2.2 0-4.5 0-7.2-.1h1.1.5.2.3.2c.2-.1.2-.1.2-.1v-.1c0-.1 0-.2.3-.2h.1l-6.2.3h.4.1c.1 0 0-.1-.3-.1-.4 0-.8-.1-1.2-.1l-1-.1c-.2 0-.3 0-.4 0h-.8c-.1 0-.2 0-.4 0h-.7l-1.6.1h-.7-.8-1-1.2c-.4 0-.9-.1-1.4-.1h.8.6.5l.4-.1c.8-.4.8-.5.6-.6l-.2-.1-.2-.1-.3-.1-.5-.1h-.3-.6l-8.7.8 3-.8h-7-.2l-6 .3-2.5.1h-1.5-1.5c-.5 0-.9 0-1.4 0h-1.3c-1.7 0-3.1-.2-4.2-.4h-.1-17.3-.2l-1.3.2-.7.1c-.6.1-1.2.1-1.8.2l.1-.1.4-.1.2-.1c.2-.1.2-.2-.2-.2h-.8-.2c-5.1.4-9.9.4-14 0h-9.5v-3.6h2400v3.6h-.5-.1l-.5.4c-.1.1-.2.2-.3.3l-.1.1-5.8.2c0 .1.3.2.6.2l.5.1.6.1h.6l.7.1 1.2.1h1.2 1.2c.3 0 .4.1.2.1l-.2.1-.3.1-.7.1-.9.1-2.2.2-2.7.2-2.4.2-2.9.2-2.3.1h-1.2-2.9l-2.2-.1-1.3-.1h-.7l-.8-.1-.6-.1-.3-.1-.2-.1-.2-.1-.1-.1-.1-.1-.1-.1-.1-.2-.1-.1-.1-.1-.1-.1-.2-.1-.4-.1-.3-.1-.7-.1-.9-.1-1.2-.1h-1.5l-15 .6-.2-.4c-1.1-.1-2-.1-2.7 0l-.6.1-1.1.2c.1-.1.1-.1-.1-.1h-.3-.4-.8-1.3-2.1-2.9-6-2.8-1.6l2.2.5c-6.2.4-11.5.4-16.3.2l-2.6-.1-2.5-.1-4.9-.3c-.4 0-.8 0-1.2-.1l-2.4-.1c-2.9-.1-5.8-.2-8.8-.1l-1.3.1-9.5.8-2-.7-1 .1-2.2.2-2.4.2-.8.1-.9.1h-.9-1.6-1.2c-.2 0-.4 0-.7 0h-1.4l-2.5-.1c-13.9-.5-28.3-.6-42.8-.5l-18.7.1c-12.4.1-24.8.1-36.9-.2.1 0 .3.1.5.1l.5.1h.5-.5c-10.3-.6-19-.4-27.2-.1l-3.7.2-9.2.4c-8 .4-16.1.6-25.4.2l-2.1-.1 1.8-.3h-4.3-1.2-.1l.3-.1.7-.1.3-.1s0 0 0-.1h-.1-.2l-.5-.1-1-.1-1.5-.1c-.2.1-.4.2-.8.2l-.6.1-.8.1-.9.1-1 .1-1.1.1-2.4.1-5.4.4-6.2.1-3.1.1-1.7.1c.3 0 .7-.1 1.1-.1h1l2.7-.1 1.1-.1-.4-.1-1.2-.3-.5-.1-.6-.1c-.7-.1-1.7-.1-3 0-.4.1-.9.1-1.4.2l-1.5.2-1.6.1-1.8.1-1.9.1-3 .1-3.2.1-3.3.1-4.5.1-11.8.2-3.7.1c-.6 0-1.2 0-1.8 0-.1 0-.2-.1-.3-.1l-.5-.1-.9-.1-1.2-.1-2.9-.3-5.4-.5-1.8-.2-1.8-.2c-.3 0-.6-.1-.9-.1l-1.6-.2c-.5-.1-1-.1-1.5-.2l-.9.3-3.1.5-2 .4c-3.3-.3-6-.2-8.5 0l-1.6.1-1.6.1h10.7l-.3.1h.3.7.7-1.4l1-.2c.6 0 1.1.1 1.7.1h-.5-.6 2.9.7.1l1.1.1.6.1.2.1h.1c.1 0 .1.1 0 .1h-.1l-.5.1-.7.1-.4.1c-.3.1-.6.2-.6.3v.1h-3.4-3.2-2.8-1.5-1.3-.7l-.6-.1c-.3 0-.6-.1-.7-.2h-1.8-1.7l-3.5-.1c-1.3.1-2.7.1-4.2.1h-1.1l.9-.1c-.3-.1-.7-.2-1.1-.2-3.5-.1-7.5 0-11.5.2l-2.7.1-2.6.2-5 .3-5.4.4 1.1-.1.5-.1.6-.1.3-.1c.3-.1.3-.2.1-.3l-.2-.1-.2-.1-.4-.1-2.1-.3-.5-.1c-.5-.1-.8-.2-.8-.3h.7l9.2.1h8.7c-.8-.1-1.4-.2-1.6-.4-1.9-.1-3.6-.2-5.3-.2h-1.7-1.7l-3.5.1-4.6.2-2 .1h-2.1-2.2c-.4 0-.8 0-1.2 0h-2.4l-2.6-.1 1-.1.4-.1.3-.1c.3-.1.4-.1.2-.2-.4 0-.8 0-1.2 0h-1.2c-.2 0-.4 0-.6 0h-1.1-1.1l-1 .1-.9.1-.8.1-.7.1-.6.1-.5.1c-.1 0-.3.1-.4.1-.1-.1-.4-.1-.8-.2l-.7-.1-.8-.1-1-.1-1.6-.1-1.8-.1-1.9-.1h-1.3-1.9-1.2-1.2-1.1-1l-3.4.4-.6.1-1 .1h-.8-.9-1.1-1.3-2.7l3.5-.4-2-.1h-1.1-1-1.3-1.1l-1.5.1-2.2.2h-.7-1.3-1-1.2-.4.6.4.3.2c.1 0 .1-.1 0-.1l-.2-.1h-.1-.4-.5-.3l-3.3.1-2 .1-1.7.1-1.9.1-1.6.1-2.5.3-4.3.5 1.3-.7-7.9.4-5 .2-2.6.1-3 .1h-2.1-1.3-.8-.6c-.4 0-.7-.1-.9-.1h-.1c0 .1-.1.2-.5.3l-.4.1-.5.1-.6.1-1.1.1h-.8l-1.8.1h-2.6-2.3-1.8l-5.7-.1-7.4-.1c-.2 0-.4 0-.5 0h.9.7l.5-.1h.2l.3-.1.3-.1.2-.1.2-.1c-8.3.5-16.7.5-25.2.3l-11.3-.3c-2.4 0-4.8-.1-7.2-.1h-3.6l-2.5-1c-2.8 0-4.8.2-6.8.5l-1.4.2-2.8.5c-2.1.4-4.4.7-7.6.7h-1.1l3.2-.5-10.9.1h-6.5-5.2-4.7l-7.9-.1.2-.7c-1.7.1-3.6.2-5.5.3l-3.9.1c-1.9.1-3.8.1-5.6.3-.9-.1-1.9-.2-3.1-.3l-1.4-.1-1.6-.1h-1.7c-.3 0-.6 0-.9 0h-1.8-2.9-3.1l-4.3.1-11.5.2h-3.7c-1.2 0-2.4 0-3.5 0h-3.5-3.5c-4.6-.1-9-.2-12.9-.5l-1.5-.1-1.2 1.2h-4-4-2.4-1.5-1.5l-1.4-.1-1.3-.1c-1.5-.1-2.7-.2-3.6-.4l-.4-.1h1.6c.2-.2-.1-.3-.6-.4h-.5-.6-1-1.5l-3.6.1c-1.5 0-2.9.1-4.1 0h-1l-.9.1-.9.1-.8.1-.7.1-.3.1c-.1 0-.1 0-.1 0l-.2.1c-.3.1-.2.2.3.3h.4.3l-2.4-.1-3.7-.1-6.5-.1-12.3-.1h-9.5-6.5l-4.9-.1-3.5-.1-3.2-.1-2-.1-1.9-.1c-.3 0-.6 0-.9 0l-1.7-.1c-.5 0-1-.1-1.5-.1l-2.6.1-5 .1-7.2.2-13.1.4-5.5.2-3.8.1-3.8.1c-.6 0-1.3 0-2 0h-4c-.7 0-1.4 0-2.1 0h-4.2-2.2l.2-.1-5-.1-2.8-.1-4.2-.2-2.3-.1-2.1-.1-1.4-.1-.8-.1-.7-.1-.6-.1c-.9-.1-1.4-.3-1.4-.5h-1.5l-2.9.1-2.8.1-2.7.1-5.3.3-5.2.3-4 .2c-.5 0-.9 0-1.4.1l-2.8.1-2.9.1c-3 .1-6.2.1-9.7 0h-1.8l3.9-.4h-1.2-1.2-1.3-2l-2 .1-2.4.1-3.7.2h-.5-.3c-.1 0-.1-.1-.1-.1l.1-.1.5-.2c-2.3-.2-4.2-.1-5.9 0l-2.2.2c-.5 0-1 .1-1.5.1h-.8l1.4-.4c-3.6-.2-7.7-.2-12.2-.2h-3.4l-3.5.1-3.6.1-14.3.1-3.7.1-3.7.1h-3.7c-2.4 0-4.8 0-7.1 0h.9l.6-.1h.1.2c.1 0 .1-.1.1-.1l-.1-.1-.3-.1-.5-.1-.4-.1-.5-.1c-.5.1-1.1.2-1.7.2l-1.3.1c-.2 0-.5 0-.7.1l-1.5.1-1.6.1-1.7.1-1.8.1-1.9.1-3.8.1-5.6.1-9.9.1h-2.9-1.2-.6l4.8-.5-1.7.1-1.5.1h-1.4-1.9-1.1-1l-1.4-.1-1.7-.1-1.9-.2-2.1-.2-1.2-.1-1.3-.1-1.4-.1h-1-1.1-1.2-2l-1.5.1-1.6.1 8.6.7h-.9-1.8-1.8-1.3-1.5-.9-.5-.5l-.4.1-.3.1c-.4.2-.4.3-.1.4zm-733-4.2h.8.4.4.1.1-10.3.4l4.5.1h.1-.3 2.3zm-22.8-.2h.2-4.9zm-283.9.5h1.5 1.5 1.5l1.4-.1 1.4-.1 1.2-.1 1.1-.1c.3 0 .5-.1.7-.1h-7.3.1c.1 0 .1.1 0 .1h-.1-.2-.3-.4l-1.3.3zm-12.9-.1h.7.6.5.4l.5-.1.4-.1.2-.1.2-.1h-7.1l-.4.3 1.8.1h1.5zm-9.9-.1 4.9-.2 1.3-.1h-11.7-.3-.6-.3c-.4.1-.5.2 0 .3 2.3.2 4.5.1 6.7 0zm-10.9-.2 1.4-.1h-6.6l-2.8.1c-.8 0-1.6.1-2.3.1 3.3.3 6.7.1 10.3-.1zm-49.3.3c2.5-.2 4.9-.4 7.2-.4h-3.1l-.7.1zm-92.3.3 2.3-.1 2.1-.1 2.7-.1 2.5-.2 3.1-.2h-11-.2l-1.1.1-.6.1-.5.1-.3.1c-.2.1-.3.1 0 .2l.3.1.4.1c.1-.1.2-.1.3-.1zm-69.7-.6h.9.2-3.4.3.7.8zm180.1 2.3c-.5-.2-.7-.3-.7-.4h.4c1.2-.1 2.3-.2 3.1-.4l-.3.2-.4.2c-.5.2-1.1.5-2.1.4zm-52.2 0h-1.9l-2.7-.1c-.2 0-.4 0-.6 0h1.5.7.3.2c.2 0 .2-.1.2-.1h-.1l-.3-.1-.8-.1-1.2-.2 11.2.2h-2.5-1.6-1.1-.4-.4-.2-.1-.1v.1h.1.1l.5.2h.1-.3zm1133.7.9-1.6-.1-.8-.1-.4-.1-.3-.1c-.3-.1-.3-.1-.2-.2l.1-.1.2-.1.2-.1h1.3l1.8-.3.3-.1h.1c.1 0 .1-.1 0-.1l.8.1 1.3.1.6.1h.3.2c.1 0 .1.1 0 .1l-.2.1-.4.1-1 .1-2.6.2-.7.1-.4.1h-.2c-.1 0-.1.1 0 .1h.2l.5.1zm-1092.7-.7c.1 0 .1 0 0 0l-.3-.1-1.9-.2h-.2-.1.1.3l1.1-.1h1.1l2.2.1.6.1h.2c.1 0 .1 0 0 .1h-.1l-.4-.1zm935 .1-1.3-.1c-1.3-.1-2.3-.2-3-.3h.9 1 1.2l4.9.2h1.5.8c-1.8.2-4 .3-6 .2zm-187.9.4h-.6-.5-.4-.3l-.2-.1c-.2-.1-.2-.2 0-.3l.2-.1.3-.1h.2l.4-.1h.4l.8-.1 1.4.7h-.9z", fill: primaryColor, "fill-rule": "evenodd" }) }));

var Style$6 = styled.label `
  --box-shadow: ${({ theme }) => `${theme.colors.black.o30} 0 -1px 1px inset, ${theme.colors.black.o30} 0 1px 3px`};
  --box-shadow-hover: ${({ theme }) => `${theme.colors.black.o80} 0 -1px 1px inset, ${theme.colors.black.o80} 0 1px 3px`};

  display: flex;
  min-height: ${asRem(48)};
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  padding: 0;

  .input {
    position: absolute;
    opacity: 0;

    &:checked + .track {
      background-color: ${({ theme }) => theme.colors.green.c500};
    }

    &:checked + .track .button {
      transform: translateX(100%);
    }

    &:disabled + .track {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  .track {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: ${asRem(40)};
    height: ${asRem(16)};
    background-color: ${({ theme }) => theme.colors.black.o30};
    border-radius: ${asRem(16)};
    box-sizing: border-box;
    transition: 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    transition-property: background-color;

    &:hover .button {
      box-shadow: var(--box-shadow-hover);
    }
  }

  .button {
    flex-shrink: 0;
    width: ${asRem(24)};
    height: ${asRem(24)};
    border-radius: 100%;
    background-color: ${({ theme }) => theme.colors.white.c500};
    transition: 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    transition-property: transform, box-shadow;
    will-change: transform, box-shadow;

    & {
      box-shadow: var(--box-shadow);
    }

    &:hover {
      box-shadow: var(--box-shadow-hover);
    }
  }

  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: ${asRem(16)};
  }

  .children {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    display: flex;
    width: 100%;
  }
`;

var SleepStyle$1 = styled(Style$6) `
  .input {
    &:checked + .track {
      background-color: ${({ theme }) => theme.colors.sleep.success.c100};
    }
  }

  .track {
    background-color: ${({ theme }) => theme.colors.sleep.grey.c500};
  }

  .mime-elements-toggle:focus, .mime-elements-toggle:focus-visible {
    border: 4px solid ${({ theme }) => theme.colors.sleep.blue.c100};
  }

  .invalid-feedback {
    color: ${({ theme }) => theme.colors.sleep.red.c500};
  }
`;

const Toggle = React__default.forwardRef(({ children, name, checked, onChange, onBlur, className, feedbackMessage, disabled, dataCyName, ...props }, ref) => {
    const ThemeToggleStyle = useIsTheme(themeSleep) ? SleepStyle$1 : Style$6;
    return (jsxs(ThemeToggleStyle, { className: `mime-elements-toggle ${className ? className : ''}`, htmlFor: name, ...props, tabIndex: 0, children: [jsx("input", { className: "input", id: name, name: name, type: "checkbox", checked: checked, onChange: onChange, disabled: disabled, "data-cy-name": dataCyName, ref: ref, role: "switch", onBlur: onBlur }), jsx("div", { className: "track", children: jsx("div", { className: "button" }) }), jsxs("div", { className: "content", children: [jsx("div", { className: "children", children: children }), feedbackMessage && jsx("div", { className: "invalid-feedback d-block", children: feedbackMessage })] })] }));
});

var Style$5 = styled(FormGroup) `
  width: 100%;

  .mime-elements-select {
    background-color: ${({ theme }) => theme.colors.input.background};
    border-color: ${({ theme }) => theme.colors.input.background};
    border-radius: ${({ theme }) => theme.appearance.input.borderRadius};
    width: 100%;
    font-size: ${({ theme }) => theme.appearance.input.fontSize};
    padding: ${asRem(16)} ${asRem(60)} ${asRem(16)} ${asRem(20)};
    &.with-placeholder {
      color: ${({ theme }) => theme.colors.input.placeholder};
    }
  }
`;

var SleepStyle = styled(FormGroup) `
  width: 100%;

  $form-select-indicator-color: ${({ theme }) => theme.colors.sleep.blue.c200};

  .mime-elements-select {
    background-color: transparent;
    --bs-form-select-indicator-color: blue;
    color: ${({ theme }) => theme.colors.sleep.beige.c100};
    border-color: ${({ theme }) => theme.colors.sleep.blue.c200};
    border-radius: var(--spacing-2x);
    width: 100%;
    font-size: ${asRem(18)};
    line-height: ${asRem(23)};
    padding: ${asRem(16)} ${asRem(60)} ${asRem(16)} ${asRem(20)};

    &.with-placeholder {
      color: ${({ theme }) => theme.colors.sleep.blue.c200};
    }

    &.is-invalid {
      border-color: ${({ theme }) => theme.colors.sleep.red.c500};
    }
  }

  .form-select:focus,
  .form-select:focus-visible {
    border: 4px solid ${({ theme }) => theme.colors.sleep.blue.c100};
  }

  .form-select {
    --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg viewBox='0 0 28 29' fill='rgba(118, 153, 203, 1)' xmlns='http://www.w3.org/2000/svg'%3e%3cg id='nav/down'%3e%3cpath id='icon' d='M14 18.2537L6.00499 10.2587C5.63261 9.88636 5.03486 9.88555 4.66667 10.2537C4.29591 10.6245 4.30071 11.2211 4.67166 11.5921L13.3283 20.2488L13.3308 20.2512L13.3333 20.2537C13.5179 20.4383 13.7584 20.5298 13.9992 20.5294C14.2432 20.5289 14.4834 20.437 14.6667 20.2537L14.6692 20.2512L14.6717 20.2488L23.3283 11.5921C23.7007 11.2197 23.7015 10.6219 23.3333 10.2537C22.9626 9.88299 22.366 9.88779 21.995 10.2587L14 18.2537Z' fill='%237699CB' stroke='%237699CB' stroke-width='0.7'/%3e%3c/g%3e%3c/svg%3e");
    --bs-form-select-bg-icon: none !important;

    &.is-invalid {
      --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg viewBox='0 0 28 29' fill='rgba(224, 111, 76, 1)' xmlns='http://www.w3.org/2000/svg'%3e%3cg id='nav/down'%3e%3cpath id='icon' d='M14 18.2537L6.00499 10.2587C5.63261 9.88636 5.03486 9.88555 4.66667 10.2537C4.29591 10.6245 4.30071 11.2211 4.67166 11.5921L13.3283 20.2488L13.3308 20.2512L13.3333 20.2537C13.5179 20.4383 13.7584 20.5298 13.9992 20.5294C14.2432 20.5289 14.4834 20.437 14.6667 20.2537L14.6692 20.2512L14.6717 20.2488L23.3283 11.5921C23.7007 11.2197 23.7015 10.6219 23.3333 10.2537C22.9626 9.88299 22.366 9.88779 21.995 10.2587L14 18.2537Z' fill='rgba(224, 111, 76, 1)' stroke='rgba(224, 111, 76, 1)' stroke-width='0.7'/%3e%3c/g%3e%3c/svg%3e");
    }
  }

  .invalid-feedback {
    color: ${({ theme }) => theme.colors.sleep.red.c500};
  }
`;

const SelectBox = forwardRef(({ className = '', placeholder, required, label, feedbackMessage, name, valid, id, options, value, onChange, onBlur, dataCyName = '' }, ref) => {
    const [selectedValue, setSelectedValue] = useState(value || '');
    const [pristine, setPristine] = useState(true);
    const _id = useMemo(() => id || name || `select-${createUniqKey()}`, [id, name]);
    const ThemeSelectBoxStyle = useIsTheme(themeSleep) ? SleepStyle : Style$5;
    const isValid = useMemo(() => {
        if (valid !== null) {
            return valid;
        }
        if (!required) {
            return null;
        }
        if (pristine) {
            return null;
        }
        return !!selectedValue;
    }, [valid, pristine, selectedValue, required]);
    const handleOnChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        onChange(event);
    };
    const handleOnClick = () => {
        setPristine(false);
    };
    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        if (!event.target.value && required) {
            console.log('Keine Auswahl getroffen');
        }
    };
    const props = {
        innerRef: ref, // suppress the forward ref type with wrong matching legacyRef, ts-ignore is required
        required,
        valid: isValid === true,
        invalid: isValid === false,
        type: 'select',
        onClick: handleOnClick,
        'data-cy-name': dataCyName,
        id: _id,
        name,
        className: `mime-elements-select form-select form-select-lg mb-3 ${`${selectedValue}` === '' && 'with-placeholder'} ${className}`,
        value: selectedValue,
        onChange: handleOnChange,
        onBlur: handleBlur,
    };
    return (jsxs(ThemeSelectBoxStyle, { children: [label && (jsxs(Label, { className: "label--small", for: _id, children: [required && '*', " ", label] })), jsxs(Input$2, { ...props, children: [placeholder && jsx("option", { value: "", children: placeholder }), options?.map((option) => {
                        let value;
                        if (typeof option === 'string') {
                            value = option;
                        }
                        else if (typeof option === 'object' && 'value' in option) {
                            value = option.value;
                        }
                        else if (typeof option === 'object' && 'key' in option) {
                            value = option.key;
                        }
                        else if (typeof option === 'object' && 'label' in option) {
                            value = option.label;
                        }
                        return (jsx("option", { value: value, children: typeof option === 'string' ? option : option.label }, typeof option === 'string' ? option : (option?.key || option?.value || option.label)));
                    })] }), jsx(FormFeedback, { valid: isValid === true, invalid: `${isValid === false}`.toString(), children: feedbackMessage })] }));
});

function _typeof$5(o) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$5(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof$5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$5(i) ? i : i + "";
}

function _defineProperty$5(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$c(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_debounce = debounce$1;

var ALIGN_VALUES = ['justify', 'left', 'right'];
var DEFAULT_LABELKEY = 'label';
var SIZES = ['lg', 'sm'];

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var invariant$1 = /*@__PURE__*/getDefaultExportFromCjs(invariant_1);

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : DEFAULT_LABELKEY;
}

/**
 * Check if an object has the given property in a type-safe way.
 */
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var idCounter = 0;

// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
}
function noop$1() {}
function pick(obj, keys) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var result = {};
  keys.forEach(function (key) {
    result[key] = obj[key];
  });
  return result;
}
function uniqueId(prefix) {
  idCounter += 1;
  return (String(prefix)) + idCounter;
}

/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  // Handle internally created options first.
  if (!isString(option) && (hasOwnProperty(option, 'paginationOption') || hasOwnProperty(option, 'customOption'))) {
    return option[getStringLabelKey(labelKey)];
  }
  var optionLabel;
  if (isFunction(labelKey)) {
    optionLabel = labelKey(option);
  } else if (isString(option)) {
    optionLabel = option;
  } else {
    // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
  }
  !isString(optionLabel) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : invariant$1(false) : void 0;
  return optionLabel;
}

function addCustomOption(results, props) {
  var allowNew = props.allowNew,
    labelKey = props.labelKey,
    text = props.text;
  if (!allowNew || !text.trim()) {
    return false;
  }

  // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.
  if (isFunction(allowNew)) {
    return allowNew(results, props);
  }

  // By default, don't add the custom option if there is an exact text match
  // with an existing option.
  return !results.some(function (o) {
    return getOptionLabel(o, labelKey) === text;
  });
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var isEqual = /*@__PURE__*/getDefaultExportFromCjs(fastDeepEqual);

function getOptionProperty(option, key) {
  if (isString(option)) {
    return undefined;
  }
  return option[key];
}

// prettier-ignore

var map = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'OE',
  letters: "\x8C\u0152"
}, {
  base: 'oe',
  letters: "\x9C\u0153"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}].reduce(function (acc, _ref) {
  var base = _ref.base,
    letters = _ref.letters;
  letters.split('').forEach(function (letter) {
    acc[letter] = base;
  });
  return acc;
}, {});

// Combining marks
var latin = "\u0300-\u036F";
var japanese = "\u3099\u309A";
function stripDiacritics(str) {
  return str.normalize('NFD')
  // Remove combining diacritics
  .replace(new RegExp("[".concat(latin).concat(japanese, "]"), 'g'), '')
  /* eslint-disable-next-line no-control-regex */.replace(/[^\u0000-\u007E]/g, function (a) {
    return map[a] || a;
  });
}

var warned = {};

/**
 * Copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
 */
function warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }
    warned[message] = true;
  }
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  warning$1.apply(void 0, [falseToWarn, "[react-bootstrap-typeahead] ".concat(message)].concat(args));
}

function isMatch(input, string, props) {
  var searchStr = input;
  var str = string;
  if (!props.caseSensitive) {
    searchStr = searchStr.toLowerCase();
    str = str.toLowerCase();
  }
  if (props.ignoreDiacritics) {
    searchStr = stripDiacritics(searchStr);
    str = stripDiacritics(str);
  }
  return str.indexOf(searchStr) !== -1;
}

/**
 * Default algorithm for filtering results.
 */
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
    labelKey = props.labelKey,
    multiple = props.multiple,
    selected = props.selected,
    text = props.text;

  // Don't show selected options in the menu for the multi-select case.
  if (multiple && selected.some(function (o) {
    return isEqual(o, option);
  })) {
    return false;
  }
  if (isFunction(labelKey)) {
    return isMatch(text, labelKey(option), props);
  }
  var fields = filterBy.slice();
  if (isString(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }
  if (isString(option)) {
    warn(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
    return isMatch(text, option, props);
  }
  return fields.some(function (field) {
    var value = getOptionProperty(option, field);
    if (!isString(value)) {
      warn(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');
      value = String(value);
    }
    return isMatch(text, value, props);
  });
}

/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */
function isSelectable(inputNode) {
  return inputNode.selectionStart != null;
}

function defaultSelectHint(e, selectHint) {
  var shouldSelectHint = false;
  if (e.key === 'ArrowRight') {
    // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = isSelectable(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
  }
  if (e.key === 'Tab') {
    // Prevent input from blurring on TAB.
    e.preventDefault();
    shouldSelectHint = true;
  }
  return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}

var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;
// Export for testing.
function escapeStringRegexp(str) {
  !(typeof str === 'string') ? process.env.NODE_ENV !== "production" ? invariant$1(false, '`escapeStringRegexp` expected a string.') : invariant$1(false) : void 0;

  // Escape characters with special meaning either inside or outside character
  // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
  // escape when the simpler form would be disallowed by Unicode patterns’
  // stricter grammar.
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function getMatchBounds(subject, str) {
  var search = new RegExp(escapeStringRegexp(stripDiacritics(str)), CASE_INSENSITIVE);
  var matches = search.exec(stripDiacritics(subject));
  if (!matches) {
    return null;
  }
  var start = matches.index;
  var matchLength = matches[0].length;

  // Account for combining marks, which changes the indices.
  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start += 1;
      }
    }

    // Similarly, increment the length of the match string if it contains a
    // combining mark.
    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength += 1;
      }
    }
  }
  return {
    end: start + matchLength,
    start: start
  };
}

function getHintText(_ref) {
  var activeIndex = _ref.activeIndex,
    initialItem = _ref.initialItem,
    isFocused = _ref.isFocused,
    isMenuShown = _ref.isMenuShown,
    labelKey = _ref.labelKey,
    multiple = _ref.multiple,
    selected = _ref.selected,
    text = _ref.text;
  // Don't display a hint under the following conditions:
  if (
  // No text entered.
  !text ||
  // The input is not focused.
  !isFocused ||
  // The menu is hidden.
  !isMenuShown ||
  // No item in the menu.
  !initialItem ||
  // The initial item is a custom option.
  !isString(initialItem) && hasOwnProperty(initialItem, 'customOption') ||
  // One of the menu items is active.
  activeIndex > -1 ||
  // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }
  var initialItemStr = getOptionLabel(initialItem, labelKey);
  var bounds = getMatchBounds(initialItemStr.toLowerCase(), text.toLowerCase());
  if (!(bounds && bounds.start === 0)) {
    return '';
  }

  // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

function getMenuItemId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var position = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(id, "-item-").concat(position);
}

var _excluded$d = ["activeIndex", "id", "isFocused", "isMenuShown", "multiple", "onClick", "onFocus", "placeholder"];
function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getInputProps = function getInputProps(_ref) {
  var activeIndex = _ref.activeIndex,
    id = _ref.id,
    isFocused = _ref.isFocused,
    isMenuShown = _ref.isMenuShown,
    multiple = _ref.multiple,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    placeholder = _ref.placeholder,
    props = _objectWithoutProperties$1(_ref, _excluded$d);
  return function () {
    var _cx;
    var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var className = hasOwnProperty(inputProps, 'className') ? String(inputProps.className) : undefined;
    return _objectSpread$f(_objectSpread$f(_objectSpread$f(_objectSpread$f({
      // These props can be overridden by values in `inputProps`.
      autoComplete: 'off',
      placeholder: placeholder,
      type: 'text'
    }, inputProps), props), {}, {
      'aria-activedescendant': activeIndex >= 0 ? getMenuItemId(id, activeIndex) : undefined,
      'aria-autocomplete': 'both',
      'aria-expanded': isMenuShown,
      'aria-haspopup': 'listbox',
      'aria-multiselectable': multiple || undefined,
      'aria-owns': isMenuShown ? id : undefined,
      className: cx((_cx = {}, _defineProperty$5(_cx, className || '', !multiple), _defineProperty$5(_cx, "focus", isFocused), _cx))
    }, multiple && {
      inputClassName: className
    }), {}, {
      onClick: onClick,
      onFocus: onFocus,
      role: 'combobox'
    });
  };
};

function getInputText(props) {
  var activeItem = props.activeItem,
    labelKey = props.labelKey,
    multiple = props.multiple,
    selected = props.selected,
    text = props.text;
  if (activeItem) {
    // Display the input value if the pagination item is active.
    return getOptionLabel(activeItem, labelKey);
  }
  if (!multiple && selected.length && selected[0]) {
    return getOptionLabel(selected[0], labelKey);
  }
  return text;
}

function getIsOnlyResult(props) {
  var allowNew = props.allowNew,
    highlightOnlyResult = props.highlightOnlyResult,
    results = props.results;
  if (!highlightOnlyResult || allowNew) {
    return false;
  }
  return results.length === 1 && !getOptionProperty(results[0], 'disabled');
}

/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }
  return options.slice(0, maxResults);
}

function isDisabledOption(index, items) {
  var option = items[index];
  return !!option && !!getOptionProperty(option, 'disabled');
}
function skipDisabledOptions(currentIndex, key, items) {
  var newIndex = currentIndex;
  while (isDisabledOption(newIndex, items)) {
    newIndex += key === 'ArrowUp' ? -1 : 1;
  }
  return newIndex;
}
function getUpdatedActiveIndex(currentIndex, key, items) {
  var newIndex = currentIndex;

  // Increment or decrement index based on user keystroke.
  newIndex += key === 'ArrowUp' ? -1 : 1;

  // Skip over any disabled options.
  newIndex = skipDisabledOptions(newIndex, key, items);

  // If we've reached the end, go back to the beginning or vice-versa.
  if (newIndex === items.length) {
    newIndex = -1;
  } else if (newIndex === -2) {
    newIndex = items.length - 1;

    // Skip over any disabled options.
    newIndex = skipDisabledOptions(newIndex, key, items);
  }
  return newIndex;
}

function isShown(_ref) {
  var open = _ref.open,
    minLength = _ref.minLength,
    showMenu = _ref.showMenu,
    text = _ref.text;
  // If menu visibility is controlled via props, that value takes precedence.
  if (open || open === false) {
    return open;
  }
  if (text.length < minLength) {
    return false;
  }
  return showMenu;
}

/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}

function isSizeLarge(size) {
  return size === 'lg';
}
function isSizeSmall(size) {
  return size === 'sm';
}

var _excluded$c = ["className", "isInvalid", "isValid", "size"];
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Returns Bootstrap classnames from `size` and validation props, along
 * with pass-through props.
 */
function propsWithBsClassName(_ref) {
  var className = _ref.className,
    isInvalid = _ref.isInvalid,
    isValid = _ref.isValid,
    size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$c);
  return _objectSpread$e(_objectSpread$e({}, props), {}, {
    className: cx('form-control', 'rbt-input', {
      'form-control-lg': isSizeLarge(size),
      'form-control-sm': isSizeSmall(size),
      'is-invalid': isInvalid,
      'is-valid': isValid
    }, className)
  });
}

function validateSelectedPropChange(prevSelected, selected) {
  var uncontrolledToControlled = !prevSelected && selected;
  var controlledToUncontrolled = prevSelected && !selected;
  var from, to, precedent;
  if (uncontrolledToControlled) {
    from = 'uncontrolled';
    to = 'controlled';
    precedent = 'an';
  } else {
    from = 'controlled';
    to = 'uncontrolled';
    precedent = 'a';
  }
  var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
  warn(!(uncontrolledToControlled || controlledToUncontrolled), message);
}

var INPUT_PROPS_BLACKLIST = [{
  alt: 'onBlur',
  prop: 'onBlur'
}, {
  alt: 'onInputChange',
  prop: 'onChange'
}, {
  alt: 'onFocus',
  prop: 'onFocus'
}, {
  alt: 'onKeyDown',
  prop: 'onKeyDown'
}];
var sizeType = PropTypes$1.oneOf(SIZES);
/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    PropTypes$1.checkPropTypes(_defineProperty$5({}, propName, validator), props, 'prop', componentName);
    isFunction(callback) && callback(props, propName, componentName);
  };
}
function caseSensitiveType(props) {
  var caseSensitive = props.caseSensitive,
    filterBy = props.filterBy;
  warn(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function defaultInputValueType(props) {
  var defaultInputValue = props.defaultInputValue,
    defaultSelected = props.defaultSelected,
    multiple = props.multiple,
    selected = props.selected;
  var name = defaultSelected.length ? 'defaultSelected' : 'selected';
  warn(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function defaultSelectedType(props) {
  var defaultSelected = props.defaultSelected,
    multiple = props.multiple;
  warn(multiple || defaultSelected.length <= 1, 'You are passing multiple options to the `defaultSelected` prop of a ' + 'Typeahead in single-select mode. The selections will be truncated to a ' + 'single selection.');
}
function highlightOnlyResultType(_ref) {
  var allowNew = _ref.allowNew,
    highlightOnlyResult = _ref.highlightOnlyResult;
  warn(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function ignoreDiacriticsType(props) {
  var filterBy = props.filterBy,
    ignoreDiacritics = props.ignoreDiacritics;
  warn(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function inputPropsType(_ref2) {
  var inputProps = _ref2.inputProps;
  if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) {
    return;
  }

  // Blacklisted properties.
  INPUT_PROPS_BLACKLIST.forEach(function (_ref3) {
    var alt = _ref3.alt,
      prop = _ref3.prop;
    var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
    warn(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
  });
}
function isRequiredForA11y(props, propName, componentName) {
  warn(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function labelKeyType(_ref4) {
  var allowNew = _ref4.allowNew,
    labelKey = _ref4.labelKey;
  warn(!(isFunction(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var optionType = PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string]);
function selectedType(_ref5) {
  var multiple = _ref5.multiple,
    onChange = _ref5.onChange,
    selected = _ref5.selected;
  warn(multiple || !selected || selected.length <= 1, 'You are passing multiple options to the `selected` prop of a Typeahead ' + 'in single-select mode. This may lead to unexpected behaviors or errors.');
  warn(!selected || selected && isFunction(onChange), 'You provided a `selected` prop without an `onChange` handler. If you ' + 'want the typeahead to be uncontrolled, use `defaultSelected`. ' + 'Otherwise, set `onChange`.');
}

({
  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: PropTypes$1.number,
  /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */
  isLoading: PropTypes$1.bool.isRequired,
  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: PropTypes$1.number,
  /**
   * Callback to perform when the search is executed.
   */
  onSearch: PropTypes$1.func.isRequired,
  /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */
  options: PropTypes$1.arrayOf(optionType),
  /**
   * Message displayed in the menu when there is no user input.
   */
  promptText: PropTypes$1.node,
  /**
   * Message displayed in the menu while the request is pending.
   */
  searchText: PropTypes$1.node,
  /**
   * Whether or not the component should cache query results.
   */
  useCache: PropTypes$1.bool
});

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$d(subClass, superClass);
}

function _possibleConstructorReturn$a(self, call) {
  if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$d(self);
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$4(o);
}

var defaultContext = {
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop$1,
  onAdd: noop$1,
  onInitialItemChange: noop$1,
  onMenuItemClick: noop$1,
  setItem: noop$1
};
var TypeaheadContext = /*#__PURE__*/createContext(defaultContext);
var useTypeaheadContext = function useTypeaheadContext() {
  return useContext(TypeaheadContext);
};

function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputPropKeys = ['activeIndex', 'disabled', 'id', 'inputRef', 'isFocused', 'isMenuShown', 'multiple', 'onBlur', 'onChange', 'onClick', 'onFocus', 'onKeyDown', 'placeholder'];
var propKeys = ['activeIndex', 'hideMenu', 'isMenuShown', 'labelKey', 'onClear', 'onHide', 'onRemove', 'results', 'selected', 'text', 'toggleMenu'];
var contextKeys = ['activeIndex', 'id', 'initialItem', 'inputNode', 'onActiveItemChange', 'onAdd', 'onInitialItemChange', 'onMenuItemClick', 'setItem'];
var TypeaheadManager = function TypeaheadManager(props) {
  var allowNew = props.allowNew,
    children = props.children,
    initialItem = props.initialItem,
    isMenuShown = props.isMenuShown,
    onAdd = props.onAdd,
    onInitialItemChange = props.onInitialItemChange,
    onKeyDown = props.onKeyDown,
    onMenuToggle = props.onMenuToggle,
    results = props.results,
    selectHint = props.selectHint;
  var hintText = getHintText(props);
  useEffect(function () {
    // Clear the initial item when there are no results.
    if (!(allowNew || results.length)) {
      onInitialItemChange();
    }
  });
  var isInitialRender = useRef(true);
  useEffect(function () {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    onMenuToggle(isMenuShown);
  }, [isMenuShown, onMenuToggle]);
  var handleKeyDown = function handleKeyDown(e) {
    onKeyDown(e);
    if (!initialItem) {
      return;
    }
    var addOnlyResult = e.key === 'Enter' && getIsOnlyResult(props);
    var shouldSelectHint = hintText && defaultSelectHint(e, selectHint);
    if (addOnlyResult || shouldSelectHint) {
      onAdd(initialItem);
    }
  };
  var childProps = _objectSpread$d(_objectSpread$d({}, pick(props, propKeys)), {}, {
    getInputProps: getInputProps(_objectSpread$d(_objectSpread$d({}, pick(props, inputPropKeys)), {}, {
      onKeyDown: handleKeyDown,
      value: getInputText(props)
    }))
  });
  var contextValue = _objectSpread$d(_objectSpread$d({}, pick(props, contextKeys)), {}, {
    hintText: hintText,
    isOnlyResult: getIsOnlyResult(props)
  });
  return /*#__PURE__*/React__default.createElement(TypeaheadContext.Provider, {
    value: contextValue
  }, isFunction(children) ? children(childProps) : children);
};

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
    defaultOpen = props.defaultOpen,
    defaultSelected = props.defaultSelected,
    maxResults = props.maxResults,
    multiple = props.multiple;
  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;
  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = getOptionLabel(selected[0], props.labelKey);
    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }
  return {
    activeIndex: -1,
    activeItem: undefined,
    initialItem: undefined,
    isFocused: false,
    selected: selected,
    showMenu: defaultOpen,
    shownResults: maxResults,
    text: text
  };
}
function clearTypeahead(state, props) {
  return _objectSpread$c(_objectSpread$c({}, getInitialState(props)), {}, {
    isFocused: state.isFocused,
    selected: [],
    text: ''
  });
}
function clickOrFocusInput(state) {
  return _objectSpread$c(_objectSpread$c({}, state), {}, {
    isFocused: true,
    showMenu: true
  });
}
function hideMenu(state, props) {
  var _getInitialState = getInitialState(props),
    activeIndex = _getInitialState.activeIndex,
    activeItem = _getInitialState.activeItem,
    initialItem = _getInitialState.initialItem,
    shownResults = _getInitialState.shownResults;
  return _objectSpread$c(_objectSpread$c({}, state), {}, {
    activeIndex: activeIndex,
    activeItem: activeItem,
    initialItem: initialItem,
    showMenu: false,
    shownResults: shownResults
  });
}
function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : _objectSpread$c(_objectSpread$c({}, state), {}, {
    showMenu: true
  });
}

var _excluded$b = ["onChange"];
function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes$7 = {
  /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */
  allowNew: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func]),
  /**
   * Autofocus the input when the component initially mounts.
   */
  autoFocus: PropTypes$1.bool,
  /**
   * Whether or not filtering should be case-sensitive.
   */
  caseSensitive: checkPropType(PropTypes$1.bool, caseSensitiveType),
  /**
   * The initial value displayed in the text input.
   */
  defaultInputValue: checkPropType(PropTypes$1.string, defaultInputValueType),
  /**
   * Whether or not the menu is displayed upon initial render.
   */
  defaultOpen: PropTypes$1.bool,
  /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */
  defaultSelected: checkPropType(PropTypes$1.arrayOf(optionType), defaultSelectedType),
  /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */
  filterBy: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.string.isRequired), PropTypes$1.func]),
  /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */
  highlightOnlyResult: checkPropType(PropTypes$1.bool, highlightOnlyResultType),
  /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */
  id: checkPropType(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]), isRequiredForA11y),
  /**
   * Whether the filter should ignore accents and other diacritical marks.
   */
  ignoreDiacritics: checkPropType(PropTypes$1.bool, ignoreDiacriticsType),
  /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */
  labelKey: checkPropType(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func]), labelKeyType),
  /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */
  maxResults: PropTypes$1.number,
  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: PropTypes$1.number,
  /**
   * Whether or not multiple selections are allowed.
   */
  multiple: PropTypes$1.bool,
  /**
   * Invoked when the input is blurred. Receives an event.
   */
  onBlur: PropTypes$1.func,
  /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */
  onChange: PropTypes$1.func,
  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: PropTypes$1.func,
  /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */
  onInputChange: PropTypes$1.func,
  /**
   * Invoked when a key is pressed. Receives an event.
   */
  onKeyDown: PropTypes$1.func,
  /**
   * Invoked when menu visibility changes.
   */
  onMenuToggle: PropTypes$1.func,
  /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */
  onPaginate: PropTypes$1.func,
  /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */
  open: PropTypes$1.bool,
  /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */
  options: PropTypes$1.arrayOf(optionType).isRequired,
  /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */
  paginate: PropTypes$1.bool,
  /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */
  selected: checkPropType(PropTypes$1.arrayOf(optionType), selectedType)
};
var defaultProps$2 = {
  allowNew: false,
  autoFocus: false,
  caseSensitive: false,
  defaultInputValue: '',
  defaultOpen: false,
  defaultSelected: [],
  filterBy: [],
  highlightOnlyResult: false,
  ignoreDiacritics: true,
  labelKey: DEFAULT_LABELKEY,
  maxResults: 100,
  minLength: 0,
  multiple: false,
  onBlur: noop$1,
  onFocus: noop$1,
  onInputChange: noop$1,
  onKeyDown: noop$1,
  onMenuToggle: noop$1,
  onPaginate: noop$1,
  paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */
function triggerInputChange(input, value) {
  var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
  inputValue && inputValue.set && inputValue.set.call(input, value);
  var e = new Event('input', {
    bubbles: true
  });
  input.dispatchEvent(e);
}
var Typeahead$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$a(Typeahead, _React$Component);
  var _super = _createSuper$5(Typeahead);
  function Typeahead() {
    var _this;
    _classCallCheck$a(this, Typeahead);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized$d(_this), "state", getInitialState(_this.props));
    _defineProperty$5(_assertThisInitialized$d(_this), "inputNode", null);
    _defineProperty$5(_assertThisInitialized$d(_this), "isMenuShown", false);
    // Keeps track of actual items displayed in the menu, after sorting,
    // truncating, grouping, etc.
    _defineProperty$5(_assertThisInitialized$d(_this), "items", []);
    _defineProperty$5(_assertThisInitialized$d(_this), "blur", function () {
      _this.inputNode && _this.inputNode.blur();
      _this.hideMenu();
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "clear", function () {
      _this.setState(clearTypeahead);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "focus", function () {
      _this.inputNode && _this.inputNode.focus();
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "getInput", function () {
      return _this.inputNode;
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "inputRef", function (inputNode) {
      _this.inputNode = inputNode;
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "setItem", function (item, position) {
      _this.items[position] = item;
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "hideMenu", function () {
      _this.setState(hideMenu);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "toggleMenu", function () {
      _this.setState(toggleMenu);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleActiveIndexChange", function (activeIndex) {
      _this.setState(function (state) {
        return {
          activeIndex: activeIndex,
          activeItem: activeIndex >= 0 ? state.activeItem : undefined
        };
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleActiveItemChange", function (activeItem) {
      // Don't update the active item if it hasn't changed.
      if (!isEqual(activeItem, _this.state.activeItem)) {
        _this.setState({
          activeItem: activeItem
        });
      }
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleBlur", function (e) {
      e.persist();
      _this.setState({
        isFocused: false
      }, function () {
        return _this.props.onBlur(e);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleChange", function (selected) {
      _this.props.onChange && _this.props.onChange(selected);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleClear", function () {
      _this.inputNode && triggerInputChange(_this.inputNode, '');
      _this.setState(clearTypeahead, function () {
        // Change handler is automatically triggered for single selections but
        // not multi-selections.
        if (_this.props.multiple) {
          _this._handleChange([]);
        }
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleClick", function (e) {
      var _this$props$inputProp;
      e.persist();
      var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
      _this.setState(clickOrFocusInput, function () {
        return isFunction(onClick) && onClick(e);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleFocus", function (e) {
      e.persist();
      _this.setState(clickOrFocusInput, function () {
        return _this.props.onFocus(e);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleInitialItemChange", function (initialItem) {
      // Don't update the initial item if it hasn't changed.
      if (!isEqual(initialItem, _this.state.initialItem)) {
        _this.setState({
          initialItem: initialItem
        });
      }
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleInputChange", function (e) {
      e.persist();
      var text = e.currentTarget.value;
      var _this$props = _this.props,
        multiple = _this$props.multiple,
        onInputChange = _this$props.onInputChange;

      // Clear selections when the input value changes in single-select mode.
      var shouldClearSelections = _this.state.selected.length && !multiple;
      _this.setState(function (state, props) {
        var _getInitialState = getInitialState(props),
          activeIndex = _getInitialState.activeIndex,
          activeItem = _getInitialState.activeItem,
          shownResults = _getInitialState.shownResults;
        return {
          activeIndex: activeIndex,
          activeItem: activeItem,
          selected: shouldClearSelections ? [] : state.selected,
          showMenu: true,
          shownResults: shownResults,
          text: text
        };
      }, function () {
        onInputChange(text, e);
        shouldClearSelections && _this._handleChange([]);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleKeyDown", function (e) {
      var activeItem = _this.state.activeItem;

      // Skip most actions when the menu is hidden.
      if (!_this.isMenuShown) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          _this.setState({
            showMenu: true
          });
        }
        _this.props.onKeyDown(e);
        return;
      }
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          // Prevent input cursor from going to the beginning when pressing up.
          e.preventDefault();
          _this._handleActiveIndexChange(getUpdatedActiveIndex(_this.state.activeIndex, e.key, _this.items));
          break;
        case 'Enter':
          // Prevent form submission while menu is open.
          e.preventDefault();
          activeItem && _this._handleMenuItemSelect(activeItem, e);
          break;
        case 'Escape':
        case 'Tab':
          // ESC simply hides the menu. TAB will blur the input and move focus to
          // the next item; hide the menu so it doesn't gain focus.
          _this.hideMenu();
          break;
      }
      _this.props.onKeyDown(e);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleMenuItemSelect", function (option, e) {
      if (getOptionProperty(option, 'paginationOption')) {
        _this._handlePaginate(e);
      } else {
        _this._handleSelectionAdd(option);
      }
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handlePaginate", function (e) {
      e.persist();
      _this.setState(function (state, props) {
        return {
          shownResults: state.shownResults + props.maxResults
        };
      }, function () {
        return _this.props.onPaginate(e, _this.state.shownResults);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleSelectionAdd", function (option) {
      var _this$props2 = _this.props,
        multiple = _this$props2.multiple,
        labelKey = _this$props2.labelKey;
      var selected;
      var selection = option;
      var text;

      // Add a unique id to the custom selection. Avoid doing this in `render` so
      // the id doesn't increment every time.
      if (!isString(selection) && selection.customOption) {
        selection = _objectSpread$b(_objectSpread$b({}, selection), {}, {
          id: uniqueId('new-id-')
        });
      }
      if (multiple) {
        // If multiple selections are allowed, add the new selection to the
        // existing selections.
        selected = _this.state.selected.concat(selection);
        text = '';
      } else {
        // If only a single selection is allowed, replace the existing selection
        // with the new one.
        selected = [selection];
        text = getOptionLabel(selection, labelKey);
      }
      _this.setState(function (state, props) {
        return _objectSpread$b(_objectSpread$b({}, hideMenu(state, props)), {}, {
          initialItem: selection,
          selected: selected,
          text: text
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_handleSelectionRemove", function (selection) {
      var selected = _this.state.selected.filter(function (option) {
        return !isEqual(option, selection);
      });

      // Make sure the input stays focused after the item is removed.
      _this.focus();
      _this.setState(function (state, props) {
        return _objectSpread$b(_objectSpread$b({}, hideMenu(state, props)), {}, {
          selected: selected
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });
    return _this;
  }
  _createClass$9(Typeahead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
        labelKey = _this$props3.labelKey,
        multiple = _this$props3.multiple,
        selected = _this$props3.selected;
      validateSelectedPropChange(selected, prevProps.selected);

      // Sync selections in state with those in props.
      if (selected && !isEqual(selected, prevState.selected)) {
        this.setState({
          selected: selected
        });
        if (!multiple) {
          this.setState({
            text: selected.length ? getOptionLabel(selected[0], labelKey) : ''
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props;
        _this$props4.onChange;
        var props = _objectWithoutProperties$1(_this$props4, _excluded$b);
      var mergedPropsAndState = _objectSpread$b(_objectSpread$b({}, props), this.state);
      var filterBy = mergedPropsAndState.filterBy,
        labelKey = mergedPropsAndState.labelKey,
        options = mergedPropsAndState.options,
        paginate = mergedPropsAndState.paginate,
        shownResults = mergedPropsAndState.shownResults,
        text = mergedPropsAndState.text;
      this.isMenuShown = isShown(mergedPropsAndState);
      this.items = []; // Reset items on re-render.

      var results = [];
      if (this.isMenuShown) {
        var cb = isFunction(filterBy) ? filterBy : defaultFilterBy;
        results = options.filter(function (option) {
          return cb(option, mergedPropsAndState);
        });

        // This must come before results are truncated.
        var shouldPaginate = paginate && results.length > shownResults;

        // Truncate results if necessary.
        results = getTruncatedOptions(results, shownResults);

        // Add the custom option if necessary.
        if (addCustomOption(results, mergedPropsAndState)) {
          results.push(_defineProperty$5({
            customOption: true
          }, getStringLabelKey(labelKey), text));
        }

        // Add the pagination item if necessary.
        if (shouldPaginate) {
          var _results$push2;
          results.push((_results$push2 = {}, _defineProperty$5(_results$push2, getStringLabelKey(labelKey), ''), _defineProperty$5(_results$push2, "paginationOption", true), _results$push2));
        }
      }
      return /*#__PURE__*/React__default.createElement(TypeaheadManager, _extends$o({}, mergedPropsAndState, {
        hideMenu: this.hideMenu,
        inputNode: this.inputNode,
        inputRef: this.inputRef,
        isMenuShown: this.isMenuShown,
        onActiveItemChange: this._handleActiveItemChange,
        onAdd: this._handleSelectionAdd,
        onBlur: this._handleBlur,
        onChange: this._handleInputChange,
        onClear: this._handleClear,
        onClick: this._handleClick,
        onFocus: this._handleFocus,
        onHide: this.hideMenu,
        onInitialItemChange: this._handleInitialItemChange,
        onKeyDown: this._handleKeyDown,
        onMenuItemClick: this._handleMenuItemSelect,
        onRemove: this._handleSelectionRemove,
        results: results,
        setItem: this.setItem,
        toggleMenu: this.toggleMenu
      }));
    }
  }]);
  return Typeahead;
}(React__default.Component);
_defineProperty$5(Typeahead$1, "propTypes", propTypes$7);
_defineProperty$5(Typeahead$1, "defaultProps", defaultProps$2);

var _excluded$a = ["className", "label", "onClick", "onKeyDown", "size"];
var propTypes$6 = {
  label: PropTypes$1.string,
  onClick: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  size: sizeType
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Clear' : _ref$label,
    _onClick = _ref.onClick,
    _onKeyDown = _ref.onKeyDown,
    size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$a);
  return /*#__PURE__*/React__default.createElement("button", _extends$o({}, props, {
    "aria-label": label,
    className: cx('close', 'btn-close', 'rbt-close', {
      'rbt-close-lg': isSizeLarge(size),
      'rbt-close-sm': isSizeSmall(size)
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick && _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      // Prevent browser from navigating back.
      if (e.key === 'Backspace') {
        e.preventDefault();
      }
      _onKeyDown && _onKeyDown(e);
    },
    type: "button"
  }), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "rbt-close-content"
  }, "\xD7"), /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
ClearButton.propTypes = propTypes$6;

var propTypes$5 = {
  label: PropTypes$1.string
};
var Loader = function Loader(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading...' : _ref$label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
Loader.propTypes = propTypes$5;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setPopperWidth = {
  enabled: true,
  fn: function fn(data) {
    // eslint-disable-next-line no-param-reassign
    data.state.styles.popper.width = "".concat(data.state.rects.reference.width, "px");
  },
  name: 'setPopperWidth',
  phase: 'write'
};
function getModifiers(props) {
  var modifiers = [{
    enabled: !!props.flip,
    name: 'flip'
  }];
  if (props.align !== 'right' && props.align !== 'left') {
    modifiers.push(setPopperWidth);
  }
  return modifiers;
}
function getPlacement(props) {
  var x = props.align === 'right' ? 'end' : 'start';
  var y = props.dropup ? 'top' : 'bottom';
  return "".concat(y, "-").concat(x);
}
function useOverlay(referenceElement, options) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popperElement = _useState2[0],
    attachRef = _useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      modifiers: getModifiers(options),
      placement: getPlacement(options),
      strategy: options.positionFixed ? 'fixed' : 'absolute'
    }),
    attributes = _usePopper.attributes,
    styles = _usePopper.styles,
    forceUpdate = _usePopper.forceUpdate;
  var refElementHeight = referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetHeight;

  // Re-position the popper if the height of the reference element changes.
  // Exclude `forceUpdate` from dependencies since it changes with each render.
  useEffect(function () {
    forceUpdate && forceUpdate();
  }, [refElementHeight]); // eslint-disable-line

  return _objectSpread$a(_objectSpread$a({}, attributes.popper), {}, {
    innerRef: attachRef,
    style: styles.popper
  });
}

var _excluded$9 = ["referenceElement", "isMenuShown"];

// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */
var SafeElement = typeof Element === 'undefined' ? noop$1 : Element;
var propTypes$4 = {
  /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */
  align: PropTypes$1.oneOf(ALIGN_VALUES),
  children: PropTypes$1.func.isRequired,
  /**
   * Specify whether the menu should appear above the input.
   */
  dropup: PropTypes$1.bool,
  /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */
  flip: PropTypes$1.bool,
  isMenuShown: PropTypes$1.bool,
  positionFixed: PropTypes$1.bool,
  // @ts-ignore
  referenceElement: PropTypes$1.instanceOf(SafeElement)
};
var Overlay = function Overlay(_ref) {
  var referenceElement = _ref.referenceElement,
    isMenuShown = _ref.isMenuShown,
    props = _objectWithoutProperties$1(_ref, _excluded$9);
  var overlayProps = useOverlay(referenceElement, props);
  if (!isMenuShown) {
    return null;
  }
  return props.children(overlayProps);
};
Overlay.propTypes = propTypes$4;

/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  const ref = useCommittedRef(fn);
  return useCallback(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument$1(node) {
  return node && node.ownerDocument || document;
}

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return ReactDOM__default.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

var ownerDocument = (function (componentOrElement) {
  return ownerDocument$1(safeFindDOMNode(componentOrElement));
});

var escapeKeyCode = 27;

var noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose$1(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = useRef(false);
  var onClose = onRootClose || noop;
  var handleMouseCapture = useCallback(function (e) {
    var _e$composedPath$;

    var currentTarget = getRefTarget(ref);
    warning$1(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  useEffect(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = ownerDocument(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = listen(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return listen(el, 'mousemove', noop);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

function useRootClose(onRootClose, options) {
  var rootElementRef = useRef(null);
  useRootClose$1(rootElementRef.current, onRootClose, options);
  return rootElementRef;
}

var _excluded$8 = ["children", "onRootClose"];
function RootClose(_ref) {
  var children = _ref.children,
    onRootClose = _ref.onRootClose,
    props = _objectWithoutProperties$1(_ref, _excluded$8);
  var rootRef = useRootClose(onRootClose, props);
  return children(rootRef);
}

var _excluded$7 = ["onBlur", "onClick", "onFocus", "onRemove", "option"];
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
({
  onBlur: PropTypes$1.func,
  onClick: PropTypes$1.func,
  onFocus: PropTypes$1.func,
  onRemove: PropTypes$1.func,
  option: optionType.isRequired
});
function useToken(_ref) {
  var onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onRemove = _ref.onRemove,
    option = _ref.option,
    props = _objectWithoutProperties$1(_ref, _excluded$7);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    rootElement = _useState4[0],
    attachRef = _useState4[1];
  var handleBlur = function handleBlur(e) {
    setActive(false);
    onBlur && onBlur(e);
  };
  var handleClick = function handleClick(e) {
    setActive(true);
    onClick && onClick(e);
  };
  var handleFocus = function handleFocus(e) {
    setActive(true);
    onFocus && onFocus(e);
  };
  var handleRemove = function handleRemove() {
    onRemove && onRemove(option);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Backspace' && active) {
      // Prevent browser from going back.
      e.preventDefault();
      handleRemove();
    }
  };
  useRootClose$1(rootElement, handleBlur, _objectSpread$9(_objectSpread$9({}, props), {}, {
    disabled: !active
  }));
  return {
    active: active,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : undefined,
    ref: attachRef
  };
}

var _excluded$6 = ["active", "children", "className", "onRemove", "tabIndex"],
  _excluded2 = ["children", "option", "readOnly"],
  _excluded3 = ["ref"];
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InteractiveToken = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    onRemove = _ref.onRemove,
    tabIndex = _ref.tabIndex,
    props = _objectWithoutProperties$1(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement("div", _extends$o({}, props, {
    className: cx('rbt-token', 'rbt-token-removeable', {
      'rbt-token-active': !!active
    }, className),
    ref: ref,
    tabIndex: tabIndex || 0
  }), children, /*#__PURE__*/React__default.createElement(ClearButton, {
    className: "rbt-token-remove-button",
    label: "Remove",
    onClick: onRemove,
    tabIndex: -1
  }));
});
var StaticToken = function StaticToken(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    disabled = _ref2.disabled,
    href = _ref2.href;
  var classnames = cx('rbt-token', {
    'rbt-token-disabled': disabled
  }, className);
  if (href && !disabled) {
    return /*#__PURE__*/React__default.createElement("a", {
      className: classnames,
      href: href
    }, children);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames
  }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */
var Token = function Token(_ref3) {
  var children = _ref3.children,
    option = _ref3.option,
    readOnly = _ref3.readOnly,
    props = _objectWithoutProperties$1(_ref3, _excluded2);
  var _useToken = useToken(_objectSpread$8(_objectSpread$8({}, props), {}, {
      option: option
    })),
    ref = _useToken.ref,
    tokenProps = _objectWithoutProperties$1(_useToken, _excluded3);
  var child = /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-token-label"
  }, children);
  return !props.disabled && !readOnly && isFunction(tokenProps.onRemove) ? /*#__PURE__*/React__default.createElement(InteractiveToken, _extends$o({}, props, tokenProps, {
    ref: ref
  }), child) : /*#__PURE__*/React__default.createElement(StaticToken, props, child);
};

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  // Title-case the sub-attribute.
  if (subattr) {
    /* eslint-disable-next-line no-param-reassign */
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }
  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles["".concat(attr).concat(dir).concat(subattr)];
  }).join(' ');
}
function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);

  /* eslint-disable no-param-reassign */
  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.fontWeight = inputStyle.fontWeight;
  hintNode.style.height = inputStyle.height;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
  /* eslint-enable no-param-reassign */
}

var useHint = function useHint() {
  var _useTypeaheadContext = useTypeaheadContext(),
    hintText = _useTypeaheadContext.hintText,
    inputNode = _useTypeaheadContext.inputNode;
  var hintRef = useRef(null);
  useEffect(function () {
    if (inputNode && hintRef.current) {
      copyStyles(inputNode, hintRef.current);
    }
  });
  return {
    hintRef: hintRef,
    hintText: hintText
  };
};
var Hint = function Hint(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var _useHint = useHint(),
    hintRef = _useHint.hintRef,
    hintText = _useHint.hintText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: {
      display: 'flex',
      flex: 1,
      height: '100%',
      position: 'relative'
    }
  }, children, /*#__PURE__*/React__default.createElement("input", {
    "aria-hidden": true,
    className: "rbt-input-hint",
    ref: hintRef,
    readOnly: true,
    style: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'rgba(0, 0, 0, 0.54)',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: '100%'
    },
    tabIndex: -1,
    value: hintText
  }));
};

var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement("input", _extends$o({}, props, {
    className: cx('rbt-input-main', props.className),
    ref: ref
  }));
});

var _excluded$5 = ["children", "className", "inputClassName", "inputRef", "referenceElementRef", "selected"];
function TypeaheadInputMulti(props) {
  var wrapperRef = React__default.useRef(null);
  var inputElem = React__default.useRef(null);
  var _propsWithBsClassName = propsWithBsClassName(props),
    children = _propsWithBsClassName.children,
    className = _propsWithBsClassName.className,
    inputClassName = _propsWithBsClassName.inputClassName;
    _propsWithBsClassName.inputRef;
    var referenceElementRef = _propsWithBsClassName.referenceElementRef,
    selected = _propsWithBsClassName.selected,
    rest = _objectWithoutProperties$1(_propsWithBsClassName, _excluded$5);
  function getInputRef(input) {
    inputElem.current = input;
    props.inputRef(input);
  }

  /**
   * Forward click or focus events on the container element to the input.
   */
  function handleContainerClickOrFocus(e) {
    // Don't focus the input if it's disabled.
    if (props.disabled) {
      e.currentTarget.blur();
      return;
    }
    var inputNode = inputElem.current;
    if (!inputNode ||
    // Ignore if the clicked element is a child of the container, ie: a token
    // or the input itself.
    e.currentTarget.contains(e.target) && e.currentTarget !== e.target) {
      return;
    }
    if (isSelectable(inputNode)) {
      // Move cursor to the end if the user clicks outside the actual input.
      inputNode.selectionStart = inputNode.value.length;
    }
    inputNode.focus();
  }
  function handleKeyDown(e) {
    if (e.key === 'Backspace' && selected.length && !props.value) {
      var _wrapperRef$current;
      // Prevent browser from going back.
      e.preventDefault();

      // If the input is selected and there is no text, focus the last
      // token when the user hits backspace.

      var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
      if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
        var lastToken = wrapperChildren[wrapperChildren.length - 2];
        lastToken === null || lastToken === void 0 || lastToken.focus();
      }
    }
    props.onKeyDown && props.onKeyDown(e);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('rbt-input-multi', {
      disabled: props.disabled
    }, className),
    onClick: handleContainerClickOrFocus,
    onFocus: handleContainerClickOrFocus,
    ref: referenceElementRef,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rbt-input-wrapper",
    ref: wrapperRef
  }, children, /*#__PURE__*/React__default.createElement(Hint, null, /*#__PURE__*/React__default.createElement(Input, _extends$o({}, rest, {
    className: inputClassName,
    onKeyDown: handleKeyDown,
    ref: getInputRef,
    style: {
      backgroundColor: 'transparent',
      border: 0,
      boxShadow: 'none',
      cursor: 'inherit',
      outline: 'none',
      padding: 0,
      width: '100%',
      zIndex: 1
    }
  })))));
}

var _excluded$4 = ["inputRef", "referenceElementRef"];
var TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
  var inputRef = _ref.inputRef,
    referenceElementRef = _ref.referenceElementRef,
    props = _objectWithoutProperties$1(_ref, _excluded$4);
  return /*#__PURE__*/React__default.createElement(Hint, null, /*#__PURE__*/React__default.createElement(Input, _extends$o({}, propsWithBsClassName(props), {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
};

var propTypes$3 = {
  children: PropTypes$1.string.isRequired,
  highlightClassName: PropTypes$1.string,
  search: PropTypes$1.string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function Highlighter(_ref) {
  var children = _ref.children,
    _ref$highlightClassNa = _ref.highlightClassName,
    highlightClassName = _ref$highlightClassNa === void 0 ? 'rbt-highlight-text' : _ref$highlightClassNa,
    search = _ref.search;
  if (!search || !children) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  var matchCount = 0;
  var remaining = children;
  var highlighterChildren = [];
  while (remaining) {
    var bounds = getMatchBounds(remaining, search);

    // No match anywhere in the remaining string, stop.
    if (!bounds) {
      highlighterChildren.push(remaining);
      break;
    }

    // Capture the string that leads up to a match.
    var nonMatch = remaining.slice(0, bounds.start);
    if (nonMatch) {
      highlighterChildren.push(nonMatch);
    }

    // Capture the matching string.
    var match = remaining.slice(bounds.start, bounds.end);
    highlighterChildren.push( /*#__PURE__*/React__default.createElement("mark", {
      className: highlightClassName,
      key: matchCount
    }, match));
    matchCount += 1;

    // And if there's anything left over, continue the loop.
    remaining = remaining.slice(bounds.end);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, highlighterChildren);
};
Highlighter.propTypes = propTypes$3;

const t=t=>"object"==typeof t&&null!=t&&1===t.nodeType,e$1=(t,e)=>(!e||"hidden"!==t)&&("visible"!==t&&"clip"!==t),n=(t,n)=>{if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){const o=getComputedStyle(t,null);return e$1(o.overflowY,n)||e$1(o.overflowX,n)||(t=>{const e=(t=>{if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}})(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)})(t)}return !1},o$1=(t,e,n,o,l,r,i,s)=>r<t&&i>e||r>t&&i<e?0:r<=t&&s<=n||i>=e&&s>=n?r-t-o:i>e&&s<n||r<t&&s>n?i-e+l:0,l=t=>{const e=t.parentElement;return null==e?t.getRootNode().host||null:e},r=(e,r)=>{var i,s,d,h;if("undefined"==typeof document)return [];const{scrollMode:c,block:f,inline:u,boundary:a,skipOverflowHiddenElements:g}=r,p="function"==typeof a?a:t=>t!==a;if(!t(e))throw new TypeError("Invalid target");const m=document.scrollingElement||document.documentElement,w=[];let W=e;for(;t(W)&&p(W);){if(W=l(W),W===m){w.push(W);break}null!=W&&W===document.body&&n(W)&&!n(document.documentElement)||null!=W&&n(W,g)&&w.push(W);}const b=null!=(s=null==(i=window.visualViewport)?void 0:i.width)?s:innerWidth,H=null!=(h=null==(d=window.visualViewport)?void 0:d.height)?h:innerHeight,{scrollX:y,scrollY:M}=window,{height:v,width:E,top:x,right:C,bottom:I,left:R}=e.getBoundingClientRect(),{top:T,right:B,bottom:F,left:V}=(t=>{const e=window.getComputedStyle(t);return {top:parseFloat(e.scrollMarginTop)||0,right:parseFloat(e.scrollMarginRight)||0,bottom:parseFloat(e.scrollMarginBottom)||0,left:parseFloat(e.scrollMarginLeft)||0}})(e);let k="start"===f||"nearest"===f?x-T:"end"===f?I+F:x+v/2-T+F,D="center"===u?R+E/2-V+B:"end"===u?C+B:R-V;const L=[];for(let t=0;t<w.length;t++){const e=w[t],{height:n,width:l,top:r,right:i,bottom:s,left:d}=e.getBoundingClientRect();if("if-needed"===c&&x>=0&&R>=0&&I<=H&&C<=b&&x>=r&&I<=s&&R>=d&&C<=i)return L;const h=getComputedStyle(e),a=parseInt(h.borderLeftWidth,10),g=parseInt(h.borderTopWidth,10),p=parseInt(h.borderRightWidth,10),W=parseInt(h.borderBottomWidth,10);let T=0,B=0;const F="offsetWidth"in e?e.offsetWidth-e.clientWidth-a-p:0,V="offsetHeight"in e?e.offsetHeight-e.clientHeight-g-W:0,S="offsetWidth"in e?0===e.offsetWidth?0:l/e.offsetWidth:0,X="offsetHeight"in e?0===e.offsetHeight?0:n/e.offsetHeight:0;if(m===e)T="start"===f?k:"end"===f?k-H:"nearest"===f?o$1(M,M+H,H,g,W,M+k,M+k+v,v):k-H/2,B="start"===u?D:"center"===u?D-b/2:"end"===u?D-b:o$1(y,y+b,b,a,p,y+D,y+D+E,E),T=Math.max(0,T+M),B=Math.max(0,B+y);else {T="start"===f?k-r-g:"end"===f?k-s+W+V:"nearest"===f?o$1(r,s,n,g,W+V,k,k+v,v):k-(r+n/2)+V/2,B="start"===u?D-d-a:"center"===u?D-(d+l/2)+F/2:"end"===u?D-i+p+F:o$1(d,i,l,a,p+F,D,D+E,E);const{scrollLeft:t,scrollTop:h}=e;T=0===X?0:Math.max(0,Math.min(h+T/X,e.scrollHeight-n/X+V)),B=0===S?0:Math.max(0,Math.min(t+B/S,e.scrollWidth-l/S+F)),k+=h-T,D+=t-B;}L.push({el:e,top:T,left:B});}return L};

const o=t=>!1===t?{block:"end",inline:"nearest"}:(t=>t===Object(t)&&0!==Object.keys(t).length)(t)?t:{block:"start",inline:"nearest"};function e(e,r$1){if(!e.isConnected||!(t=>{let o=t;for(;o&&o.parentNode;){if(o.parentNode===document)return !0;o=o.parentNode instanceof ShadowRoot?o.parentNode.host:o.parentNode;}return !1})(e))return;const n=(t=>{const o=window.getComputedStyle(t);return {top:parseFloat(o.scrollMarginTop)||0,right:parseFloat(o.scrollMarginRight)||0,bottom:parseFloat(o.scrollMarginBottom)||0,left:parseFloat(o.scrollMarginLeft)||0}})(e);if((t=>"object"==typeof t&&"function"==typeof t.behavior)(r$1))return r$1.behavior(r(e,r$1));const l="boolean"==typeof r$1||null==r$1?void 0:r$1.behavior;for(const{el:a,top:i,left:s}of r(e,o(r$1))){const t=i-n.top+n.bottom,o=s-n.left+n.right;a.scroll({top:t,left:o,behavior:l});}}

var _excluded$3 = ["label", "onClick", "option", "position"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
({
  option: optionType.isRequired,
  position: PropTypes$1.number
});
function useItem(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    option = _ref.option,
    position = _ref.position,
    props = _objectWithoutProperties$1(_ref, _excluded$3);
  var _useTypeaheadContext = useTypeaheadContext(),
    activeIndex = _useTypeaheadContext.activeIndex,
    id = _useTypeaheadContext.id,
    isOnlyResult = _useTypeaheadContext.isOnlyResult,
    onActiveItemChange = _useTypeaheadContext.onActiveItemChange,
    onInitialItemChange = _useTypeaheadContext.onInitialItemChange,
    onMenuItemClick = _useTypeaheadContext.onMenuItemClick,
    setItem = _useTypeaheadContext.setItem;
  var itemRef = useRef(null);
  useEffect(function () {
    if (position === 0) {
      onInitialItemChange(option);
    }
  });
  useEffect(function () {
    if (position === activeIndex) {
      onActiveItemChange(option);

      // Automatically scroll the menu as the user keys through it.
      var node = itemRef.current;
      node && e(node, {
        boundary: node.parentNode,
        scrollMode: 'if-needed'
      });
    }
  }, [activeIndex, onActiveItemChange, option, position]);
  var handleClick = useCallback(function (e) {
    onMenuItemClick(option, e);
    onClick && onClick(e);
  }, [onClick, onMenuItemClick, option]);
  var active = isOnlyResult || activeIndex === position;

  // Update the item's position in the item stack.
  setItem(option, position);
  return _objectSpread$7(_objectSpread$7({}, props), {}, {
    active: active,
    'aria-label': label,
    'aria-selected': active,
    id: getMenuItemId(id, position),
    onClick: handleClick,
    onMouseDown: preventInputBlur,
    ref: itemRef,
    role: 'option'
  });
}

var _excluded$2 = ["active", "children", "className", "disabled", "onClick"];
var BaseMenuItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    _onClick = _ref.onClick,
    props = _objectWithoutProperties$1(_ref, _excluded$2);
  return /*#__PURE__*/React__default.createElement("a", _extends$o({}, props, {
    className: cx('dropdown-item', {
      active: active,
      disabled: disabled
    }, className),
    href: props.href || '#',
    onClick: function onClick(e) {
      e.preventDefault();
      !disabled && _onClick && _onClick(e);
    },
    ref: ref
  }), children);
});
function MenuItem(props) {
  return /*#__PURE__*/React__default.createElement(BaseMenuItem, useItem(props));
}

var _excluded$1 = ["emptyLabel", "innerRef", "maxHeight", "style"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "dropdown-divider",
    role: "separator"
  });
};
var MenuHeader = function MenuHeader(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    React__default.createElement("div", _extends$o({}, props, {
      className: "dropdown-header",
      role: "heading"
    }))
  );
};
var propTypes$2 = {
  'aria-label': PropTypes$1.string,
  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: PropTypes$1.node,
  /**
   * Needed for accessibility.
   */
  id: checkPropType(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]), isRequiredForA11y),
  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: PropTypes$1.string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu$1 = function Menu(_ref) {
  var _ref$emptyLabel = _ref.emptyLabel,
    emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel,
    innerRef = _ref.innerRef,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight,
    style = _ref.style,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  var children = Children.count(props.children) === 0 ? /*#__PURE__*/React__default.createElement(BaseMenuItem, {
    disabled: true,
    role: "option"
  }, emptyLabel) : props.children;
  return (
    /*#__PURE__*/
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    React__default.createElement("div", _extends$o({}, props, {
      "aria-label": props['aria-label'] || 'menu-options',
      className: cx('rbt-menu', 'dropdown-menu', 'show', props.className),
      onMouseDown:
      // Prevent input from blurring when clicking on the menu scrollbar.
      preventInputBlur,
      ref: innerRef,
      role: "listbox",
      style: _objectSpread$6(_objectSpread$6({}, style), {}, {
        display: 'block',
        maxHeight: maxHeight,
        overflow: 'auto'
      })
    }), children)
    /* eslint-enable jsx-a11y/interactive-supports-focus */
  );
};

Menu$1.propTypes = propTypes$2;
Menu$1.Divider = MenuDivider;
Menu$1.Header = MenuHeader;

var _excluded = ["labelKey", "newSelectionPrefix", "options", "paginationText", "renderMenuItemChildren", "text"];
var propTypes$1 = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: PropTypes$1.node,
  /**
   * Prompt displayed when large data sets are paginated.
   */
  paginationText: PropTypes$1.node,
  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: PropTypes$1.func
};
function renderMenuItemChildrenFn(option, props) {
  return /*#__PURE__*/React__default.createElement(Highlighter, {
    search: props.text
  }, getOptionLabel(option, props.labelKey));
}
var TypeaheadMenu = function TypeaheadMenu(props) {
  var labelKey = props.labelKey,
    _props$newSelectionPr = props.newSelectionPrefix,
    newSelectionPrefix = _props$newSelectionPr === void 0 ? 'New selection: ' : _props$newSelectionPr,
    options = props.options,
    _props$paginationText = props.paginationText,
    paginationText = _props$paginationText === void 0 ? 'Display additional results...' : _props$paginationText,
    _props$renderMenuItem = props.renderMenuItemChildren,
    renderMenuItemChildren = _props$renderMenuItem === void 0 ? renderMenuItemChildrenFn : _props$renderMenuItem,
    text = props.text,
    menuProps = _objectWithoutProperties$1(props, _excluded);
  var renderMenuItem = function renderMenuItem(option, position) {
    var label = getOptionLabel(option, labelKey);
    var menuItemProps = {
      disabled: !!getOptionProperty(option, 'disabled'),
      label: label,
      option: option,
      position: position
    };
    if (getOptionProperty(option, 'customOption')) {
      return /*#__PURE__*/React__default.createElement(MenuItem, _extends$o({}, menuItemProps, {
        className: "rbt-menu-custom-option",
        key: position,
        label: label
      }), newSelectionPrefix, /*#__PURE__*/React__default.createElement(Highlighter, {
        search: text
      }, label));
    }
    if (getOptionProperty(option, 'paginationOption')) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "pagination-option-divider"
      }, /*#__PURE__*/React__default.createElement(Menu$1.Divider, null), /*#__PURE__*/React__default.createElement(MenuItem, _extends$o({}, menuItemProps, {
        className: "rbt-menu-pagination-option",
        label:
        // TODO: Fix how (aria-)labels are passed to `MenuItem`.
        // `paginationText` can be a ReactNode.
        isString(paginationText) ? paginationText : ''
      }), paginationText));
    }
    return /*#__PURE__*/React__default.createElement(MenuItem, _extends$o({}, menuItemProps, {
      key: position
    }), renderMenuItemChildren(option, props, position));
  };
  return /*#__PURE__*/React__default.createElement(Menu$1, _extends$o({}, menuProps, {
    key:
    // Force a re-render if the text changes to ensure that menu
    // positioning updates correctly.
    text
  }), options.map(renderMenuItem));
};
TypeaheadMenu.propTypes = propTypes$1;

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty$5(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes = {
  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: PropTypes$1.bool,
  /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */
  inputProps: checkPropType(PropTypes$1.object, inputPropsType),
  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: PropTypes$1.bool,
  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: PropTypes$1.bool,
  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: PropTypes$1.bool,
  /**
   * Callback for custom input rendering.
   */
  renderInput: PropTypes$1.func,
  /**
   * Callback for custom menu rendering.
   */
  renderMenu: PropTypes$1.func,
  /**
   * Callback for custom menu rendering.
   */
  renderToken: PropTypes$1.func,
  /**
   * Specifies the size of the input.
   */
  size: sizeType
};
var defaultProps$1 = {
  isLoading: false
};
var defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
  return /*#__PURE__*/React__default.createElement(TypeaheadMenu, _extends$o({}, menuProps, {
    labelKey: props.labelKey,
    options: results,
    text: props.text
  }));
};
var defaultRenderToken = function defaultRenderToken(option, props, idx) {
  return /*#__PURE__*/React__default.createElement(Token, {
    disabled: props.disabled,
    key: idx,
    onRemove: props.onRemove,
    option: option,
    tabIndex: props.tabIndex
  }, getOptionLabel(option, props.labelKey));
};
var overlayPropKeys = ['align', 'dropup', 'flip', 'positionFixed'];
function getOverlayProps(props) {
  return pick(props, overlayPropKeys);
}
var TypeaheadComponent = /*#__PURE__*/function (_React$Component) {
  _inherits$a(TypeaheadComponent, _React$Component);
  var _super = _createSuper$4(TypeaheadComponent);
  function TypeaheadComponent() {
    var _this;
    _classCallCheck$a(this, TypeaheadComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$5(_assertThisInitialized$d(_this), "_referenceElement", null);
    _defineProperty$5(_assertThisInitialized$d(_this), "referenceElementRef", function (referenceElement) {
      _this._referenceElement = referenceElement;
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_renderInput", function (inputProps, props) {
      var _this$props = _this.props,
        isInvalid = _this$props.isInvalid,
        isValid = _this$props.isValid,
        multiple = _this$props.multiple,
        renderInput = _this$props.renderInput,
        renderToken = _this$props.renderToken,
        size = _this$props.size;
      if (isFunction(renderInput)) {
        return renderInput(inputProps, props);
      }
      var commonProps = _objectSpread$5(_objectSpread$5({}, inputProps), {}, {
        isInvalid: isInvalid,
        isValid: isValid,
        size: size
      });
      if (!multiple) {
        return /*#__PURE__*/React__default.createElement(TypeaheadInputSingle, commonProps);
      }
      var labelKey = props.labelKey,
        onRemove = props.onRemove,
        selected = props.selected;
      return /*#__PURE__*/React__default.createElement(TypeaheadInputMulti, _extends$o({}, commonProps, {
        placeholder: selected.length ? '' : inputProps.placeholder,
        selected: selected
      }), selected.map(function (option, idx) {
        return (renderToken || defaultRenderToken)(option, _objectSpread$5(_objectSpread$5({}, commonProps), {}, {
          labelKey: labelKey,
          onRemove: onRemove
        }), idx);
      }));
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_renderMenu", function (results, menuProps, props) {
      var _this$props2 = _this.props,
        emptyLabel = _this$props2.emptyLabel,
        id = _this$props2.id,
        maxHeight = _this$props2.maxHeight,
        newSelectionPrefix = _this$props2.newSelectionPrefix,
        paginationText = _this$props2.paginationText,
        renderMenu = _this$props2.renderMenu,
        renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return (renderMenu || defaultRenderMenu)(results, _objectSpread$5(_objectSpread$5({}, menuProps), {}, {
        emptyLabel: emptyLabel,
        id: id,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        paginationText: paginationText,
        renderMenuItemChildren: renderMenuItemChildren
      }), props);
    });
    _defineProperty$5(_assertThisInitialized$d(_this), "_renderAux", function (_ref) {
      var onClear = _ref.onClear,
        selected = _ref.selected;
      var _this$props3 = _this.props,
        clearButton = _this$props3.clearButton,
        disabled = _this$props3.disabled,
        isLoading = _this$props3.isLoading,
        size = _this$props3.size;
      var content;
      if (isLoading) {
        content = /*#__PURE__*/React__default.createElement(Loader, null);
      } else if (clearButton && !disabled && selected.length) {
        content = /*#__PURE__*/React__default.createElement(ClearButton, {
          onClick: onClear,
          onMouseDown: preventInputBlur,
          size: size
        });
      }
      return content ? /*#__PURE__*/React__default.createElement("div", {
        className: cx('rbt-aux', {
          'rbt-aux-lg': isSizeLarge(size)
        })
      }, content) : null;
    });
    return _this;
  }
  _createClass$9(TypeaheadComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        instanceRef = _this$props4.instanceRef,
        open = _this$props4.open,
        options = _this$props4.options,
        style = _this$props4.style;
      return /*#__PURE__*/React__default.createElement(Typeahead$1, _extends$o({}, this.props, {
        options: options,
        ref: instanceRef
      }), function (props) {
        var hideMenu = props.hideMenu,
          isMenuShown = props.isMenuShown,
          results = props.results;
        var auxContent = _this2._renderAux(props);
        return /*#__PURE__*/React__default.createElement(RootClose, {
          disabled: open || !isMenuShown,
          onRootClose: hideMenu
        }, function (ref) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: cx('rbt', {
              'has-aux': !!auxContent,
              'is-invalid': _this2.props.isInvalid,
              'is-valid': _this2.props.isValid
            }, className),
            ref: ref,
            style: _objectSpread$5(_objectSpread$5({}, style), {}, {
              outline: 'none',
              position: 'relative'
            }),
            tabIndex: -1
          }, _this2._renderInput(_objectSpread$5(_objectSpread$5({}, props.getInputProps(_this2.props.inputProps)), {}, {
            referenceElementRef: _this2.referenceElementRef
          }), props), /*#__PURE__*/React__default.createElement(Overlay, _extends$o({}, getOverlayProps(_this2.props), {
            isMenuShown: isMenuShown,
            referenceElement: _this2._referenceElement
          }), function (menuProps) {
            return _this2._renderMenu(results, menuProps, props);
          }), auxContent, isFunction(children) ? children(props) : children);
        });
      });
    }
  }]);
  return TypeaheadComponent;
}(React__default.Component);
_defineProperty$5(TypeaheadComponent, "propTypes", propTypes);
_defineProperty$5(TypeaheadComponent, "defaultProps", defaultProps$1);
var RBTypeahead = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(TypeaheadComponent, _extends$o({}, props, {
    instanceRef: ref
  }));
});

var Style$4 = styled(FormGroup) `
  .rbt-aux {
    position: absolute;
    right: ${asRem(2)};
    top: ${asRem(12)};

    .rbt-close-content {
      display: none;
    }
  }

  .dropdown-menu {
    max-height: ${asRem(200)} !important;
    border-radius: ${asRem(6)};
    padding: 0;
    border: none;
    width: 100%;

    a {
      background-color: ${({ theme }) => theme.colors.input.background};
      color: ${({ theme }) => theme.colors.input.text};
      border-bottom: ${asRem(2)} solid ${({ theme }) => theme.colors.white.c500} solid;
      margin-bottom: ${asRem(2)};

      &:hover {
        background-color: ${({ theme }) => theme.colors.button.default.background};
        color: ${({ theme }) => theme.colors.button.default.text};

        mark {
          color: ${({ theme }) => theme.colors.button.default.text};
        }
      }
      mark {
        padding: 0;
        color: ${({ theme }) => theme.colors.input.text};
        background-color: transparent;
      }

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }
    }
  }
`;

// https://www.figma.com/file/wBAWu7yXOmgYTKKTywxD24/Balloon-Web-Library?type=design&node-id=301-133&mode=dev
const Typeahead = forwardRef(({ options, id, name, className = '', value, label, feedbackMessage, onChange, dataCyName = '', required, valid, placeholder }, ref) => {
    const _id = useMemo(() => id || name || `typeahead-${createUniqKey()}`, [id, name]);
    const [pristine, setPristine] = useState(true);
    const [selection, setSelection] = useState(value || '');
    const handleOnClick = () => {
        setPristine(false);
    };
    const isValid = useMemo(() => {
        if (valid === true || valid === false) {
            return valid;
        }
        if (!required) {
            return null;
        }
        if (pristine) {
            return null;
        }
        return !!selection;
    }, [valid, pristine, selection, required]);
    useEffect(() => {
        onChange && onChange({ target: { value: selection || '', name: name || '' } });
    }, [selection]);
    const handleOnChange = (selected) => {
        setSelection(selected.length ? selected[0] : '');
    };
    const handleInChangeInput = (evt) => {
        const value = `${evt.target.value}`;
        setSelection(!!`${value}`.trim() ? value : '');
    };
    const handleOnClearSelection = () => {
        setSelection('');
    };
    const typeaheadProps = {
        ref: ref,
        options,
        labelKey: 'name',
        onClick: handleOnClick,
        emptyLabel: 'Keine Einträge gefunden',
        id: `wrapper-${_id}`,
    };
    return (jsxs(Style$4, { "data-cy-name": dataCyName, className: `missionme-typeahead ${className}`, children: [label && (jsxs(Label, { className: "label--small", for: _id, children: [required && '*', " ", label] })), jsx(RBTypeahead, { ...typeaheadProps, isValid: isValid === true, isInvalid: isValid === false, onChange: handleOnChange, options: options, placeholder: "Choose a state...", selected: [selection], renderInput: ({ inputRef, referenceElementRef, ...inputProps }) => (jsxs(Fragment, { children: [jsx(Input$1, { ...inputProps, id: _id, placeholder: placeholder, ref: referenceElementRef, onChange: handleInChangeInput }), !!selection.length && (jsx("div", { className: "rbt-aux", children: jsxs("button", { "aria-label": "Clear", onClick: handleOnClearSelection, className: "close btn-close rbt-close", type: "button", children: [jsx("span", { "aria-hidden": "true", className: "rbt-close-content", children: "\u00D7" }), jsx("span", { className: "sr-only visually-hidden", children: "Clear" })] }) }))] })) }), jsx(FormFeedback, { valid: isValid === true, invalid: `${isValid === false}`.toString(), children: feedbackMessage })] }));
});

var TextBlockStyle = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: ${({ $smRow }) => ($smRow ? 'row' : 'column')};
  text-align: ${({ $smRow }) => ($smRow ? 'left' : 'center')};
  flex-basis: 0;
  flex: 1;
  margin-top: ${({ theme }) => asRem(theme.spacing.two)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }

  .image {
    width: ${({ $smRow }) => ($smRow ? asRem(150) : asRem(200))};
    aspect-ratio: 1/1;
    margin-bottom: ${({ theme, $smRow }) => ($smRow ? 0 : asRem(theme.spacing.two))};
    margin-right: ${({ $smRow }) => ($smRow ? asRem(24) : 0)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-right: 0;
      width: ${asRem(125)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-right: 0;
      width: ${asRem(160)};
    }
  }

  h3,
  h4,
  h5 {
    margin-top: ${({ theme }) => asRem(theme.spacing.three)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
  }

  h1 {
    font-size: ${asRem(16)};
    letter-spacing: ${asRem(0.6)};
    font-family: poppins-semibold;
    margin-top: ${({ theme }) => asRem(-theme.spacing.two)};
    margin-bottom: ${({ theme }) => asRem(theme.spacing.default)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(18)};
      margin-top: ${({ theme }) => asRem(theme.spacing.three)};
    }
  }
`;

var SleepTextBlockStyle = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: ${({ $smRow }) => ($smRow ? 'row' : 'column')};
  text-align: ${({ $smRow }) => ($smRow ? 'left' : 'center')};
  flex-basis: 0;
  flex: 1;
  margin-top: ${({ theme }) => asRem(theme.spacing.two)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }

  .image {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1;
    }

`;

const TextBlockImg = ({ image, children, smRow = false, dataCyName }) => {
    const ThemeTextBlockStyle = useIsTheme(themeSleep) ? SleepTextBlockStyle : TextBlockStyle;
    return (jsxs(ThemeTextBlockStyle, { className: "text-block-img", "$smRow": smRow, "data-cy-name": dataCyName, children: [jsx(BackgroundImage, { image: image }), children] }));
};

var LogoChainStyle = styled.div `
  width: 100%;
  display: inline-block;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: center;
  }

  .logo-chain__logo-row {
    flex-direction: column;
    justify-content: center;
    margin-top: ${({ theme }) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .logo-chain__logo {
      aspect-ratio: 150 / 60;
      width: ${asRem(150)};
      margin: 0 auto;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin: 0 0;
      }
    }
  }
`;

const LogoChain = ({ headline, logos, className = '' }) => {
    return (jsxs(LogoChainStyle, { className: `logo-chain ${className}`, children: [headline, jsx(Row, { children: logos.map((logo, index) => (jsx(Col, { xs: 12, md: 4, lg: 12 / logos.length, className: "logo-chain__logo", children: logo }, `logoChainElement_${index}`))) })] }));
};

const createGrid = ({ theme }, breakpoint) => {
    let style = '';
    if (!breakpoint) {
        for (let i = 1, l = 13; i < l; i++) {
            style += `  &.row > .col-${i} {\n`;
            style += `    grid-column: span ${i};\n`;
            style += `  }\n`;
        }
        return style;
    }
    style = `@media (min-width: ${theme.breakpoints[breakpoint]}) {\n`;
    for (let i = 1, l = 13; i < l; i++) {
        style += `  &.row > .col-${breakpoint}-${i} {\n`;
        style += `    grid-column: span ${i};\n`;
        style += `  }\n`;
    }
    style += `}\n`;
    return style;
};
var Style$3 = styled(Row) `
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(12, 1fr);
  margin: ${({ theme }) => asRem(theme.spacing.three)} 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: ${({ theme }) => asRem(theme.spacing.five)} 0;
  }
  &.row > * {
    width: 100% !important;
    margin-bottom: ${({ theme }) => asRem(theme.spacing.one)};

    .mime-elements-card {
      height: 100%;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-bottom: ${({ theme }) => asRem(theme.spacing.three)};
    }
  }

  ${(props) => createGrid(props)};
  ${(props) => createGrid(props, 'sm')};
  ${(props) => createGrid(props, 'md')};
  ${(props) => createGrid(props, 'lg')};
  ${(props) => createGrid(props, 'xl')};
  ${(props) => createGrid(props, 'xxl')};
`;

const CardContainer = ({ cards, className = '', cols = 'auto-fill' }) => {
    let colProps;
    switch (true) {
        case typeof cols === 'number':
            cols = cols;
            colProps = { xs: cols, sm: cols, md: cols, lg: cols, xl: cols, xxl: cols };
            break;
        case cols === 'auto-fill':
            const colProperty = { size: 'auto' };
            colProps = { xs: colProperty, sm: colProperty, md: colProperty, lg: colProperty, xl: colProperty, xxl: colProperty };
            break;
        default:
            colProps = cols;
            break;
    }
    return (jsx(Style$3, { className: `card-conatiner ${className}`, children: cards.map((card, index) => (jsx(Col, { ...colProps, children: card }, `cardContainerElement_${index}`))) }));
};

var StyledCard = styled.div `
  position: relative;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white.c500};
  color: ${({ theme }) => theme.colors.blueGrey.c500};
  border-radius: ${asRem(10)};

  padding: ${({ theme }) => asRem(theme.spacing.two)} ${({ theme }) => asRem(theme.spacing.three)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.three)};
  box-shadow: 0 0 20 rgba(0, 0, 0, 0.1);

  &.shadow-border {
    box-shadow: 0px 0px 60px 0px var(--black-o20);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)} ${({ theme }) => asRem(theme.spacing.four)};
  }

  .image {
    height: auto;
    margin-bottom: ${({ theme }) => asRem(theme.spacing.one)};
  }

  ul,
  li:last-child {
    margin-bottom: 0;
  }

  h3,
  h4,
  h5 {
    font-size: ${asRem(16)};
    margin-bottom: ${asRem(8)};
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(18)};
      margin-bottom: ${asRem(13)};
    }
  }
`;

var SleepStyledCard = styled.div `
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: ${asRem(10)};
  border: none;
  font-family: var(--sleep-fontfamily2);
  background-color: ${({ theme }) => theme.colors.sleep.blue.c600};
  color: ${({ theme }) => theme.colors.sleep.beige.c000};

  padding: ${({ theme }) => asRem(theme.spacing.two)} ${({ theme }) => asRem(theme.spacing.three)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.three)};
  box-shadow: 0 0 20 rgba(0, 0, 0, 0.1);

  &.shadow-border {
    box-shadow: 0px 0px 60px 0px var(--black-o20);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)} ${({ theme }) => asRem(theme.spacing.four)};
  }

  .image {
    height: auto;
    margin-bottom: ${({ theme }) => asRem(theme.spacing.one)};
  }

  ul,
  li:last-child {
    margin-bottom: 0;
  }

  h3,
  h4,
  h5 {
    font-size: ${asRem(16)};
    margin-bottom: ${asRem(8)};
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${asRem(18)};
      margin-bottom: ${asRem(13)};
    }
  }

  p {
    margin: 0 0 ${asRem(15)};
  }
`;

const Card = ({ className = '', shadow, children, badge }) => {
    const ThemeStyledCard = useIsTheme(themeSleep) ? SleepStyledCard : StyledCard;
    return (jsxs(ThemeStyledCard, { className: ['mime-elements-card', className, shadow && 'shadow-border'].filter((c) => !!c).join(' '), children: [badge && badge, children] }));
};

var StyledHeadlineContainer = styled.div `
  width: 100%;
  span {
    margin-bottom: 0 !important;
  }

  span > h3,
  span > h2 {
    margin-bottom: 0 !important;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin-bottom: ${({ theme }) => asRem(theme.spacing.default)}!important;
    }
  }

  margin-bottom: ${({ theme }) => asRem(theme.spacing.two)};
`;

const HeadlineContainer = ({ className = '', children }) => {
    return jsx(StyledHeadlineContainer, { className: `headline-container ${className}`, children: children });
};

var ScrollableRowStyle = styled.div `
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-padding: 0 ${({ theme }) => asRem(theme.spacing.ten)};
  scroll-snap-type: x mandatory;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    justify-content: center;
  }

  & > * {
    scroll-snap-align: start;
    margin: 0 ${({ theme }) => asRem(theme.spacing.one)};
  }
`;

const ScrollableRow = ({ children, className = '' }) => {
    return jsx(ScrollableRowStyle, { className: `scrollable-row ${className}`, children: children });
};

var StyledRoundedBox = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white.c500};
  color: ${({ theme }) => theme.colors.blueGrey.c500};
  border-radius: ${asRem(10)};
  overflow: hidden;

  padding: ${({ theme }) => asRem(theme.spacing.two)} ${({ theme }) => asRem(theme.spacing.three)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.three)};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)} ${({ theme }) => asRem(theme.spacing.four)};
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.2);
  }
`;

var StyledRoundedBoxSleep = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.sleep.blue.c790};
  color: ${({ theme }) => theme.colors.sleep.beige.c100} !important;
  border-radius: ${asRem(10)};
  overflow: hidden;

  padding: ${({ theme }) => asRem(theme.spacing.two)} ${({ theme }) => asRem(theme.spacing.three)};
  margin-bottom: ${({ theme }) => asRem(theme.spacing.three)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => asRem(theme.spacing.three)} ${({ theme }) => asRem(theme.spacing.four)};
  }
`;

const RoundedBox = ({ className = '', children }) => {
    const ThemedRoundedBox = useIsTheme(themeSleep) ? StyledRoundedBoxSleep : StyledRoundedBox;
    return jsx(ThemedRoundedBox, { className: `mime-elements-rounded-box ${className}`, children: children });
};

var StyledBadge = styled.div `
  position: absolute;
  top: 0;
  right: 0;

  display: inline-block;
  color: ${({ theme }) => theme.colors.badge.text};
  background-color: ${({ theme }) => theme.colors.badge.background};
  text-align: center;
  min-width: ${asRem(50)};
  padding: ${({ theme }) => asRem(theme.spacing.default)} ${({ theme }) => asRem(theme.spacing.two)};
  border-radius: 0;
  border-bottom-left-radius: ${asRem(8)};
  border-top-right-radius: ${asRem(8)};

  font-family: poppins-semibold;
  font-size: ${asRem(12)};
  line-height: ${asRem(16)};
  letter-spacing: ${asRem(0.25)};
  text-transform: uppercase;
`;

const Badge = ({ className, children }) => {
    return jsx(StyledBadge, { className: `badge ${className}`, children: children });
};

var MenuStyle = styled.div `
  width: 100%;
  background-color: transparent;
  z-index: 1000;
  height: 80px;
  font-size: 1rem;

  .nav-link {
    color: ${({ theme }) => theme.colors.menu.text};
  }

  .navbar-brand {
    background-size: 135px;
    width: 135px;
    height: 40px;
    text-indent: -10000px;
  }

  .navbar-collapse {
    @media (max-width: ${breakpoints.lg}) {
      background-color: ${({ theme }) => theme.colors.menu.background};
      margin-top: 1.5rem;

      .nav-link {
        background-color: ${({ theme }) => theme.colors.menu.background};
        display: inline-block;
      }
    }
  }

  .navbar {
    --bs-nav-link-font-size: 15px;

    height: 56px;
    font-family: 'Poppins-SemiBold', sans-serif;
    z-index: 10;

    .container-fluid {
      padding-left: 0;
      padding-right: 0;
    }

    .navbar-toggler {
      border: 0;

      &:focus {
        box-shadow: none;
      }

      .navbar-toggler-icon {
        transition: background-color 0.6s ease-in-out;
        background-color: ${({ theme }) => theme.colors.menu.text};
        background-image: none;
        width: 25px;
        height: 3px;
        position: relative;
        border-radius: 2px;

        &:before,
        &:after {
          transition: transform 0.6s ease-in-out, background-color 0.6s ease-in-out;
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: ${({ theme }) => theme.colors.menu.text};
          border-radius: 2px;
          left: 0;
        }

        &:before {
          top: -8px;
        }
        &:after {
          bottom: -8px;
        }
      }
    }

    .navbar-open {
      .navbar-toggler-icon {
        background-color: transparent !important;

        &:before {
          transform: rotate(45deg) scaleX(1.256) translate(4px, 7px);
        }
        &:after {
          transform: rotate(-45deg) scaleX(1.256) translate(4px, -7px);
        }
      }
    }

    .nav-item {
      padding: 0.8rem 1.5rem;

      &:last-child {
        padding-right: 0;
      }
      
      &.active .nav-link,
      .nav-link:hover {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: ${({ theme }) => theme.colors.menu.text};
        }
      }
    }

    .navbar-nav {
      .nav-link {
        padding: 0;
        font-family: 'Poppins-SemiBold';
        letter-spacing: 0.02rem;
        text-transform: uppercase;
      }
    }

    padding-top: 1.3rem;
  }

  &.navbar-transparent {
    .nav-item.active .nav-link:before,
    .nav-item:hover .nav-link:before {
      background-color: ${({ theme }) => theme.colors.menu.textTransparent};
    }

    .nav-link {
      color: ${({ theme }) => theme.colors.menu.textTransparent};
    }

    &.navbar-down {
      .navbar .navbar-nav .nav-link {
        color: ${({ theme }) => theme.colors.menu.text};
      }

      .nav-item.active .nav-link:before,
      .nav-item:hover .nav-link:before {
        background-color: ${({ theme }) => theme.colors.menu.text};
      }

      .navbar .navbar-toggler .navbar-toggler-icon {
        background-color: ${({ theme }) => theme.colors.menu.text};

        &:before,
        &:after {
          background-color: ${({ theme }) => theme.colors.menu.text};
        }
      }

      @media (max-width: ${breakpoints.lg}) {
        .navbar-collapse .nav-link {
          background-color: ${({ theme }) => theme.colors.menu.background};
        }
      }
    }

    @media (max-width: ${breakpoints.lg}) {
      .navbar-collapse,
      .navbar-collapse .nav-link {
        background-color: ${({ theme }) => theme.colors.menu.collapse};
      }
    }

    .navbar .navbar-toggler .navbar-toggler-icon {
      background-color: ${({ theme }) => theme.colors.menu.textTransparent};

      &:before,
      &:after {
        background-color: ${({ theme }) => theme.colors.menu.textTransparent};
      }
    }
  }

  &.navbar-down {
    background-color: ${({ theme }) => theme.colors.menu.background};
    box-shadow: 0 1px 5px 2px rgba(0, 0, 0, 0.03);
  }
`;

var MenuStyleSleep = styled(MenuStyle) `
  background-color: var(--sleep-blue-c790) !important;
  width: 100% !important;
  z-index: 1000;

  .navigation {
  background-color: var(--sleep-blue-c790)!important;
}

  .navbar {
    --bs-nav-link-font-size: ${asRem(14)};
    background-color: var(--sleep-blue-c790)!important;
    align-items: center;
    height: ${asRem(72)};
    font-family: var(--sleep-fontfamily2), sans-serif;
    z-index: 10;
    padding-right: ${asRem(18)};

    .navbar-nav {
      .nav-link {
        padding: 0;
        font-family: var(--sleep-fontfamily2), sans-serif;
        color: ${({ theme }) => theme.colors.sleep.beige.c200};
        font-size: ${asRem(14)};
        letter-spacing: 0.02rem;
        text-transform: uppercase;

        &:focus {
      border: none !important; 
    }

      }

      .nav-item {
        &.active .nav-link,
        .nav-link:hover {
          &:before {
            bottom: -2px;
            height: 2px;
            background-color: ${({ theme }) => theme.colors.sleep.beige.c200};
          }
        }
      }
    }

  &.navbar-transparent {
    .nav-item.active .nav-link:before,
    .nav-item:hover .nav-link:before {
      background-color: ${({ theme }) => theme.colors.sleep.blue.c790}!important;
    }

    .nav-link {
      color: ${({ theme }) => theme.colors.sleep.beige.c200};
    }

  }

  .navbar-sleep-brand {
    width: ${asRem(200)};
    height: ${asRem(53)};
    text-indent: -10000px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center ;
  }

  .navbar-collapse {
    @media (max-width: ${breakpoints.lg}) {
      background-color: ${({ theme }) => theme.colors.sleep.blue.c790} !important;
      margin-top: 1.5rem;

      .nav-link {
        background-color: ${({ theme }) => theme.colors.sleep.blue.c790} !important;
        display: inline-block;
      }
    }
  }

  .navbar-down {
    background-color: ${({ theme }) => theme.colors.sleep.blue.c790} !important;
    box-shadow: none !important;
    width: 100% !important;
  }
  
  .nav-link:focus, .nav-link:focus-visible {
    border: none !important;
  }

`;

const Menu = ({ children, open, onToggleNavbar, className, tinted, brandLink, cooperationLogo, }) => {
    const [isOpen, setIsOpen] = React__default.useState(open ?? false);
    const [top, setTop] = React__default.useState(true);
    const ThemeStyle = useIsTheme(themeSleep) ? MenuStyleSleep : MenuStyle;
    const classNames = (classes) => classes.filter((c) => !!c).join(' ');
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const toggleMenu = () => {
        if (window.innerWidth <= parseInt(breakpoints.lg, 10)) {
            onToggleNavbar && onToggleNavbar(!open);
            setIsOpen(!isOpen);
        }
    };
    const handleScroll = () => {
        setTop(window.scrollY < 65);
    };
    return (jsx(ThemeStyle, { className: classNames([
            'navigation',
            'fixed-top',
            tinted ? 'navbar-dark' : 'navbar-transparent',
            top ? 'navbar-up' : 'navbar-down',
            className ?? '',
        ]), children: jsx(Container, { children: jsx(Row, { children: jsx(Col, { children: jsxs(Navbar, { expand: "lg", children: [brandLink, children && (jsxs(Fragment, { children: [jsx(NavbarToggler, { onClick: toggleMenu, className: classNames([isOpen ? 'navbar-isOpen' : '']) }), jsx(Collapse, { isOpen: open ?? isOpen, navbar: true, onClick: toggleMenu, children: jsx(Nav, { className: "ms-auto", navbar: true, children: children }) })] })), cooperationLogo] }) }) }) }) }));
};
const NavbarBrand = NavbarBrand$1;

const NavLink = NavLink$1;

const NavItem = NavItem$1;

var Style$2 = styled(NavItem) ``;

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */
var Action;
(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */
  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */
  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
//#endregion

var ResultType;
(function (ResultType) {
  ResultType["data"] = "data";
  ResultType["deferred"] = "deferred";
  ResultType["redirect"] = "redirect";
  ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
/**
 * @private
 */
function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }
  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  let nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }
  return pathname.slice(startIndex) || "/";
}

const validMutationMethodsArr = ["post", "put", "patch", "delete"];
new Set(validMutationMethodsArr);
const validRequestMethodsArr = ["get", ...validMutationMethodsArr];
new Set(validRequestMethodsArr);

const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const Link$1 = ({ children, to, ...props }) => {
    if (typeof to === 'string' && ABSOLUTE_URL_REGEX.test(to)) {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith('//') ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = stripBasename(targetUrl.pathname, window.location.origin);
        if (path === currentUrl.origin && path != null) {
            to = path + targetUrl.search + targetUrl.hash;
        }
    }
    return (jsx("a", { href: to, ...props, children: children }));
};
const MenuLink = ({ children, location, tag, active, activeAvailableRoutes = [], to, onClick, }) => {
    const { pathname } = location ?? window.location;
    const compareRouteWithPath = (route) => {
        return pathname.startsWith(route.replace(/\/:.*[^\/]|\/\*.*/, ''));
    };
    const isActive = useMemo(() => {
        if (active || (pathname === to && pathname === '/')) {
            return true;
        }
        return to !== '/' && (compareRouteWithPath(to) || activeAvailableRoutes.some(compareRouteWithPath));
    }, [pathname, to]);
    return (jsx(Style$2, { className: [isActive && 'active'].filter((c) => !!c).join(' '), children: jsx(NavLink, { tag: tag ?? Link$1, to: to, onClick: onClick, children: children }) }));
};

const overrides = `
  .dropdown-menu {
    --bs-dropdown-border-radius: var(--bs-border-radius);
    --bs-dropdown-border-width: var(--bs-border-width);
    --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  }
`;
const Dropdown$1 = styled(Dropdown$2) `
  ${overrides}
`;
const UncontrolledDropdown$1 = styled(UncontrolledDropdown$2) `
  ${overrides}
`;
const DropdownToggle$1 = styled(DropdownToggle$2) ``;
const DropdownItem$1 = styled(DropdownItem$2) ``;
const DropdownMenu$1 = styled(DropdownMenu$2) ``;

const Dropdown = Dropdown$1;
const UncontrolledDropdown = UncontrolledDropdown$1;
const DropdownToggle = DropdownToggle$1;
const DropdownMenu = DropdownMenu$1;
const DropdownItem = DropdownItem$1;

var Style$1 = styled.div `
  width: 100%;

  .nav-tabs {
    justify-content: center;
  }

  .mime-elements-tab-content {
    margin-top: ${asRem(24)};
  }

  .mime-elements-tab {
    font-family: Poppins-SemiBold, Helvetica;
    color: ${({ theme }) => theme.colors.tabs.textColor};
    text-transform: uppercase;
    cursor: pointer;

    &.active .nav-link:after,
    &:hover .nav-link:after,
    &:focus .nav-link:after {
      content: '';
      position: absolute;
      bottom: ${asRem(0.4)};
      height: ${asRem(3)};
      width: calc(100% - ${asRem(40)});
      background-color: ${({ theme }) => theme.colors.tabs.textFocus};
      left: ${asRem(20)};
    }

    .nav-link {
      color: ${({ theme }) => theme.colors.tabs.textColor};
      position: relative;
      padding-left: ${asRem(20)};
      padding-right: ${asRem(20)};
    }

    a {
      color: inherit;
    }

    &.active .nav-link {
      color: ${({ theme }) => theme.colors.tabs.textFocus};
    }

    &:hover .nav-link,
    &:focus .nav-link {
      isolation: auto;
      border-color: transparent;
      color: ${({ theme }) => theme.colors.tabs.textFocus};
    }
  }

  .nav-tabs {
    border-bottom: transparent;
    color: red;
  }
`;

const Tabs = ({ className, activeTab, onChange, items, defaultActiveTab }) => {
    const [tab, setTab] = React__default.useState(activeTab ?? defaultActiveTab ?? 0);
    const handleOnClickTab = (index) => () => {
        if (activeTab !== undefined && onChange) {
            return onChange(index);
        }
        setTab(index);
    };
    return (jsxs(Style$1, { className: [className, 'mime-elements-tabs'].filter((c) => !!c).join(' '), children: [jsx(Nav, { tabs: true, children: items.map((item, index) => (jsx(Tab, { active: index === (activeTab ?? tab), className: 'mime-elements-tab', onClick: handleOnClickTab(index), children: item.title }, `tabItem-${item.key ?? index}`))) }), jsx(TabContent, { activeTab: activeTab ?? tab, className: 'mime-elements-tab-content', children: items.map((item, index) => (jsx(TabPane, { tabId: index, children: item.content }, `tabPane-${item.key ?? index}`))) })] }));
};
const Tab = ({ className = '', active, onClick, children }) => (jsx(NavItem, { className: [className, active && 'active'].filter((c) => !!c).join(' '), children: jsx(NavLink, { onClick: onClick, children: children }) }));

var modules = {};

var Link = {};

var scrollLink = {};

var scrollSpy$2 = {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle$1;

var passiveEventListeners = {};

Object.defineProperty(passiveEventListeners, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
passiveEventListeners.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn('Listener must be a named function.');
  }

  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;

  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};

passiveEventListeners.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};

var attachedListeners = new Map();

Object.defineProperty(scrollSpy$2, "__esModule", {
  value: true
});

var _lodash$1 = lodash_throttle;

var _lodash2 = _interopRequireDefault$e(_lodash$1);

var _passiveEventListeners$1 = passiveEventListeners;

function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy$1 = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy$1.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy$1.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners$1.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy$1.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy$1.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy$1.spySetState && scrollSpy$1.spySetState.length && scrollSpy$1.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy$1.spySetState.splice(scrollSpy$1.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy$1.scrollHandler);
  },


  update: function update() {
    return scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return scrollSpy$1.scrollHandler(c);
    });
  }
};

scrollSpy$2.default = scrollSpy$1;

var scroller = {};

var utils = {};

Object.defineProperty(utils, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

utils.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

var animateScroll$1 = {};

var smooth = {};

Object.defineProperty(smooth, "__esModule", {
  value: true
});
smooth.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

var cancelEvents = {};

Object.defineProperty(cancelEvents, "__esModule", {
  value: true
});

var _passiveEventListeners = passiveEventListeners;

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

cancelEvents.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

var scrollEvents = {};

Object.defineProperty(scrollEvents, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

scrollEvents.default = Events;

Object.defineProperty(animateScroll$1, "__esModule", {
  value: true
});

var _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$2 = utils;

_interopRequireDefault$d(_utils$2);

var _smooth = smooth;

var _smooth2 = _interopRequireDefault$d(_smooth);

var _cancelEvents = cancelEvents;

var _cancelEvents2 = _interopRequireDefault$d(_cancelEvents);

var _scrollEvents$2 = scrollEvents;

var _scrollEvents2$2 = _interopRequireDefault$d(_scrollEvents$2);

function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  }
  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2$2.default.registered['end']) {
    _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  var setCancel = function setCancel() {
    options.data.cancel = true;
  };
  _cancelEvents2.default.subscribe(setCancel);

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2$2.default.registered['begin']) {
        _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2$2.default.registered['begin']) {
    _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends$8({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

animateScroll$1.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

Object.defineProperty(scroller, "__esModule", {
  value: true
});

var _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$1 = utils;

var _utils2$1 = _interopRequireDefault$c(_utils$1);

var _animateScroll$1 = animateScroll$1;

var _animateScroll2$1 = _interopRequireDefault$c(_animateScroll$1);

var _scrollEvents$1 = scrollEvents;

var _scrollEvents2$1 = _interopRequireDefault$c(_scrollEvents$1);

function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

scroller.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends$7({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2$1.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2$1.default.registered['begin']) {
        _scrollEvents2$1.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2$1.default.registered['end']) {
        _scrollEvents2$1.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2$1.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

var scrollHash$2 = {};

Object.defineProperty(scrollHash$2, "__esModule", {
  value: true
});

var _utils = utils;

var _utils2 = _interopRequireDefault$b(_utils);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash$1 = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

scrollHash$2.default = scrollHash$1;

Object.defineProperty(scrollLink, "__esModule", {
  value: true
});

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$9 = React__default;

var _react2$4 = _interopRequireDefault$a(_react$9);

var _scrollSpy$1 = scrollSpy$2;

var _scrollSpy2$1 = _interopRequireDefault$a(_scrollSpy$1);

var _scroller$2 = scroller;

var _scroller2$2 = _interopRequireDefault$a(_scroller$2);

var _propTypes$2 = propTypesExports;

var _propTypes2$2 = _interopRequireDefault$a(_propTypes$2);

var _scrollHash = scrollHash$2;

var _scrollHash2 = _interopRequireDefault$a(_scrollHash);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes$1 = {
  to: _propTypes2$2.default.string.isRequired,
  containerId: _propTypes2$2.default.string,
  container: _propTypes2$2.default.object,
  activeClass: _propTypes2$2.default.string,
  activeStyle: _propTypes2$2.default.object,
  spy: _propTypes2$2.default.bool,
  horizontal: _propTypes2$2.default.bool,
  smooth: _propTypes2$2.default.oneOfType([_propTypes2$2.default.bool, _propTypes2$2.default.string]),
  offset: _propTypes2$2.default.number,
  delay: _propTypes2$2.default.number,
  isDynamic: _propTypes2$2.default.bool,
  onClick: _propTypes2$2.default.func,
  duration: _propTypes2$2.default.oneOfType([_propTypes2$2.default.number, _propTypes2$2.default.func]),
  absolute: _propTypes2$2.default.bool,
  onSetActive: _propTypes2$2.default.func,
  onSetInactive: _propTypes2$2.default.func,
  ignoreCancelEvents: _propTypes2$2.default.bool,
  hashSpy: _propTypes2$2.default.bool,
  saveHashHistory: _propTypes2$2.default.bool,
  spyThrottle: _propTypes2$2.default.number
};

scrollLink.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2$2.default;

  var Link = function (_React$PureComponent) {
    _inherits$9(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck$9(this, Link);

      var _this = _possibleConstructorReturn$9(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass$8(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2$1.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2$1.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2$1.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2$1.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends$6({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends$6({}, this.props.style);
        }

        var props = _extends$6({}, this.props);

        for (var prop in protoTypes$1) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2$4.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2$4.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends$6({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes$1;

  Link.defaultProps = { offset: 0 };

  return Link;
};

Object.defineProperty(Link, "__esModule", {
  value: true
});

var _react$8 = React__default;

var _react2$3 = _interopRequireDefault$9(_react$8);

var _scrollLink$2 = scrollLink;

var _scrollLink2$2 = _interopRequireDefault$9(_scrollLink$2);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits$8(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$8(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$8(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2$3.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn$8(_this, _ret);
  }

  return LinkElement;
}(_react2$3.default.Component);

Link.default = (0, _scrollLink2$2.default)(LinkElement);

var Button = {};

Object.defineProperty(Button, "__esModule", {
  value: true
});

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$7 = React__default;

var _react2$2 = _interopRequireDefault$8(_react$7);

var _scrollLink$1 = scrollLink;

var _scrollLink2$1 = _interopRequireDefault$8(_scrollLink$1);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits$7(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck$7(this, ButtonElement);

    return _possibleConstructorReturn$7(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass$7(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2$2.default.createElement(
        'button',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2$2.default.Component);

Button.default = (0, _scrollLink2$1.default)(ButtonElement);

var Element$3 = {};

var scrollElement = {};

Object.defineProperty(scrollElement, "__esModule", {
  value: true
});

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$6 = React__default;

var _react2$1 = _interopRequireDefault$7(_react$6);

var _reactDom = ReactDOM__default;

_interopRequireDefault$7(_reactDom);

var _scroller$1 = scroller;

var _scroller2$1 = _interopRequireDefault$7(_scroller$1);

var _propTypes$1 = propTypesExports;

var _propTypes2$1 = _interopRequireDefault$7(_propTypes$1);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

scrollElement.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits$6(Element, _React$Component);

    function Element(props) {
      _classCallCheck$6(this, Element);

      var _this = _possibleConstructorReturn$6(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass$6(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2$1.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2$1.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2$1.default.createElement(Component, _extends$5({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2$1.default.Component);

  Element.propTypes = {
    name: _propTypes2$1.default.string,
    id: _propTypes2$1.default.string
  };

  return Element;
};

Object.defineProperty(Element$3, "__esModule", {
  value: true
});

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$5 = React__default;

var _react2 = _interopRequireDefault$6(_react$5);

var _scrollElement$1 = scrollElement;

var _scrollElement2$1 = _interopRequireDefault$6(_scrollElement$1);

var _propTypes = propTypesExports;

var _propTypes2 = _interopRequireDefault$6(_propTypes);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits$5(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck$5(this, ElementWrapper);

    return _possibleConstructorReturn$5(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass$5(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` and `name` from props
      var newProps = _extends$4({}, this.props);
      delete newProps.name;
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends$4({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

Element$3.default = (0, _scrollElement2$1.default)(ElementWrapper);

/* DEPRECATED */

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = React__default;
var scrollSpy = scrollSpy$2;
var defaultScroller = scroller;
var PropTypes = propTypesExports;
var scrollHash = scrollHash$2;

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits$4(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck$4(this, Scroll);

        var _this = _possibleConstructorReturn$4(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass$4(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends$3({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends$3({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits$4(Element, _React$Component2);

      function Element(props) {
        _classCallCheck$4(this, Element);

        var _this3 = _possibleConstructorReturn$4(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass$4(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends$3({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

var Helpers_1 = Helpers;

Object.defineProperty(modules, "__esModule", {
  value: true
});
modules.Helpers = modules.ScrollElement = ScrollLink$1 = modules.ScrollLink = modules.animateScroll = modules.scrollSpy = modules.Events = modules.scroller = Element$2 = modules.Element = modules.Button = modules.Link = undefined;

var _Link = Link;

var _Link2 = _interopRequireDefault$5(_Link);

var _Button = Button;

var _Button2 = _interopRequireDefault$5(_Button);

var _Element = Element$3;

var _Element2 = _interopRequireDefault$5(_Element);

var _scroller = scroller;

var _scroller2 = _interopRequireDefault$5(_scroller);

var _scrollEvents = scrollEvents;

var _scrollEvents2 = _interopRequireDefault$5(_scrollEvents);

var _scrollSpy = scrollSpy$2;

var _scrollSpy2 = _interopRequireDefault$5(_scrollSpy);

var _animateScroll = animateScroll$1;

var _animateScroll2 = _interopRequireDefault$5(_animateScroll);

var _scrollLink = scrollLink;

var _scrollLink2 = _interopRequireDefault$5(_scrollLink);

var _scrollElement = scrollElement;

var _scrollElement2 = _interopRequireDefault$5(_scrollElement);

var _Helpers = Helpers_1;

var _Helpers2 = _interopRequireDefault$5(_Helpers);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

modules.Link = _Link2.default;
modules.Button = _Button2.default;
var Element$2 = modules.Element = _Element2.default;
modules.scroller = _scroller2.default;
modules.Events = _scrollEvents2.default;
modules.scrollSpy = _scrollSpy2.default;
modules.animateScroll = _animateScroll2.default;
var ScrollLink$1 = modules.ScrollLink = _scrollLink2.default;
modules.ScrollElement = _scrollElement2.default;
modules.Helpers = _Helpers2.default;
modules.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

const ScrollButtonComponent = ScrollLink$1(Button$2);
const ScrollButton = ({ children, dataCyName, className, color, type, to, duration = 1200, offset = 0 }) => {
    return (jsx(ScrollButtonComponent, { dataCyName: dataCyName, type: type, className: className, color: color, to: to, spy: true, smooth: false, duration: duration, offset: offset, children: children }));
};

const ScrollLinkComponent = ScrollLink$1(Link$2);
const ScrollLink = ({ children, className, dataCyName, color, to, duration = 1200, offset = 0, containerId, }) => {
    return (jsx(ScrollLinkComponent, { className: className, color: color, to: to, spy: true, smooth: false, duration: duration, offset: offset, containerId: containerId, dataCyName: dataCyName, children: children }));
};
const Element$1 = Element$2;

var Style = styled(Modal$1) `
  .modal-content {
    border-width: 0;
    border-radius: ${asRem(12)};
  }

  .modal-body {
    max-height: 97vh;
    min-height: 20vh;
  }

  .close {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
`;

const Modal = ({ children, className, isOpen, toggle }) => {
    return (jsx(Style, { className: `mime-elements-modal ${className}`, isOpen: isOpen, toggle: toggle, children: jsxs(ModalBody, { children: [jsx(Icon, { name: "Close", className: "close", size: 40, color: colors.grey.c800, onClick: toggle }), children] }) }));
};

var lib = {};

var slider = {};

var innerSlider = {};

var initialState = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	exports["default"] = initialState; 
} (initialState));

var innerSliderUtils = {};

var defaultProps = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(React__default);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true,
	  asNavFor: null
	};
	exports["default"] = defaultProps; 
} (defaultProps));

Object.defineProperty(innerSliderUtils, "__esModule", {
  value: true
});
innerSliderUtils.checkSpecKeys = innerSliderUtils.checkNavigable = innerSliderUtils.changeSlide = innerSliderUtils.canUseDOM = innerSliderUtils.canGoNext = void 0;
innerSliderUtils.clamp = clamp;
innerSliderUtils.extractObject = void 0;
innerSliderUtils.filterSettings = filterSettings;
innerSliderUtils.validSettings = innerSliderUtils.swipeStart = innerSliderUtils.swipeMove = innerSliderUtils.swipeEnd = innerSliderUtils.slidesOnRight = innerSliderUtils.slidesOnLeft = innerSliderUtils.slideHandler = innerSliderUtils.siblingDirection = innerSliderUtils.safePreventDefault = innerSliderUtils.lazyStartIndex = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.keyHandler = innerSliderUtils.initializedState = innerSliderUtils.getWidth = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackCSS = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTotalSlides = innerSliderUtils.getSwipeDirection = innerSliderUtils.getSlideCount = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getPreClones = innerSliderUtils.getPostClones = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.getNavigableIndexes = innerSliderUtils.getHeight = void 0;
var _react$4 = _interopRequireDefault$4(React__default);
var _defaultProps = _interopRequireDefault$4(defaultProps);
function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$4(o) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$4(o); }
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty$4(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$4(obj, key, value) { key = _toPropertyKey$4(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$4(t) { var i = _toPrimitive$4(t, "string"); return "symbol" == _typeof$4(i) ? i : String(i); }
function _toPrimitive$4(t, r) { if ("object" != _typeof$4(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$4(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}
var safePreventDefault = innerSliderUtils.safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};
var getOnDemandLazySlides = innerSliderUtils.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
innerSliderUtils.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = innerSliderUtils.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = innerSliderUtils.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = innerSliderUtils.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = innerSliderUtils.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = innerSliderUtils.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = innerSliderUtils.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = innerSliderUtils.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }
  return "vertical";
};

// whether or not we can go next
var canGoNext = innerSliderUtils.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
innerSliderUtils.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
innerSliderUtils.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react$4["default"].Children.count(spec.children);
  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };
  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }
  return state;
};
innerSliderUtils.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
    animating = spec.animating,
    fade = spec.fade,
    infinite = spec.infinite,
    index = spec.index,
    slideCount = spec.slideCount,
    lazyLoad = spec.lazyLoad,
    currentSlide = spec.currentSlide,
    centerMode = spec.centerMode,
    slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
    finalSlide,
    animationLeft,
    finalLeft;
  var state = {},
    nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }
    animationLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: finalSlide
    }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }
  return {
    state: state,
    nextState: nextState
  };
};
innerSliderUtils.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
    slidesToShow = spec.slidesToShow,
    slideCount = spec.slideCount,
    currentSlide = spec.currentSlide,
    previousTargetSlide = spec.targetSlide,
    lazyLoad = spec.lazyLoad,
    infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (infinite) {
      var direction = siblingDirection(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        targetSlide: targetSlide
      }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }
  return targetSlide;
};
innerSliderUtils.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};
innerSliderUtils.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
innerSliderUtils.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
    animating = spec.animating,
    vertical = spec.vertical,
    swipeToSlide = spec.swipeToSlide,
    verticalSwiping = spec.verticalSwiping,
    rtl = spec.rtl,
    currentSlide = spec.currentSlide,
    edgeFriction = spec.edgeFriction,
    edgeDragged = spec.edgeDragged,
    onEdge = spec.onEdge,
    swiped = spec.swiped,
    swiping = spec.swiping,
    slideCount = spec.slideCount,
    slidesToScroll = spec.slidesToScroll,
    infinite = spec.infinite,
    touchObject = spec.touchObject,
    swipeEvent = spec.swipeEvent,
    listHeight = spec.listHeight,
    listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
    state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _objectSpread$4(_objectSpread$4({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: swipeLeft
    }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }
  return state;
};
innerSliderUtils.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
    swipe = spec.swipe,
    touchObject = spec.touchObject,
    listWidth = spec.listWidth,
    touchThreshold = spec.touchThreshold,
    verticalSwiping = spec.verticalSwiping,
    listHeight = spec.listHeight,
    swipeToSlide = spec.swipeToSlide,
    scrolling = spec.scrolling,
    onSwipe = spec.onSwipe,
    targetSlide = spec.targetSlide,
    currentSlide = spec.currentSlide,
    infinite = spec.infinite;
  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = activeSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: currentLeft
    }));
  }
  return state;
};
var getNavigableIndexes = innerSliderUtils.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = innerSliderUtils.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = innerSliderUtils.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }
      return true;
    });
    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};
var checkSpecKeys = innerSliderUtils.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};
var getTrackCSS = innerSliderUtils.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread$4(_objectSpread$4({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }
  return style;
};
var getTrackAnimateCSS = innerSliderUtils.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = innerSliderUtils.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }
  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
    trackRef = spec.trackRef,
    infinite = spec.infinite,
    centerMode = spec.centerMode,
    slideCount = spec.slideCount,
    slidesToShow = spec.slidesToShow,
    slidesToScroll = spec.slidesToScroll,
    slideWidth = spec.slideWidth,
    listWidth = spec.listWidth,
    variableWidth = spec.variableWidth,
    slideHeight = spec.slideHeight,
    fade = spec.fade,
    vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;
  if (fade || spec.slideCount === 1) {
    return 0;
  }
  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;
  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }
  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }
  return targetLeft;
};
var getPreClones = innerSliderUtils.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = innerSliderUtils.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};
var getTotalSlides = innerSliderUtils.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = innerSliderUtils.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};
var slidesOnRight = innerSliderUtils.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
    centerMode = _ref.centerMode,
    rtl = _ref.rtl,
    centerPadding = _ref.centerPadding;
  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};
var slidesOnLeft = innerSliderUtils.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
    centerMode = _ref2.centerMode,
    rtl = _ref2.rtl,
    centerPadding = _ref2.centerPadding;
  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};
innerSliderUtils.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var validSettings = innerSliderUtils.validSettings = Object.keys(_defaultProps["default"]);
function filterSettings(settings) {
  return validSettings.reduce(function (acc, settingName) {
    if (settings.hasOwnProperty(settingName)) {
      acc[settingName] = settings[settingName];
    }
    return acc;
  }, {});
}

var track = {};

Object.defineProperty(track, "__esModule", {
  value: true
});
track.Track = void 0;
var _react$3 = _interopRequireDefault$3(React__default);
var _classnames$3 = _interopRequireDefault$3(classnamesExports);
var _innerSliderUtils$3 = innerSliderUtils;
function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$3(o) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$3(o); }
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor); } }
function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$3(subClass, superClass); }
function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }
function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$3(self); }
function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty$3(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$3(obj, key, value) { key = _toPropertyKey$3(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$3(t) { var i = _toPrimitive$3(t, "string"); return "symbol" == _typeof$3(i) ? i : String(i); }
function _toPrimitive$3(t, r) { if ("object" != _typeof$3(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$3(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var focusedSlide;
  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }
  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};
var getSlideStyle = function getSlideStyle(spec) {
  var style = {};
  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }
  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};
var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react$3["default"].Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils$3.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils$3.lazyEndIndex)(spec);
  _react$3["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react$3["default"].createElement("div", null);
    }
    var childStyle = getSlideStyle(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    // push a cloned element of the desired slide
    slides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames$3["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread$3(_objectSpread$3({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils$3.getPreClones)(spec)) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
      key = childrenCount + index;
      if (key < endIndex) {
        child = elem;
      }
      slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
        index: key
      }));
      postCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
        key: "postcloned" + getKey(child, key),
        "data-index": key,
        tabIndex: "-1",
        className: (0, _classnames$3["default"])(slideClasses, slideClass),
        "aria-hidden": !slideClasses["slick-active"],
        style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
        onClick: function onClick(e) {
          child.props && child.props.onClick && child.props.onClick(e);
          if (spec.focusOnSelect) {
            spec.focusOnSelect(childOnClickOptions);
          }
        }
      }));
    }
  });
  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};
track.Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$3(Track, _React$PureComponent);
  var _super = _createSuper$3(Track);
  function Track() {
    var _this;
    _classCallCheck$3(this, Track);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized$3(_this), "node", null);
    _defineProperty$3(_assertThisInitialized$3(_this), "handleRef", function (ref) {
      _this.node = ref;
    });
    return _this;
  }
  _createClass$3(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react$3["default"].createElement("div", _extends$2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);
  return Track;
}(_react$3["default"].PureComponent);

var dots = {};

function _typeof$2(o) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$2(o); }
Object.defineProperty(dots, "__esModule", {
  value: true
});
dots.Dots = void 0;
var _react$2 = _interopRequireDefault$2(React__default);
var _classnames$2 = _interopRequireDefault$2(classnamesExports);
var _innerSliderUtils$2 = innerSliderUtils;
function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$2(obj, key, value) { key = _toPropertyKey$2(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor); } }
function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$2(t) { var i = _toPrimitive$2(t, "string"); return "symbol" == _typeof$2(i) ? i : String(i); }
function _toPrimitive$2(t, r) { if ("object" != _typeof$2(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$2(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$2(subClass, superClass); }
function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$2(self); }
function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }
var getDotCount = function getDotCount(spec) {
  var dots;
  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }
  return dots;
};
dots.Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$2(Dots, _React$PureComponent);
  var _super = _createSuper$2(Dots);
  function Dots() {
    _classCallCheck$2(this, Dots);
    return _super.apply(this, arguments);
  }
  _createClass$2(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        onMouseOver = _this$props.onMouseOver,
        onMouseLeave = _this$props.onMouseLeave,
        infinite = _this$props.infinite,
        slidesToScroll = _this$props.slidesToScroll,
        slidesToShow = _this$props.slidesToShow,
        slideCount = _this$props.slideCount,
        currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];
      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;
        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils$2.clamp)(_rightBound, 0, slideCount - 1);
        var _leftBound = rightBound - (slidesToScroll - 1);
        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils$2.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames$2["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react$2["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react$2["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }
      return /*#__PURE__*/_react$2["default"].cloneElement(this.props.appendDots(dots), _objectSpread$2({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);
  return Dots;
}(_react$2["default"].PureComponent);

var arrows = {};

function _typeof$1(o) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$1(o); }
Object.defineProperty(arrows, "__esModule", {
  value: true
});
arrows.PrevArrow = arrows.NextArrow = void 0;
var _react$1 = _interopRequireDefault$1(React__default);
var _classnames$1 = _interopRequireDefault$1(classnamesExports);
var _innerSliderUtils$1 = innerSliderUtils;
function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$1(obj, key, value) { key = _toPropertyKey$1(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor); } }
function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$1(t) { var i = _toPrimitive$1(t, "string"); return "symbol" == _typeof$1(i) ? i : String(i); }
function _toPrimitive$1(t, r) { if ("object" != _typeof$1(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$1(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }
function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }
function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }
arrows.PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$1(PrevArrow, _React$PureComponent);
  var _super = _createSuper$1(PrevArrow);
  function PrevArrow() {
    _classCallCheck$1(this, PrevArrow);
    return _super.apply(this, arguments);
  }
  _createClass$1(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });
      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }
      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;
      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.prevArrow, _objectSpread$1(_objectSpread$1({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }
      return prevArrow;
    }
  }]);
  return PrevArrow;
}(_react$1["default"].PureComponent);
arrows.NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits$1(NextArrow, _React$PureComponent2);
  var _super2 = _createSuper$1(NextArrow);
  function NextArrow() {
    _classCallCheck$1(this, NextArrow);
    return _super2.apply(this, arguments);
  }
  _createClass$1(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });
      if (!(0, _innerSliderUtils$1.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }
      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;
      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.nextArrow, _objectSpread$1(_objectSpread$1({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$1({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }
      return nextArrow;
    }
  }]);
  return NextArrow;
}(_react$1["default"].PureComponent);

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var ResizeObserver_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: index
});

var require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

Object.defineProperty(innerSlider, "__esModule", {
  value: true
});
innerSlider.InnerSlider = void 0;
var _react = _interopRequireDefault(React__default);
var _initialState = _interopRequireDefault(initialState);
var _lodash = _interopRequireDefault(lodash_debounce);
var _classnames = _interopRequireDefault(classnamesExports);
var _innerSliderUtils = innerSliderUtils;
var _track = track;
var _dots = dots;
var _arrows = arrows;
var _resizeObserverPolyfill = _interopRequireDefault(require$$8);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
innerSlider.InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);
  var _super = _createSuper(InnerSlider);
  function InnerSlider(props) {
    var _this;
    _classCallCheck(this, InnerSlider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      _this.ro.disconnect();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      var setTrackStyle = _this.didPropsChange(prevProps);
      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    });
    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node);
      // prevent warning: setting state on unmounted component (server side rendering)
      if (!isTrackMounted) return;
      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });
    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    });
    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
          _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }
        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }
        return {
          trackStyle: _trackStyle
        };
      }
      var childrenCount = _react["default"].Children.count(_this.props.children);
      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });
    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
        loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function (e) {
            prevClickHandler(e);
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        asNavFor = _this$props.asNavFor,
        beforeChange = _this$props.beforeChange,
        onLazyLoad = _this$props.onLazyLoad,
        speed = _this$props.speed,
        afterChange = _this$props.afterChange; // capture currentslide before state is updated
      var currentSlide = _this.state.currentSlide;
      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
          index: index
        }, _this.props), _this.state), {}, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })),
        state = _slideHandler.state,
        nextState = _slideHandler.nextState;
      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }
      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
            firstBatch = _objectWithoutProperties(nextState, ["animating"]);
          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
      _this.props.autoplay && _this.autoPlay("update");
      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");
        nodes[0] && nodes[0].focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });
    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    });
    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });
    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }
      _this.slideHandler(nextIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({
        autoplaying: "playing"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }
      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;
      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }
      var verticalHeightStyle = null;
      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }
      var centerPaddingStyle = null;
      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }
      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };
      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }
      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });
    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    var ssrState = _this.ssrInit();
    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }
  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;
      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) {
          continue;
        }
        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);
  return InnerSlider;
}(_react["default"].Component);

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

var QueryHandler_1;
var hasRequiredQueryHandler;

function requireQueryHandler () {
	if (hasRequiredQueryHandler) return QueryHandler_1;
	hasRequiredQueryHandler = 1;
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	QueryHandler_1 = QueryHandler;
	return QueryHandler_1;
}

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

var Util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	Util = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};
	return Util;
}

var MediaQuery_1;
var hasRequiredMediaQuery;

function requireMediaQuery () {
	if (hasRequiredMediaQuery) return MediaQuery_1;
	hasRequiredMediaQuery = 1;
	var QueryHandler = requireQueryHandler();
	var each = requireUtil().each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	MediaQuery_1 = MediaQuery;
	return MediaQuery_1;
}

var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;

function requireMediaQueryDispatch () {
	if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
	hasRequiredMediaQueryDispatch = 1;
	var MediaQuery = requireMediaQuery();
	var Util = requireUtil();
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	MediaQueryDispatch_1 = MediaQueryDispatch;
	return MediaQueryDispatch_1;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	var MediaQueryDispatch = requireMediaQueryDispatch();
	src = new MediaQueryDispatch();
	return src;
}

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(React__default);
	var _innerSlider = innerSlider;
	var _json2mq = _interopRequireDefault(json2mq_1);
	var _defaultProps = _interopRequireDefault(defaultProps);
	var _innerSliderUtils = innerSliderUtils;
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();
	exports["default"] = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	  var _super = _createSuper(Slider);
	  function Slider(props) {
	    var _this;
	    _classCallCheck(this, Slider);
	    _this = _super.call(this, props);
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        });
	        // sort them in increasing order of their numerical value
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          }
	          // when not using server side rendering
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        });

	        // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	      var settings;
	      var newProps;
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      }

	      // force scrolling by one if centerMode is on
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	        settings.slidesToScroll = 1;
	      }
	      // force showing one slide and scrolling by one if the fade mode is on
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      }

	      // makes sure that children is an array, even when there is only 1 child
	      var children = _react["default"].Children.toArray(this.props.children);

	      // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	        return !!child;
	      });

	      // rows and slidesPerRow logic is handled here
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	      var newChildren = [];
	      var currentWidth = null;
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) {
	        settings.unslick = true;
	      }
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, (0, _innerSliderUtils.filterSettings)(settings)), newChildren);
	    }
	  }]);
	  return Slider;
	}(_react["default"].Component); 
} (slider));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _slider = _interopRequireDefault(slider);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	exports["default"] = _slider["default"]; 
} (lib));

var SlickSlider = /*@__PURE__*/getDefaultExportFromCjs(lib);

var SliderStyle = styled.div `
  .slick-prev:before,
  .slick-next:before {
    display: none !important;
  }

  .slick-dots {
    bottom: ${asRem(-30)};
  }

  .slick-dots li {
    margin-left: 0;
    margin-right: 0;
  }

  .slick-dots li button:before {
    color: ${colors.grey.c800};
    width: ${asRem(12)};
    height: ${asRem(12)};
    font-size: ${asRem(12)};
  }

  .slick-dots li.slick-active button:before {
    color: ${({ theme }) => theme.colors.slider.dotsActive};
    opacity: 1;
  }
  .slick-dots li button:hover:before {
    color: ${({ theme }) => theme.colors.slider.dotsHover};
    opacity: 1;
  }

  &.blue-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.blue.c500};
    }
    .slick-dots li button:hover:before {
      color: ${colors.blue.c800};
    }
  }

  &.green-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.green.c500};
    }
    .slick-dots li button:hover:before {
      color: ${colors.green.c800};
    }
  }

  &.pink-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.pink.c500};
    }
    .slick-dots li button:hover:before {
      color: ${colors.pink.c800};
    }
  }

  &.yellow-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.yellow.c500};
    }
    .slick-dots li button:hover:before {
      color: ${colors.yellow.c800};
    }
  }

  &.purple-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.purple.c800};
    }
    .slick-dots li button:hover:before {
      color: ${colors.purple.c800};
    }
  }
`;

var SliderSleepStyle = styled.div `
  .slick-prev:before,
  .slick-next:before {
    display: none !important;
  }

  .slick-dots {
    bottom: ${asRem(-30)};
  }

  .slick-dots li {
    margin-left: 0;
    margin-right: 0;
  }

  .slick-dots li button:before {
    color: ${colors.sleep.blue.c700};
    width: ${asRem(12)};
    height: ${asRem(12)};
    font-size: ${asRem(12)};
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    color: ${({ theme }) => theme.colors.slider.dotsActive} !important;
    opacity: 1;
  }
  .slick-dots li button:hover:before {
    color: ${({ theme }) => theme.colors.slider.dotsHover} !important;
    opacity: 1;
  }

  &.blue-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.sleep.blue.c400} !important;
    }
    .slick-dots li button:hover:before {
      color: {colors.sleep.blue.c200} !important;
    }
  }

  &.beige-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.sleep.beige.c100};
    }
    .slick-dots li button:hover:before {
      color: {colors.sleep.beige.c400}!important;
    }
  }

  &.red-dots {
    .slick-dots li.slick-active button:before {
      color: ${colors.sleep.red.c500} !important;
    }
    .slick-dots li button:hover:before {
      color: ${colors.sleep.red.c300} !important;
    }
  }

`;

const CustomArrowStyle = styled.div `
  cursor: pointer;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${asRem(10)};

  &.mime-elements-arrow.next {
    transform: scaleX(1);
    right: ${asRem(-35)};
  }

  &.mime-elements-arrow.prev {
    transform: scaleX(-1);
    left: ${asRem(-35)};
  }
`;

const CustomArrow = ({ direction, className, onClick, color, hoverColor }) => {
    const isSleep = useIsTheme(themeSleep);
    const defaultColor = isSleep ? colors.sleep.beige.c100 : colors.blueGrey.c500;
    const defaultHoverColor = isSleep ? colors.sleep.beige.c300 : colors.green.c500;
    const chevronSize = isSleep ? 80 : 40;
    return (jsx(CustomArrowStyle, { className: `mime-elements-arrow ${direction} ${className}`, onClick: onClick, children: jsx(Icon, { name: "Chevron", size: chevronSize, color: color || defaultColor, hoverColor: hoverColor || defaultHoverColor }) }));
};

const Slider = ({ settings, children, style, className, dataCyName }) => {
    const ThemedSlider = useIsTheme(themeSleep) ? SliderSleepStyle : SliderStyle;
    const { arrows, ...otherSettings } = settings || {};
    const prevArrow = arrows ? jsx(CustomArrow, { direction: "prev" }) : undefined;
    const nextArrow = arrows ? jsx(CustomArrow, { direction: "next" }) : undefined;
    return (jsx(ThemedSlider, { style: style, className: ['mime-elements-slider', className].filter(Boolean).join(' '), "data-cy-name": dataCyName, children: jsx(SlickSlider, { ...otherSettings, prevArrow: prevArrow, nextArrow: nextArrow, children: children }) }));
};

const mapBasicNeutralColorToShade = (color, theme) => {
    switch (color) {
        case 'lightGrey':
            return theme.colors.grey.c100;
        case 'white':
        default:
            return theme.colors.white.c500;
    }
};

var StyledSection = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  z-index: 3;

  background-color: ${({ theme, $backgroundColor }) => $backgroundColor
    ? $backgroundColor === 'white' || $backgroundColor === 'lightGrey'
        ? mapBasicNeutralColorToShade($backgroundColor, theme)
        : theme.colors[$backgroundColor].c500
    : theme.colors.section.background};

  color: ${({ theme, $backgroundColor }) => $backgroundColor
    ? $backgroundColor === 'white' || $backgroundColor === 'lightGrey'
        ? theme.colors.blueGrey.c500
        : theme.colors.white.c500
    : theme.colors.white.c500};

  padding-top: ${({ $verticalPadding }) => asRem($verticalPadding.sm)};
  padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding.sm)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: ${({ $verticalPadding }) => asRem($verticalPadding?.md)};
    padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding?.md)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-top: ${({ $verticalPadding }) => asRem($verticalPadding?.lg)};
    padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding?.lg)};
  }

  .container-fluid {
    padding-left: 0;
    padding-right: 0;
    position: relative;
    z-index: 1;
  }
`;

var StyledSectionSleep = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  z-index: 3;
  color: ${({ theme }) => theme.colors.sleep.beige.c100};

  background-color: ${({ theme, $backgroundColor }) => $backgroundColor ? theme.colors.sleep.blue[$backgroundColor] : theme.colors.section.background};

  padding-top: ${({ $verticalPadding }) => asRem($verticalPadding.sm)};
  padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding.sm)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: ${({ $verticalPadding }) => asRem($verticalPadding?.md)};
    padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding?.md)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-top: ${({ $verticalPadding }) => asRem($verticalPadding?.lg)};
    padding-bottom: ${({ $verticalPadding }) => asRem($verticalPadding?.lg)};
  }

  .container-fluid {
    padding-left: 0;
    padding-right: 0;
    position: relative;
    z-index: 1;
  }
`;

const Section = ({ children, verticalPadding, className = '', backgroundColor, type = 'default', id, dataCyName, }) => {
    const isSleep = useIsTheme(themeSleep);
    let verticalPaddingSizes = { sm: 56, md: 80, lg: 96 };
    switch (true) {
        case verticalPadding === 'none':
            verticalPaddingSizes = { sm: 0, md: 0, lg: 0 };
            break;
        case verticalPadding === 'small':
            verticalPaddingSizes = { sm: 32, md: 24, lg: 24 };
            break;
        case verticalPadding === 'medium':
            verticalPaddingSizes = { sm: 56, md: 80, lg: 96 };
            break;
        case typeof verticalPadding === 'object':
            if (verticalPadding !== null && typeof verticalPadding === 'object') {
                verticalPaddingSizes = { ...verticalPaddingSizes, ...verticalPadding };
            }
            break;
    }
    const styledProps = {
        $backgroundColor: backgroundColor,
        $verticalPadding: verticalPaddingSizes,
        children,
        className,
        type,
        id,
    };
    return isSleep ? (jsx(StyledSectionSleep, { ...styledProps, className: ['mime-elements-section', className].filter((c) => !!c).join(' '), "data-cy-name": dataCyName, children: jsx(Container, { fluid: type === 'full-width', children: children }) })) : (jsx(StyledSection, { ...styledProps, className: ['mime-elements-section', className].filter((c) => !!c).join(' '), "data-cy-name": dataCyName, children: jsx(Container, { fluid: type === 'full-width', children: children }) }));
};

const mergeTheme = (themeUniversal, overrideTheme) => {
    const newTheme = { ...themeUniversal };
    if (overrideTheme) {
        for (const key in overrideTheme) {
            const value = overrideTheme[key];
            if (typeof value === 'object') {
                newTheme[key] = mergeTheme(themeUniversal[key], value);
            }
            else {
                newTheme[key] = value;
            }
        }
    }
    return newTheme;
};
const ThemeProvider = ({ children, theme }) => {
    return jsx(ThemeProvider$1, { theme: mergeTheme(themeUniversal, theme || {}), children: children });
};
const useTheme = useTheme$1;

const ThemeContainer = ({ children, theme }) => {
    return jsx(ThemeProvider, { theme: theme, children: children });
};

export { Accordion, AccordionItem, BackgroundImage, Badge, BottomLine, Button$2 as Button, Card, CardContainer, Carousel, CarouselItem, CheckmarkIcon, ChevronIcon, CloseIcon, Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Element$1 as Element, Form, Headline, HeadlineContainer, Icon, Image, Input$1 as Input, Link$2 as Link, List, LogoChain, Menu, MenuLink, Modal, NavItem, NavLink, NavbarBrand, Paragraph, PlayIcon, PlusIcon, RoundedBox, Row, ScrollButton, ScrollLink, ScrollableRow, Section, SelectBox, Slider, Span, StyledCarouselIndicators, Tabs, TextBlockImg, ThemeContainer, ThemeProvider, Toggle, Typeahead, UncontrolledDropdown, asRem, breakpoints, colors, spacing, themeCalm, themeFeeling, themePodcast, themeSleep, themeUniversal, themeWork, useTheme };
